"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  ADDITIONAL_INCOME_SOURCE_OPTIONS: () => ADDITIONAL_INCOME_SOURCE_OPTIONS,
  AboutUsReferral: () => AboutUsReferral,
  CAREER_CHANGE_OPTIONS: () => CAREER_CHANGE_OPTIONS,
  CONSIDER_PART_TIME_RETIREMENT_OPTIONS: () => CONSIDER_PART_TIME_RETIREMENT_OPTIONS,
  DisabilityInsuranceWizard: () => DisabilityInsuranceWizard_default,
  EMPLOYMENT_TYPE: () => EMPLOYMENT_TYPE,
  EMPLOYMENT_TYPE_OPTIONS: () => EMPLOYMENT_TYPE_OPTIONS,
  ESTATE_PLANNING_OPTIONS: () => ESTATE_PLANNING_OPTIONS,
  GOALS_OPTIONS: () => GOALS_OPTIONS,
  IMPORTANT_RELATIONSHIPS_PERSON_RELATIONSHIP_OPTIONS: () => IMPORTANT_RELATIONSHIPS_PERSON_RELATIONSHIP_OPTIONS,
  IMPORTANT_RELATIONSHIP_BASE_DEPENDENT_STATUS_OPTIONS: () => IMPORTANT_RELATIONSHIP_BASE_DEPENDENT_STATUS_OPTIONS,
  IMPORTANT_RELATIONSHIP_ORGANIZATION_TYPE_OPTIONS: () => IMPORTANT_RELATIONSHIP_ORGANIZATION_TYPE_OPTIONS,
  INSURANCE_POLICIES_OPTIONS: () => INSURANCE_POLICIES_OPTIONS,
  INTERESTS_OPTIONS: () => INTERESTS_OPTIONS,
  JMMG_ACCESS_CODE: () => JMMG_ACCESS_CODE,
  MGPWizard: () => MGPWizard_default,
  ProfileWizard: () => ProfileWizard_default,
  Radio: () => Radio_default,
  RadioGroup: () => RadioGroup_default,
  RiskToleranceWizard: () => RiskToleranceWizard_default,
  SIGNUP_FORM_SCHEMA: () => SIGNUP_FORM_SCHEMA,
  SIGNUP_TERMS_HEADER: () => SIGNUP_TERMS_HEADER,
  SignupFieldKeys: () => SignupFieldKeys,
  SignupWizard: () => SignupWizard_default,
  TermLifeInsuranceWizard: () => TermLifeInsuranceWizard_default,
  UMP_ACCESS_CODE: () => UMP_ACCESS_CODE,
  WILLING_TO_RETIRE_LATER_OPTIONS: () => WILLING_TO_RETIRE_LATER_OPTIONS,
  getPortfolioTypeFromRiskScore: () => getPortfolioTypeFromRiskScore,
  getReviewListValue: () => getReviewListValue
});
module.exports = __toCommonJS(src_exports);

// src/common/components/Radio/Radio.tsx
var React = __toESM(require("react"));
var import_CheckIcon = __toESM(require("@heroicons/react/outline/CheckIcon"));
var import_jsx_runtime = require("react/jsx-runtime");
var Radio = React.forwardRef(
  ({ value, label, name, onChange }, ref) => {
    const textLabel = label ?? value;
    const inputId = `${name}-${textLabel}-${value}`;
    return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("span", { className: "RadioBar-root", "data-testid": "radio", children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "input",
        {
          ref,
          className: "RadioBar-input",
          id: inputId,
          type: "radio",
          value,
          name,
          onChange
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("label", { className: "RadioBar-label", htmlFor: inputId, children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: "RadioBar-text", children: textLabel }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: "RadioBar-icon", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_CheckIcon.default, { width: 24, height: 24, className: "text-primary" }) })
      ] })
    ] });
  }
);
var Radio_default = Radio;

// src/common/components/RadioGroup/RadioGroup.tsx
var React2 = __toESM(require("react"));
var import_jsx_runtime2 = require("react/jsx-runtime");
var RadioGroup = React2.forwardRef(
  ({ children, name, onChange }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
      "fieldset",
      {
        className: "RadioBarGroup-root",
        "data-testid": "radio-group",
        name,
        children: React2.Children.map(
          children,
          (child) => {
            if (React2.isValidElement(child)) {
              return React2.cloneElement(child, {
                name,
                onChange,
                ref
              });
            }
            return child;
          }
        )
      }
    );
  }
);
var RadioGroup_default = RadioGroup;

// src/common/components/Footer/Footer.tsx
var import_core = require("@earned/core");
var React3 = __toESM(require("react"));
var import_jsx_runtime3 = require("react/jsx-runtime");
var Footer = ({
  showPrevious = false,
  previousLabel = "Back",
  nextLabel = "Next",
  onPreviousClick,
  onNextClick,
  submitMode = false,
  nextDisabled = false,
  submitting = false,
  showReturnToReview = false,
  onReturnToReviewClick
}) => {
  const handleNextClick = React3.useCallback(
    (e) => {
      if (!submitMode)
        e.preventDefault();
      onNextClick();
    },
    [submitMode, onNextClick]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { "data-testid": "footer", className: "Footer", children: /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { className: "flex flex-col gap-3 sm:flex-row sm:gap-4", children: [
    showPrevious && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      import_core.Button,
      {
        type: "button",
        fullWidth: true,
        variant: "secondary",
        onClick: onPreviousClick,
        children: previousLabel
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      import_core.Button,
      {
        type: submitMode ? "submit" : "button",
        disabled: nextDisabled,
        fullWidth: true,
        variant: "primary",
        onClick: handleNextClick,
        children: submitting ? "Submitting..." : nextLabel
      }
    ) }),
    showReturnToReview && onReturnToReviewClick && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      "button",
      {
        type: "button",
        className: "self-center text-link",
        onClick: onReturnToReviewClick,
        children: "Return to Review"
      }
    )
  ] }) });
};
var Footer_default = Footer;

// src/common/components/Modal/Modal.tsx
var import_core3 = require("@earned/core");
var import_react_dom = __toESM(require("react-dom"));

// src/common/components/CloseButton/CloseButton.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var CloseButton = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("button", { ...props, "data-testid": "close-button", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("g", { id: "X", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("path", { id: "Icon", d: "M6 18L18 6M6 6L18 18", stroke: "#04260E", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }) }) });
};
var CloseButton_default = CloseButton;

// src/common/components/ProgressBar/ProgressBar.tsx
var import_core2 = require("@earned/core");
var import_jsx_runtime5 = require("react/jsx-runtime");
var ProgressBar = ({ percentage = 0 }) => {
  if (percentage > 1 || percentage < 0)
    throw Error(
      `Invalid percentage '${percentage}', value must be between 0 and 1`
    );
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { "data-testid": "progress-bar", className: "ProgressBar", children: [
    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "ProgressBarBackdrop", children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
      "div",
      {
        className: "ProgressBarSlider",
        style: { width: `${percentage * 100}%` }
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
      import_core2.Typography,
      {
        className: "ProgressBarText",
        variant: "body",
        weight: "medium",
        color: "inherit",
        children: `${Math.round(percentage * 100)}%`
      }
    )
  ] });
};
var ProgressBar_default = ProgressBar;

// src/common/components/Modal/Modal.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime6 = require("react/jsx-runtime");
var Modal = ({
  children,
  open,
  title,
  titleTag,
  pageTitle,
  titleIcon,
  subtitle,
  close,
  progressPercentage,
  showConfirmation = false,
  showProgressBar = true,
  showCloseIcon = true,
  rootSelector = "body",
  renderConfirmation,
  taxLayout = false
}) => {
  if (showConfirmation && !renderConfirmation)
    throw Error(
      `Invalid prop: method 'renderConfirmation()' must be provided if showConfirmation is true`
    );
  return import_react_dom.default.createPortal(
    /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { "data-testid": "modal", className: "Modal", "aria-modal": true, children: open && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: "ModalContainer", children: showConfirmation ? renderConfirmation ? renderConfirmation() : null : /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("div", { className: "ModalPanel", children: [
      /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
        "div",
        {
          className: `${taxLayout ? "ModalTaxHeader" : "ModalHeader"}`,
          children: /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
            "div",
            {
              className: (0, import_classnames.default)("ModalTop", {
                ModalTopWithTitle: pageTitle || titleTag
              }),
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("div", { className: "ModalTitle", children: [
                  showCloseIcon && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: "ModalTitleCloseButton", children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(CloseButton_default, { onClick: close }) }),
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("div", { className: "ModalTitleLogoContainer", children: [
                    titleIcon,
                    /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
                      import_core3.Typography,
                      {
                        color: taxLayout ? "secondary" : void 0,
                        variant: "body-lg",
                        weight: "medium",
                        children: title
                      }
                    )
                  ] })
                ] }),
                showProgressBar && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: `${taxLayout ? "" : "ModalProgressBar"}`, children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(ProgressBar_default, { percentage: progressPercentage }) }),
                pageTitle || titleTag ? /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("div", { className: "ModalPageTitle", children: [
                  pageTitle && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
                    import_core3.Typography,
                    {
                      variant: "title-md",
                      weight: "medium",
                      color: "black",
                      children: pageTitle
                    }
                  ),
                  titleTag && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
                    import_core3.Typography,
                    {
                      variant: "body-xl",
                      weight: "medium",
                      color: "secondary",
                      children: titleTag
                    }
                  )
                ] }) : null
              ]
            }
          )
        }
      ),
      subtitle && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: "ModalSubtitle", children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_core3.Typography, { variant: "body", color: "black", children: subtitle }) }),
      /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: "ModalBody", children })
    ] }) }) }),
    document.querySelector(rootSelector)
  );
};
var Modal_default = Modal;

// src/common/components/Question/Question.tsx
var import_core4 = require("@earned/core");
var import_jsx_runtime7 = require("react/jsx-runtime");
var Question = ({ label }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { "data-testid": "question", className: "Question", children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(import_core4.Typography, { variant: "body", color: "primary", children: label }) });
};
var Question_default = Question;

// src/common/components/QuestionBlock/QuestionBlock.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_jsx_runtime8 = require("react/jsx-runtime");
var QuestionBlock = ({
  label,
  children,
  applyIndent = false,
  applyPadding = true
}) => {
  const className = (0, import_classnames2.default)("QuestionBlock", {
    "QuestionBlock--indented": applyIndent,
    "QuestionBlock--padded": applyPadding
  });
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { "data-testid": "question-block", className, children: [
    label && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Question_default, { label }),
    /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { children })
  ] });
};
var QuestionBlock_default = QuestionBlock;

// src/common/components/ReviewBlock/ReviewBlock.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
var ReviewBlock = ({ children }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { "data-testid": "review-block", className: "ReviewBlock", children });
};
var ReviewBlock_default = ReviewBlock;

// src/common/components/ReviewEditLink/ReviewEditLink.tsx
var import_jsx_runtime10 = require("react/jsx-runtime");
var ReviewEditLink = ({ onClick }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: "ReviewEditLink", children: [
    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { className: "ReviewEditLinkSpacer" }),
    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { className: "ReviewEditLinkButton", children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("button", { "data-testid": "review-edit-link", onClick, children: "Edit" }) })
  ] });
};
var ReviewEditLink_default = ReviewEditLink;

// src/common/components/ReviewList/ReviewList.tsx
var import_core5 = require("@earned/core");
var import_jsx_runtime11 = require("react/jsx-runtime");
var ReviewList = ({ label, value }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { "data-testid": "review-list", className: "ReviewList", children: [
    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "ReviewListLabel", children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_core5.Typography, { variant: "body", color: "primary", children: label }) }),
    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "ReviewListValue", children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_core5.Typography, { variant: "body", color: "primary", children: value }) })
  ] });
};
var ReviewList_default = ReviewList;

// src/common/components/SuccessIcon/SuccessIcon.tsx
var import_jsx_runtime12 = require("react/jsx-runtime");
var SuccessIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("svg", { "data-testid": "success-icon", width: "120", height: "120", viewBox: "0 0 120 120", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("g", { id: "Group 47639", children: [
    /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("circle", { id: "Ellipse 181", cx: "60", cy: "60", r: "60", fill: "#AEDBB7" }),
    /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("circle", { id: "Ellipse 180", cx: "59.9997", cy: "60", r: "47.7966", fill: "#49A55E" }),
    /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("path", { id: "Vector 188 (Stroke)", fillRule: "evenodd", clipRule: "evenodd", d: "M88.4606 39.1685C90.9793 41.4073 91.2062 45.264 88.9674 47.7827L56.425 84.3929C54.192 86.905 50.3478 87.1382 47.8275 84.9144L30.5394 69.6602C28.0125 67.4306 27.7715 63.5747 30.0011 61.0479C32.2307 58.521 36.0865 58.28 38.6134 60.5096L51.343 71.7416L79.8464 39.6752C82.0852 37.1565 85.942 36.9297 88.4606 39.1685Z", fill: "white" })
  ] }) });
};
var SuccessIcon_default = SuccessIcon;

// src/common/components/SuccessPanel/SuccessPanel.tsx
var import_core6 = require("@earned/core");
var import_jsx_runtime13 = require("react/jsx-runtime");
var SuccessPanel = ({ onDone }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("div", { "data-testid": "success-panel", className: "SuccessPanel", children: [
    /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(SuccessIcon_default, {}),
    /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(import_core6.Typography, { variant: "title-xl", weight: "medium", children: "Success" }),
    /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(import_core6.Button, { variant: "primary", size: "lg", onClick: onDone, children: "Done" }) })
  ] });
};
var SuccessPanel_default = SuccessPanel;

// src/common/hooks.ts
var import_react = __toESM(require("react"));
var useWizardControls = ({ pages, defaultPage = 0 }) => {
  const [currentPage, setCurrentPage] = import_react.default.useState(defaultPage);
  const goBack = import_react.default.useCallback(() => {
    const pending = currentPage - 1;
    if (pending < 0)
      return;
    setCurrentPage(pending);
  }, [currentPage]);
  const goNext = import_react.default.useCallback(() => {
    const pending = currentPage + 1;
    if (pending >= pages)
      return;
    setCurrentPage(pending);
  }, [currentPage, pages]);
  const goToLast = import_react.default.useCallback(() => {
    setCurrentPage(pages - 1);
  }, [pages, setCurrentPage]);
  const goToFirst = import_react.default.useCallback(() => {
    setCurrentPage(0);
  }, [setCurrentPage]);
  const goTo = import_react.default.useCallback(
    (page) => {
      if (page < 0 || page > pages - 1)
        throw Error(
          `Invalid Page Selection '${page}': 'page' must be between 0 and ${pages - 1}`
        );
      setCurrentPage(page);
    },
    [pages, setCurrentPage]
  );
  const reset = import_react.default.useCallback(() => {
    setCurrentPage(defaultPage);
  }, [currentPage, defaultPage]);
  const isFirst = import_react.default.useMemo(() => currentPage === 0, [currentPage]);
  const isLast = import_react.default.useMemo(
    () => currentPage === pages - 1,
    [currentPage, pages]
  );
  const progress = import_react.default.useMemo(() => {
    return currentPage === 0 ? 0.1 : currentPage / (pages - 1);
  }, [currentPage, pages]);
  return {
    currentPage,
    setCurrentPage,
    reset,
    goBack,
    goNext,
    goToLast,
    goToFirst,
    goTo,
    isFirst,
    isLast,
    progress
  };
};

// src/modules/disability-insurance/components/DisabilityInsuranceWizard/DisabilityInsuranceWizard.tsx
var import_core9 = require("@earned/core");

// src/common/yup-extend.ts
var import_core7 = require("@earned/core");
var yup = __toESM(require("yup"));
yup.addMethod(yup.string, "currency", function() {
  return this.transform((value) => (0, import_core7.formatCurrency)(value));
});
yup.addMethod(yup.number, "fromCurrency", function() {
  return this.transform(
    (_6, originalValue) => originalValue ? parseFloat(originalValue.replace(/[^\d.]/g, "")) : void 0
  );
});
var yup_extend_default = yup;

// src/common/helpers.tsx
var import_moment = __toESM(require("moment"));

// src/common/types.ts
var AboutUsReferral = {
  POF: "PHYSICIAN_ON_FIRE",
  OTHER: "OTHER",
  UMP: "UMP",
  JMMG: "JMMG",
  ECMA: "ECMA",
  SJMG: "SJMG"
};

// src/common/helpers.tsx
var transformers = {
  form: {
    ssn: (ssn) => {
      const cleanSSN = ssn ? ssn.replace(/-/g, "") : "";
      return cleanSSN ? cleanSSN.slice(0, 3) + "-" + cleanSSN.slice(3, 5) + "-" + cleanSSN.slice(5) : void 0;
    },
    date: (dateStr) => {
      return dateStr ? (0, import_moment.default)(
        dateStr,
        /\d+\/\d+\/\d+/.test(dateStr) ? "MM/DD/YYYY" : void 0
      ).format("MM/DD/YYYY") : void 0;
    },
    /**
     * Used for formatting phone numbers
     * @param digits - string of digits
     * Might come from cache as "+1xxxxxxxxxx" or from phone input mask as "(xxx) xxx xxxx"
     * @returns formatted phone number with mask (999) 999 9999
     */
    phone: (digits) => {
      if (!digits)
        return void 0;
      const cleanDigits = digits.replace(/\D/g, "");
      const numbers = cleanDigits.length > 10 && cleanDigits.startsWith("1") ? cleanDigits.substring(1) : cleanDigits;
      if (numbers.length < 10)
        return digits;
      return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)} ${numbers.slice(
        6
      )}`;
    }
  },
  payload: {
    ssn: (ssn) => ssn ? ssn.replace(/-/g, "") : void 0,
    date: (dateString, format) => dateString ? (0, import_moment.default)(
      dateString,
      format ?? /\d+\/\d+\/\d+/.test(dateString) ? "MM/DD/YYYY" : void 0
    ).format("YYYY-MM-DD") : void 0,
    phone: (digits) => digits ? "+1" + digits.replace(/[\(\)\s]/g, "") : void 0
  }
};
var validators = {
  ssn: (v) => !!v && v.length === 11 && !/_/.test(v),
  date: (v) => !!v && (0, import_moment.default)(v, "MM/DD/YYYY").isValid(),
  phone: (v) => !!v && /\((\d{3})\)\s(\d{3})\s(\d{4})/.test(v)
};
var formatters = {
  employmentStatus: (v) => {
    switch (v) {
      case "EMPLOYED" /* EMPLOYED */:
        return "Employed";
      case "NOT_EMPLOYED" /* NOT_EMPLOYED */:
        return "Not Employed";
      case "RETIRED" /* RETIRED */:
        return "Retired";
      default:
        return "--";
    }
  },
  careerStage: (v) => {
    switch (v) {
      case "MEDICAL_STUDENT" /* MEDICAL_STUDENT */:
        return "Medical Student";
      case "RESIDENT" /* RESIDENT */:
        return "Resident";
      case "PRACTICING_PHYSICIAN" /* PRACTICING_PHYSICIAN */:
        return "Practicing Doctor";
      case "RETIRED_PHYSICIAN" /* RETIRED_PHYSICIAN */:
        return "Retired Doctor";
      default:
        return "--";
    }
  },
  string: (v) => v ? v : "--",
  currency: (v) => v === void 0 || !v.trim() ? "--" : parseFloat(v.replace(/[^\d.]/g, "")).toLocaleString("en-us", {
    currency: "USD",
    style: "currency",
    maximumFractionDigits: 0
  })
};
var renderFullName = ({
  first,
  last: last2,
  placeholder = ""
}) => {
  return [first, last2].join(" ").trim() || placeholder;
};
var isFullAddress = (...addressFields) => addressFields.every((v) => !!v);
var getReviewListValue = (list, defaultValue) => {
  var _a;
  return ((_a = list.find((item) => item.value === defaultValue)) == null ? void 0 : _a.label) || defaultValue;
};

// src/modules/disability-insurance/constants.ts
var PAGE_COUNT = 3;
var DISABILITY_INSURANCE_FORM_SCHEMA = yup_extend_default.object({
  ["FIRST_NAME" /* FIRST_NAME */]: yup_extend_default.string(),
  ["LAST_NAME" /* LAST_NAME */]: yup_extend_default.string(),
  ["DOB" /* DOB */]: yup_extend_default.string().transform(transformers.form.date).test("dob", "Invalid date of birth", validators.date),
  ["ADDRESS_STATE" /* ADDRESS_STATE */]: yup_extend_default.string(),
  ["SPECIALTY" /* SPECIALTY */]: yup_extend_default.string(),
  ["GENDER" /* GENDER */]: yup_extend_default.mixed().oneOf(["male", "female", "other"]).required("Gender is required"),
  ["TOBACCO_USE" /* TOBACCO_USE */]: yup_extend_default.string().required("This field is required").nullable().min(1, "This field is required"),
  ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.string().currency().required("Annual income is required"),
  ["YEARS_PRACTICE" /* YEARS_PRACTICE */]: yup_extend_default.string().required("Years practicing is required"),
  ["BORN_IN_THE_USA" /* BORN_IN_THE_USA */]: yup_extend_default.boolean().default(true),
  ["BIRTH_STATE" /* BIRTH_STATE */]: yup_extend_default.string().when("BORN_IN_THE_USA" /* BORN_IN_THE_USA */, {
    is: true,
    then: yup_extend_default.string().required("State of birth is required"),
    otherwise: yup_extend_default.string()
  }),
  ["PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */]: yup_extend_default.string().when("BORN_IN_THE_USA" /* BORN_IN_THE_USA */, {
    is: false,
    then: yup_extend_default.string().required("Place of birth is required"),
    otherwise: yup_extend_default.string()
  })
});
var DISABILITY_INSURANCE_PAYLOAD_SCHEMA = yup_extend_default.object({
  ["FIRST_NAME" /* FIRST_NAME */]: yup_extend_default.string(),
  ["LAST_NAME" /* LAST_NAME */]: yup_extend_default.string(),
  ["DOB" /* DOB */]: yup_extend_default.string().transform((value) => transformers.payload.date(value)),
  ["ADDRESS_STATE" /* ADDRESS_STATE */]: yup_extend_default.string(),
  ["SPECIALTY" /* SPECIALTY */]: yup_extend_default.string(),
  ["GENDER" /* GENDER */]: yup_extend_default.mixed().oneOf(["male", "female", "other"]),
  ["TOBACCO_USE" /* TOBACCO_USE */]: yup_extend_default.boolean(),
  ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.number().fromCurrency(),
  ["YEARS_PRACTICE" /* YEARS_PRACTICE */]: yup_extend_default.number(),
  ["BIRTH_STATE" /* BIRTH_STATE */]: yup_extend_default.string(),
  ["PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */]: yup_extend_default.string()
});
var VALIDATION_MAP = {
  [0]: ["DOB" /* DOB */, "GENDER" /* GENDER */, "TOBACCO_USE" /* TOBACCO_USE */],
  [1]: [
    "ANNUAL_INCOME" /* ANNUAL_INCOME */,
    "YEARS_PRACTICE" /* YEARS_PRACTICE */,
    "BIRTH_STATE" /* BIRTH_STATE */,
    "PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */
  ],
  [2]: []
};

// src/modules/disability-insurance/components/DisabilityInsuranceWizard/DisabilityInsuranceWizard.tsx
var React5 = __toESM(require("react"));
var import_react_hook_form = require("react-hook-form");
var import_lodash = __toESM(require("lodash"));

// src/common/components/LoadingIndicator/LoadingIndicator.tsx
var import_jsx_runtime14 = require("react/jsx-runtime");
var LoadingIndicator = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)(
    "svg",
    {
      "data-testid": "wizard-loading-indicator",
      className: "animate-spin text-primary",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
          "path",
          {
            opacity: "0.2",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
          "path",
          {
            d: "M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
};
var LoadingIndicator_default = LoadingIndicator;

// src/modules/disability-insurance/components/DisabilityInsuranceWizard/DisabilityInsuranceWizard.tsx
var import_moment2 = __toESM(require("moment"));
var import_yup = require("@hookform/resolvers/yup");

// src/common/constants.ts
var import_core8 = require("@earned/core");
var US_STATE_OPTIONS = [
  { id: "AK", label: "Alaska", value: "AK" },
  { id: "AL", label: "Alabama", value: "AL" },
  { id: "AR", label: "Arkansas", value: "AR" },
  { id: "AZ", label: "Arizona", value: "AZ" },
  { id: "CA", label: "California", value: "CA" },
  { id: "CO", label: "Colorado", value: "CO" },
  { id: "CT", label: "Connecticut", value: "CT" },
  { id: "DE", label: "Delaware", value: "DE" },
  { id: "FL", label: "Florida", value: "FL" },
  { id: "GA", label: "Georgia", value: "GA" },
  { id: "HI", label: "Hawaii", value: "HI" },
  { id: "IA", label: "Iowa", value: "IA" },
  { id: "ID", label: "Idaho", value: "ID" },
  { id: "IL", label: "Illinois", value: "IL" },
  { id: "IN", label: "Indiana", value: "IN" },
  { id: "KS", label: "Kansas", value: "KS" },
  { id: "KY", label: "Kentucky", value: "KY" },
  { id: "LA", label: "Louisiana", value: "LA" },
  { id: "MA", label: "Massachusetts", value: "MA" },
  { id: "MD", label: "Maryland", value: "MD" },
  { id: "ME", label: "Maine", value: "ME" },
  { id: "MI", label: "Michigan", value: "MI" },
  { id: "MN", label: "Minnesota", value: "MN" },
  { id: "MO", label: "Missouri", value: "MO" },
  { id: "MS", label: "Mississippi", value: "MS" },
  { id: "MT", label: "Montana", value: "MT" },
  { id: "NC", label: "North Carolina", value: "NC" },
  { id: "ND", label: "North Dakota", value: "ND" },
  { id: "NE", label: "Nebraska", value: "NE" },
  { id: "NH", label: "New Hampshire", value: "NH" },
  { id: "NJ", label: "New Jersey", value: "NJ" },
  { id: "NM", label: "New Mexico", value: "NM" },
  { id: "NV", label: "Nevada", value: "NV" },
  { id: "NY", label: "New York", value: "NY" },
  { id: "OH", label: "Ohio", value: "OH" },
  { id: "OK", label: "Oklahoma", value: "OK" },
  { id: "OR", label: "Oregon", value: "OR" },
  { id: "PA", label: "Pennsylvania", value: "PA" },
  { id: "RI", label: "Rhode Island", value: "RI" },
  { id: "SC", label: "South Carolina", value: "SC" },
  { id: "SD", label: "South Dakota", value: "SD" },
  { id: "TN", label: "Tennessee", value: "TN" },
  { id: "TX", label: "Texas", value: "TX" },
  { id: "UT", label: "Utah", value: "UT" },
  { id: "VA", label: "Virginia", value: "VA" },
  { id: "VT", label: "Vermont", value: "VT" },
  { id: "WA", label: "Washington", value: "WA" },
  { id: "WI", label: "Wisconsin", value: "WI" },
  { id: "WV", label: "West Virginia", value: "WV" },
  { id: "WY", label: "Wyoming", value: "WY" }
];
var NO_SELECTION_OPTION = {
  id: import_core8.DEFAULT_NO_SELECTION_ID,
  label: "Select an option",
  value: void 0
};
var US_STATE_OPTIONS_OPTIONAL = [NO_SELECTION_OPTION, ...US_STATE_OPTIONS];
var SPECIALTY_OPTIONS = [
  {
    id: "allergy_and_immunology",
    label: "Allergy and Immunology",
    value: "Allergy and Immunology"
  },
  { id: "anesthesiology", label: "Anesthesiology", value: "Anesthesiology" },
  {
    id: "colon_and_rectal_surgery",
    label: "Colon and Rectal Surgery",
    value: "Colon and Rectal Surgery"
  },
  { id: "dentist", label: "Dentist", value: "Dentist" },
  { id: "dermatology", label: "Dermatology", value: "Dermatology" },
  {
    id: "emergency_medicine",
    label: "Emergency Medicine",
    value: "Emergency Medicine"
  },
  { id: "family_medicine", label: "Family Medicine", value: "Family Medicine" },
  {
    id: "internal_medicine",
    label: "Internal Medicine",
    value: "Internal Medicine"
  },
  {
    id: "medical_genetics_and_genomics",
    label: "Medical Genetics and Genomics",
    value: "Medical Genetics and Genomics"
  },
  {
    id: "neurological_surgery",
    label: "Neurological Surgery",
    value: "Neurological Surgery"
  },
  { id: "neurology", label: "Neurology", value: "Neurology" },
  { id: "not_applicable", label: "Not Applicable", value: "Not Applicable" },
  {
    id: "nuclear_medicine",
    label: "Nuclear Medicine",
    value: "Nuclear Medicine"
  },
  {
    id: "obstetrics_and_gynecology",
    label: "Obstetrics and Gynecology",
    value: "Obstetrics and Gynecology"
  },
  { id: "oncology", label: "Oncology", value: "Oncology" },
  { id: "ophthalmology", label: "Ophthalmology", value: "Ophthalmology" },
  {
    id: "orthopaedic_surgery",
    label: "Orthopaedic Surgery",
    value: "Orthopaedic Surgery"
  },
  {
    id: "osteopathic_neuromusculoskeletal_medicine",
    label: "Osteopathic Neuromusculoskeletal Medicine",
    value: "Osteopathic Neuromusculoskeletal Medicine"
  },
  {
    id: "otolaryngology-head_and_neck_surgery",
    label: "Otolaryngology-Head and Neck Surgery",
    value: "Otolaryngology-Head and Neck Surgery"
  },
  { id: "pain_medicine", label: "Pain Medicine", value: "Pain Medicine" },
  { id: "pathology", label: "Pathology", value: "Pathology" },
  { id: "pediatrics", label: "Pediatrics", value: "Pediatrics" },
  {
    id: "physical_medicine_and_rehabilitation",
    label: "Physical Medicine and Rehabilitation",
    value: "Physical Medicine and Rehabilitation"
  },
  { id: "plastic_surgery", label: "Plastic Surgery", value: "Plastic Surgery" },
  { id: "podiatrist", label: "Podiatrist", value: "Podiatrist" },
  {
    id: "preventive_medicine",
    label: "Preventive Medicine",
    value: "Preventive Medicine"
  },
  { id: "psychiatry", label: "Psychiatry", value: "Psychiatry" },
  { id: "radiology", label: "Radiology", value: "Radiology" },
  {
    id: "surgery_(general_surgery)",
    label: "Surgery (General Surgery)",
    value: "Surgery (General Surgery)"
  },
  {
    id: "thoracic_surgery",
    label: "Thoracic Surgery",
    value: "Thoracic Surgery"
  },
  { id: "urology", label: "Urology", value: "Urology" }
];
var SPECIALTY_OPTIONS_OPTIONAL = [
  { id: import_core8.DEFAULT_NO_SELECTION_ID, label: "None Selected", value: void 0 },
  ...SPECIALTY_OPTIONS
];
var CAREER_STAGE_MAPPING = {
  ["MEDICAL_STUDENT" /* MEDICAL_STUDENT */]: "Medical Student",
  ["RESIDENT" /* RESIDENT */]: "Resident",
  ["RETIRED_PHYSICIAN" /* RETIRED_PHYSICIAN */]: "Retired Doctor",
  ["PRACTICING_PHYSICIAN" /* PRACTICING_PHYSICIAN */]: "Practicing Doctor"
};
var ABOUS_US_REFERRAL_MAPPING = {
  [AboutUsReferral.POF]: "Physician on FIRE",
  [AboutUsReferral.OTHER]: "Other"
};
var INTERESTS_OPTIONS = [
  { value: "FINANCIAL_PLANNING", label: "Financial Plan" },
  { value: "INVESTMENTS", label: "Investments" },
  { value: "TAX_PLANNING", label: "Tax Planning" },
  { value: "CAREER_ADVISORY", label: "Career Advisory" },
  { value: "INSURANCE", label: "Insurance" },
  { value: "DEBT_AND_CASH_MANAGEMENT", label: "Debt & Cash Management" },
  { value: "TRUST_AND_ESTATE_PLANNING", label: "Trust & Estate" },
  { value: "RETIREMENT_PLANNING", label: "Retirement Planning" }
];

// src/modules/disability-insurance/components/DisabilityInsuranceWizard/DisabilityInsuranceWizard.tsx
var import_jsx_runtime15 = require("react/jsx-runtime");
var DisabilityInsuranceWizard = ({
  isOpen,
  close,
  cache,
  onSubmit,
  isSuccess,
  onDone,
  isSubmitting = false,
  isLoading = false,
  infoOwnerName,
  modalRootSelector = "body"
}) => {
  const { isFirst, isLast, currentPage, goNext, goBack, reset, progress } = useWizardControls({ pages: PAGE_COUNT });
  const subtitle = React5.useMemo(
    () => isFirst ? "Please provide the necessary information for us to set up your Disability Insurance." : void 0,
    [isFirst]
  );
  const nextLabel = React5.useMemo(() => isLast ? "Submit" : "Next", [isLast]);
  const {
    formState,
    handleSubmit: submit,
    trigger,
    getValues,
    register,
    watch,
    setValue,
    control
  } = (0, import_react_hook_form.useForm)({
    values: cache ? DISABILITY_INSURANCE_FORM_SCHEMA.cast(cache) : void 0,
    mode: "onTouched",
    resolver: (0, import_yup.yupResolver)(DISABILITY_INSURANCE_FORM_SCHEMA)
  });
  const handleSubmit = React5.useCallback(
    (fields) => {
      onSubmit(DISABILITY_INSURANCE_PAYLOAD_SCHEMA.cast(fields));
    },
    [onSubmit]
  );
  const handleNext = React5.useCallback(() => {
    trigger(VALIDATION_MAP[currentPage]).then((valid) => {
      if (valid)
        goNext();
    });
  }, [trigger, currentPage, goNext]);
  const fieldValues = getValues();
  const stateOfBirth = watch("BIRTH_STATE" /* BIRTH_STATE */);
  const stateOfBirthValue = React5.useMemo(
    () => US_STATE_OPTIONS.find((state) => state.value === stateOfBirth) || {
      id: null,
      label: "",
      value: null
    },
    [stateOfBirth]
  );
  const bornInUS = watch("BORN_IN_THE_USA" /* BORN_IN_THE_USA */);
  React5.useEffect(() => {
    if (!bornInUS) {
      setValue("BIRTH_STATE" /* BIRTH_STATE */, "");
    } else {
      setValue("PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */, "");
    }
  }, [bornInUS, setValue]);
  const renderFields = React5.useCallback(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    switch (currentPage) {
      case 0:
        return /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(import_jsx_runtime15.Fragment, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
            import_react_hook_form.Controller,
            {
              control,
              name: "DOB" /* DOB */,
              render: ({ field, formState: formState2 }) => {
                var _a2;
                return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                  import_core9.TextInput,
                  {
                    label: "Date of Birth",
                    placeholder: "mm/dd/yyyy",
                    error: (_a2 = formState2.errors["DOB" /* DOB */]) == null ? void 0 : _a2.message,
                    maskOptions: {
                      mask: "99/99/9999",
                      maskChar: ""
                    },
                    ...field
                  }
                );
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(QuestionBlock_default, { label: "Gender", children: /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(
            import_core9.RadioGroup,
            {
              ...register("GENDER" /* GENDER */),
              error: (_a = formState.errors["GENDER" /* GENDER */]) == null ? void 0 : _a.message,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                  import_core9.Radio,
                  {
                    label: "Male",
                    value: "male",
                    error: (_b = formState.errors["GENDER" /* GENDER */]) == null ? void 0 : _b.message
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                  import_core9.Radio,
                  {
                    label: "Female",
                    value: "female",
                    error: (_c = formState.errors["GENDER" /* GENDER */]) == null ? void 0 : _c.message
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                  import_core9.Radio,
                  {
                    label: "Other",
                    value: "other",
                    error: (_d = formState.errors["GENDER" /* GENDER */]) == null ? void 0 : _d.message
                  }
                )
              ]
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(QuestionBlock_default, { label: "Do you currently use Tobacco?", children: /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(
            import_core9.RadioGroup,
            {
              ...register("TOBACCO_USE" /* TOBACCO_USE */),
              error: (_e = formState.errors["TOBACCO_USE" /* TOBACCO_USE */]) == null ? void 0 : _e.message,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                  import_core9.Radio,
                  {
                    label: "Yes",
                    value: "true",
                    error: (_f = formState.errors["TOBACCO_USE" /* TOBACCO_USE */]) == null ? void 0 : _f.message
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                  import_core9.Radio,
                  {
                    label: "No",
                    value: "false",
                    error: (_g = formState.errors["TOBACCO_USE" /* TOBACCO_USE */]) == null ? void 0 : _g.message
                  }
                )
              ]
            }
          ) })
        ] });
      case 1:
        return /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(import_jsx_runtime15.Fragment, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(QuestionBlock_default, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
              import_react_hook_form.Controller,
              {
                control,
                name: "BIRTH_STATE" /* BIRTH_STATE */,
                render: () => {
                  var _a2;
                  return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                    import_core9.SelectBox,
                    {
                      label: "State of Birth",
                      options: US_STATE_OPTIONS,
                      onChange: (opt) => setValue("BIRTH_STATE" /* BIRTH_STATE */, (opt == null ? void 0 : opt.value) ?? ""),
                      selected: stateOfBirthValue,
                      error: (_a2 = formState.errors["BIRTH_STATE" /* BIRTH_STATE */]) == null ? void 0 : _a2.message,
                      disabled: !bornInUS
                    }
                  );
                }
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
              import_react_hook_form.Controller,
              {
                control,
                name: "BORN_IN_THE_USA" /* BORN_IN_THE_USA */,
                render: () => {
                  var _a2;
                  return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                    import_core9.Checkbox,
                    {
                      label: "I was not born in the United States",
                      onChange: (e) => {
                        setValue("BORN_IN_THE_USA" /* BORN_IN_THE_USA */, !e.target.checked);
                      },
                      checked: !bornInUS,
                      error: (_a2 = formState.errors["BORN_IN_THE_USA" /* BORN_IN_THE_USA */]) == null ? void 0 : _a2.message
                    }
                  );
                }
              }
            )
          ] }),
          !bornInUS && /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(QuestionBlock_default, { applyIndent: true, applyPadding: false, children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
            import_core9.TextInput,
            {
              type: "text",
              label: "Place of Birth (Country)",
              ...register("PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */),
              error: (_h = formState.errors["PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */]) == null ? void 0 : _h.message
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
            import_core9.TextInput,
            {
              type: "currency",
              label: "Annual Income",
              ...register("ANNUAL_INCOME" /* ANNUAL_INCOME */),
              error: (_i = formState.errors["ANNUAL_INCOME" /* ANNUAL_INCOME */]) == null ? void 0 : _i.message
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
            import_core9.TextInput,
            {
              type: "number",
              label: "Years in your current position",
              ...register("YEARS_PRACTICE" /* YEARS_PRACTICE */),
              error: (_j = formState.errors["YEARS_PRACTICE" /* YEARS_PRACTICE */]) == null ? void 0 : _j.message,
              helperText: "Training (includes Residency and Fellowship) or Practicing"
            }
          )
        ] });
      case 2:
        const formattedName = !(fieldValues["FIRST_NAME" /* FIRST_NAME */] && fieldValues["LAST_NAME" /* LAST_NAME */]) ? "--" : `${fieldValues["FIRST_NAME" /* FIRST_NAME */]} ${fieldValues["LAST_NAME" /* LAST_NAME */]}`;
        const formattedDOB = fieldValues["DOB" /* DOB */] ? (0, import_moment2.default)(fieldValues["DOB" /* DOB */]).format("MM/DD/YYYY") : "--";
        return /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(import_jsx_runtime15.Fragment, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(ReviewBlock_default, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(ReviewList_default, { label: "Name", value: formattedName }),
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
              ReviewList_default,
              {
                label: "State of Residence",
                value: fieldValues["ADDRESS_STATE" /* ADDRESS_STATE */] || "--"
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
              ReviewList_default,
              {
                label: "Specialty",
                value: fieldValues["SPECIALTY" /* SPECIALTY */] || "--"
              }
            )
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(ReviewBlock_default, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
              ReviewList_default,
              {
                label: "Date of Birth",
                value: formattedDOB
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
              ReviewList_default,
              {
                label: "Gender",
                value: import_lodash.default.capitalize(fieldValues["GENDER" /* GENDER */])
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
              ReviewList_default,
              {
                label: "Do you currently use Tobacco?",
                value: fieldValues["TOBACCO_USE" /* TOBACCO_USE */] === "true" ? "Yes" : fieldValues["TOBACCO_USE" /* TOBACCO_USE */] === "false" ? "No" : "--"
              }
            ),
            fieldValues["BORN_IN_THE_USA" /* BORN_IN_THE_USA */] ? /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
              ReviewList_default,
              {
                label: "State of Birth",
                value: fieldValues["BIRTH_STATE" /* BIRTH_STATE */] || "--"
              }
            ) : /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
              ReviewList_default,
              {
                label: "Place of Birth",
                value: fieldValues["PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */] || "--"
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
              ReviewList_default,
              {
                label: "Annual Income",
                value: formatters.currency(
                  fieldValues["ANNUAL_INCOME" /* ANNUAL_INCOME */]
                )
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
              ReviewList_default,
              {
                label: "How long practicing?",
                value: (fieldValues["YEARS_PRACTICE" /* YEARS_PRACTICE */] || 0) + " year(s)"
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(ReviewEditLink_default, { onClick: reset })
          ] })
        ] });
      default:
        return null;
    }
  }, [
    bornInUS,
    currentPage,
    fieldValues,
    formState.errors,
    register,
    reset,
    setValue,
    stateOfBirthValue,
    control
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { "data-testid": "disability-insurance-wizard", children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
    Modal_default,
    {
      open: isOpen,
      progressPercentage: isLoading ? 0 : progress,
      renderConfirmation: () => /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(SuccessPanel_default, { onDone }),
      showConfirmation: isSuccess,
      close,
      title: "Disability Insurance",
      titleTag: infoOwnerName,
      subtitle,
      showProgressBar: true,
      rootSelector: modalRootSelector,
      children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "flex flex-row justify-center", children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(LoadingIndicator_default, {}) }) : /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)("form", { onSubmit: submit(handleSubmit), children: [
        renderFields(),
        /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
          Footer_default,
          {
            onNextClick: handleNext,
            onPreviousClick: goBack,
            nextDisabled: isLast && (!formState.isValid || isSubmitting),
            showPrevious: !isFirst,
            submitMode: isLast,
            nextLabel,
            submitting: isLast && isSubmitting
          }
        )
      ] })
    }
  ) });
};
var DisabilityInsuranceWizard_default = DisabilityInsuranceWizard;

// src/modules/term-life-insurance/constants.ts
var TL_PAGE_COUNT = 3;
var TERM_LIFE_INSURANCE_FORM_SCHEMA = yup_extend_default.object({
  ["FIRST_NAME" /* FIRST_NAME */]: yup_extend_default.string(),
  ["LAST_NAME" /* LAST_NAME */]: yup_extend_default.string(),
  ["ADDRESS_STATE" /* ADDRESS_STATE */]: yup_extend_default.string(),
  ["DOB" /* DOB */]: yup_extend_default.string(),
  ["BIRTH_STATE" /* BIRTH_STATE */]: yup_extend_default.string().optional(),
  ["PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */]: yup_extend_default.string().optional(),
  ["BORN_IN_THE_USA" /* BORN_IN_THE_USA */]: yup_extend_default.boolean(),
  ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.string().currency(),
  ["NET_WORTH" /* NET_WORTH */]: yup_extend_default.string().currency(),
  ["CURR_LIFE_POLICY_MONTHLY_PREM" /* CURR_LIFE_POLICY_MONTHLY_PREM */]: yup_extend_default.string().currency().optional(),
  ["CURR_LIFE_POLICY_TYPE" /* CURR_LIFE_POLICY_TYPE */]: yup_extend_default.string().optional()
});
var TERM_LIFE_INSURANCE_PAYLOAD_SCHEMA = yup_extend_default.object({
  ["FIRST_NAME" /* FIRST_NAME */]: yup_extend_default.string(),
  ["LAST_NAME" /* LAST_NAME */]: yup_extend_default.string(),
  ["ADDRESS_STATE" /* ADDRESS_STATE */]: yup_extend_default.string(),
  ["DOB" /* DOB */]: yup_extend_default.string(),
  ["BIRTH_STATE" /* BIRTH_STATE */]: yup_extend_default.string().optional(),
  ["PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */]: yup_extend_default.string().optional(),
  ["BORN_IN_THE_USA" /* BORN_IN_THE_USA */]: yup_extend_default.boolean(),
  ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.number().fromCurrency(),
  ["NET_WORTH" /* NET_WORTH */]: yup_extend_default.number().fromCurrency(),
  ["CURR_LIFE_POLICY_MONTHLY_PREM" /* CURR_LIFE_POLICY_MONTHLY_PREM */]: yup_extend_default.number().fromCurrency().optional(),
  ["CURR_LIFE_POLICY_TYPE" /* CURR_LIFE_POLICY_TYPE */]: yup_extend_default.string().optional()
});
var PAGE_VALIDATION_MAP = {
  0: [
    "ANNUAL_INCOME" /* ANNUAL_INCOME */,
    "NET_WORTH" /* NET_WORTH */,
    "BIRTH_STATE" /* BIRTH_STATE */,
    "PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */
  ],
  1: [
    "CURR_LIFE_POLICY_MONTHLY_PREM" /* CURR_LIFE_POLICY_MONTHLY_PREM */,
    "CURR_LIFE_POLICY_TYPE" /* CURR_LIFE_POLICY_TYPE */
  ]
};
var INSURANCE_POLICY_TYPE_MAP = {
  ["TERM" /* TERM */]: "Term Life",
  ["WHOLE" /* WHOLE */]: "Whole Life",
  ["UNIVERSAL" /* UNIVERSAL */]: "Universal Life"
};

// src/modules/term-life-insurance/components/TermLifeInsuranceWizard/TermLifeInsuranceWizard.tsx
var React7 = __toESM(require("react"));
var import_react_hook_form2 = require("react-hook-form");

// src/modules/term-life-insurance/components/TLPageOne/TLPageOne.tsx
var import_core10 = require("@earned/core");
var import_jsx_runtime16 = require("react/jsx-runtime");
var TLPageOne = ({
  fields,
  setValue,
  formState,
  register,
  notBornInTheUSA,
  toggleNotBornInTheUSA
}) => {
  var _a, _b, _c, _d;
  register("BIRTH_STATE" /* BIRTH_STATE */, {
    validate: (v) => notBornInTheUSA || !!v || "Birth State is required"
  });
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)("div", { "data-testid": "tl-page-one", children: [
    /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)(QuestionBlock_default, { applyPadding: !notBornInTheUSA, children: [
      /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
        import_core10.SelectBox,
        {
          disabled: notBornInTheUSA,
          label: "Birth State",
          options: US_STATE_OPTIONS_OPTIONAL,
          selected: US_STATE_OPTIONS_OPTIONAL.find(
            (opt) => opt.value === fields["BIRTH_STATE" /* BIRTH_STATE */]
          ),
          onChange: (selected) => {
            setValue("BIRTH_STATE" /* BIRTH_STATE */, selected.value, {
              shouldValidate: true
            });
          },
          error: (_a = formState.errors["BIRTH_STATE" /* BIRTH_STATE */]) == null ? void 0 : _a.message
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
        import_core10.Checkbox,
        {
          label: "I was not born in the United States",
          checked: notBornInTheUSA,
          onChange: toggleNotBornInTheUSA
        }
      )
    ] }),
    notBornInTheUSA && /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(QuestionBlock_default, { applyIndent: true, applyPadding: false, children: /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
      import_core10.TextInput,
      {
        type: "text",
        label: "Place of Birth (Country)",
        ...register("PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */, {
          validate: (v) => !!v || "Place of Birth is required"
        }),
        error: (_b = formState.errors["PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */]) == null ? void 0 : _b.message
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)(QuestionBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
        import_core10.TextInput,
        {
          label: "Annual Income",
          type: "currency",
          ...register("ANNUAL_INCOME" /* ANNUAL_INCOME */, {
            required: "Annual Income is required"
          }),
          error: (_c = formState.errors["ANNUAL_INCOME" /* ANNUAL_INCOME */]) == null ? void 0 : _c.message
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
        import_core10.TextInput,
        {
          label: "Net Worth",
          type: "currency",
          ...register("NET_WORTH" /* NET_WORTH */, {
            required: "Net Worth is required"
          }),
          helperText: "Your net worth is your assets minus your liabilities.",
          error: (_d = formState.errors["NET_WORTH" /* NET_WORTH */]) == null ? void 0 : _d.message
        }
      )
    ] })
  ] });
};
var TLPageOne_default = TLPageOne;

// src/modules/term-life-insurance/components/TLPageTwo/TLPageTwo.tsx
var import_core11 = require("@earned/core");
var import_jsx_runtime17 = require("react/jsx-runtime");
var TLPageTwo = ({
  formState,
  register,
  hasLifeInsurancePolicy,
  toggleHasInsurancePolicy
}) => {
  var _a, _b;
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)("div", { "data-testid": "tl-page-two", children: [
    /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
      QuestionBlock_default,
      {
        label: "Do you currently have a life insurance policy?",
        applyPadding: !hasLifeInsurancePolicy,
        children: /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)(
          import_core11.RadioGroup,
          {
            name: "HAS_INSURANCE_POLICY",
            onChange: toggleHasInsurancePolicy,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(import_core11.Radio, { value: "true", label: "Yes", checked: hasLifeInsurancePolicy }),
              /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(import_core11.Radio, { value: "false", label: "No", checked: !hasLifeInsurancePolicy })
            ]
          }
        )
      }
    ),
    hasLifeInsurancePolicy && /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)("div", { className: "pl-form-detail-pl", children: [
      /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
        import_core11.TextInput,
        {
          type: "currency",
          label: "What is your current monthly payment?",
          ...register("CURR_LIFE_POLICY_MONTHLY_PREM" /* CURR_LIFE_POLICY_MONTHLY_PREM */, {
            validate: (v) => !!v && hasLifeInsurancePolicy || "Monthly Premium is required"
          }),
          error: (_a = formState.errors["CURR_LIFE_POLICY_MONTHLY_PREM" /* CURR_LIFE_POLICY_MONTHLY_PREM */]) == null ? void 0 : _a.message
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(QuestionBlock_default, { label: "What type of insurancy policy do you have?", children: /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)(
        import_core11.RadioGroup,
        {
          ...register("CURR_LIFE_POLICY_TYPE" /* CURR_LIFE_POLICY_TYPE */, {
            validate: (v) => !!v && hasLifeInsurancePolicy || "Insurance Policy Type is required"
          }),
          error: (_b = formState.errors["CURR_LIFE_POLICY_TYPE" /* CURR_LIFE_POLICY_TYPE */]) == null ? void 0 : _b.message,
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(import_core11.Radio, { value: "TERM" /* TERM */, label: "Term Life" }),
            /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(import_core11.Radio, { value: "WHOLE" /* WHOLE */, label: "Whole Life" }),
            /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(import_core11.Radio, { value: "UNIVERSAL" /* UNIVERSAL */, label: "Universal Life" })
          ]
        }
      ) })
    ] })
  ] });
};
var TLPageTwo_default = TLPageTwo;

// src/modules/term-life-insurance/components/TLPageReview/TLPageReview.tsx
var React6 = __toESM(require("react"));
var import_moment3 = __toESM(require("moment"));
var import_jsx_runtime18 = require("react/jsx-runtime");
var TLPageReview = ({ fields, onEdit }) => {
  const formattedName = React6.useMemo(
    () => !(fields.FIRST_NAME || fields.LAST_NAME) ? "--" : `${fields.FIRST_NAME} ${fields.LAST_NAME}`,
    [fields]
  );
  const formattedDOB = React6.useMemo(
    () => fields.DOB ? (0, import_moment3.default)(fields.DOB).format("MM/DD/yyyy") : "--",
    [fields]
  );
  const formattedPolicyType = React6.useMemo(
    () => fields.CURR_LIFE_POLICY_TYPE ? INSURANCE_POLICY_TYPE_MAP[fields.CURR_LIFE_POLICY_TYPE] : "--",
    [fields]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime18.jsxs)("div", { "data-testid": "tl-page-review", children: [
    /* @__PURE__ */ (0, import_jsx_runtime18.jsxs)(ReviewBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(ReviewList_default, { label: "Name", value: formattedName }),
      /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(ReviewList_default, { label: "Date of Birth", value: formattedDOB }),
      /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        ReviewList_default,
        {
          label: "State of Residence",
          value: fields.ADDRESS_STATE || "--"
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime18.jsxs)(ReviewBlock_default, { children: [
      fields.BORN_IN_THE_USA ? /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        ReviewList_default,
        {
          label: "State of Birth",
          value: fields.BIRTH_STATE || "--"
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        ReviewList_default,
        {
          label: "Place of Birth",
          value: fields.PLACE_OF_BIRTH || "--"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        ReviewList_default,
        {
          label: "Annual Income",
          value: formatters.currency(fields.ANNUAL_INCOME)
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        ReviewList_default,
        {
          label: "Net Worth",
          value: formatters.currency(fields.NET_WORTH)
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        ReviewList_default,
        {
          label: "Do you currently have life insurance?",
          value: fields.CURR_LIFE_POLICY_MONTHLY_PREM || fields.CURR_LIFE_POLICY_TYPE ? "Yes" : "No"
        }
      ),
      fields["CURR_LIFE_POLICY_MONTHLY_PREM" /* CURR_LIFE_POLICY_MONTHLY_PREM */] && /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        ReviewList_default,
        {
          label: "What is your current monthly payment?",
          value: formatters.currency(fields.CURR_LIFE_POLICY_MONTHLY_PREM)
        }
      ),
      fields["CURR_LIFE_POLICY_TYPE" /* CURR_LIFE_POLICY_TYPE */] && /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
        ReviewList_default,
        {
          label: "Which type of insurance policy do you have?",
          value: formattedPolicyType
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(ReviewEditLink_default, { onClick: onEdit })
    ] })
  ] });
};
var TLPageReview_default = TLPageReview;

// src/modules/term-life-insurance/components/TermLifeInsuranceWizard/TermLifeInsuranceWizard.tsx
var import_jsx_runtime19 = require("react/jsx-runtime");
var TermLifeInsuranceWizard = ({
  isOpen,
  close,
  cache,
  onSubmit,
  isSuccess,
  onDone,
  isSubmitting = false,
  isLoading = false,
  infoOwnerName,
  modalRootSelector = "body"
}) => {
  const { isFirst, isLast, currentPage, goNext, goBack, reset, progress } = useWizardControls({ pages: TL_PAGE_COUNT });
  const subtitle = React7.useMemo(
    () => isFirst ? "Please provide the necessary information for us to set up your Term Life Insurance." : isLast ? "Please review the following information before submitting the application." : void 0,
    [isFirst, isLast]
  );
  const nextLabel = React7.useMemo(() => isLast ? "Submit" : "Next", [isLast]);
  const {
    register,
    getValues,
    formState,
    handleSubmit: submit,
    trigger,
    control,
    setValue
  } = (0, import_react_hook_form2.useForm)({
    values: cache ? TERM_LIFE_INSURANCE_FORM_SCHEMA.cast(cache) : void 0,
    defaultValues: {
      BORN_IN_THE_USA: true
    },
    mode: "onBlur"
  });
  const fieldValues = getValues();
  const [hasLifeInsurancePolicy, setHasLifeInsurancePolicy] = React7.useState(
    !!(cache == null ? void 0 : cache.CURR_LIFE_POLICY_MONTHLY_PREM) || !!(cache == null ? void 0 : cache.CURR_LIFE_POLICY_TYPE)
  );
  const toggleHasInsurancePolicy = React7.useCallback(() => {
    setHasLifeInsurancePolicy((checked) => !checked);
  }, [setHasLifeInsurancePolicy]);
  React7.useEffect(() => {
    if (!hasLifeInsurancePolicy) {
      if (fieldValues.CURR_LIFE_POLICY_TYPE !== void 0)
        setValue("CURR_LIFE_POLICY_TYPE" /* CURR_LIFE_POLICY_TYPE */, void 0);
      if (fieldValues.CURR_LIFE_POLICY_MONTHLY_PREM !== void 0)
        setValue("CURR_LIFE_POLICY_MONTHLY_PREM" /* CURR_LIFE_POLICY_MONTHLY_PREM */, void 0);
    }
  }, [hasLifeInsurancePolicy, fieldValues, setValue]);
  register("BORN_IN_THE_USA" /* BORN_IN_THE_USA */);
  const [notBornInTheUSA, setNotBornInTheUSA] = React7.useState(
    !(fieldValues == null ? void 0 : fieldValues.BORN_IN_THE_USA)
  );
  const toggleNotBornInTheUSA = React7.useCallback(
    () => setNotBornInTheUSA((prev) => !prev),
    [setNotBornInTheUSA]
  );
  React7.useEffect(() => {
    if (!!fieldValues.BORN_IN_THE_USA === notBornInTheUSA) {
      setValue("BORN_IN_THE_USA" /* BORN_IN_THE_USA */, !notBornInTheUSA);
      if (notBornInTheUSA)
        trigger("BIRTH_STATE" /* BIRTH_STATE */);
    }
    if (notBornInTheUSA && !!fieldValues.BIRTH_STATE) {
      setValue("BIRTH_STATE" /* BIRTH_STATE */, void 0, { shouldValidate: true });
    }
    if (!notBornInTheUSA && !!fieldValues.PLACE_OF_BIRTH) {
      setValue("PLACE_OF_BIRTH" /* PLACE_OF_BIRTH */, void 0, { shouldValidate: true });
    }
  }, [setValue, notBornInTheUSA, fieldValues, trigger]);
  React7.useEffect(() => {
    if (isLast)
      trigger();
  }, [trigger, isLast]);
  const handleSubmit = React7.useCallback(
    (fields) => {
      onSubmit(
        TERM_LIFE_INSURANCE_PAYLOAD_SCHEMA.cast(fields)
      );
    },
    [onSubmit]
  );
  const handleNext = React7.useCallback(() => {
    trigger(PAGE_VALIDATION_MAP[currentPage]).then((valid) => {
      if (valid)
        goNext();
    });
  }, [trigger, goNext, currentPage]);
  const renderPages = React7.useCallback(() => {
    switch (currentPage) {
      case 0:
        return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
          TLPageOne_default,
          {
            setValue,
            fields: fieldValues,
            toggleNotBornInTheUSA,
            notBornInTheUSA,
            register,
            formState
          }
        );
      case 1:
        return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
          TLPageTwo_default,
          {
            register,
            fields: fieldValues,
            setValue,
            formState,
            hasLifeInsurancePolicy,
            toggleHasInsurancePolicy
          }
        );
      case 2:
        return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(TLPageReview_default, { fields: fieldValues, onEdit: reset });
    }
  }, [
    currentPage,
    fieldValues,
    formState,
    hasLifeInsurancePolicy,
    notBornInTheUSA,
    toggleHasInsurancePolicy,
    toggleNotBornInTheUSA,
    register,
    reset,
    setValue
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("div", { "data-testid": "term-life-insurance-wizard", children: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
    Modal_default,
    {
      title: "Term Life Insurance",
      titleTag: infoOwnerName,
      subtitle,
      open: isOpen,
      close,
      showConfirmation: isSuccess,
      progressPercentage: isLoading ? 0 : progress,
      renderConfirmation: () => /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(SuccessPanel_default, { onDone }),
      showProgressBar: true,
      rootSelector: modalRootSelector,
      children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("div", { className: "flex flex-row justify-center", children: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(LoadingIndicator_default, {}) }) : /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)("form", { onSubmit: submit(handleSubmit), children: [
        renderPages(),
        /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
          Footer_default,
          {
            onNextClick: handleNext,
            onPreviousClick: goBack,
            nextDisabled: isLast && (!formState.isValid || isSubmitting),
            showPrevious: !isFirst,
            submitMode: isLast,
            nextLabel,
            submitting: isLast && isSubmitting
          }
        )
      ] })
    }
  ) });
};
var TermLifeInsuranceWizard_default = TermLifeInsuranceWizard;

// src/modules/signup/constants.ts
var yup2 = __toESM(require("yup"));

// src/modules/signup/types.ts
var SignupFieldKeys = /* @__PURE__ */ ((SignupFieldKeys2) => {
  SignupFieldKeys2["FIRST_NAME"] = "FIRST_NAME";
  SignupFieldKeys2["LAST_NAME"] = "LAST_NAME";
  SignupFieldKeys2["NPI_NUMBER"] = "NPI_NUMBER";
  SignupFieldKeys2["SPECIALTY"] = "SPECIALTY";
  SignupFieldKeys2["SUBSPECIALTY"] = "SUBSPECIALTY";
  SignupFieldKeys2["CAREER_STAGE"] = "CAREER_STAGE";
  SignupFieldKeys2["NOT_A_DOCTOR"] = "NOT_A_DOCTOR";
  SignupFieldKeys2["ABOUT_US_REFERRAL"] = "ABOUT_US_REFERRAL";
  SignupFieldKeys2["INTERESTS"] = "INTERESTS";
  SignupFieldKeys2["CREATED_BY_ADVISOR"] = "CREATED_BY_ADVISOR";
  SignupFieldKeys2["ACCESS_CODE"] = "ACCESS_CODE";
  SignupFieldKeys2["SHOW_ACCESS_CODE_HELPER_TEXT"] = "SHOW_ACCESS_CODE_HELPER_TEXT";
  return SignupFieldKeys2;
})(SignupFieldKeys || {});

// src/modules/signup/helpers.ts
var validateNPIChecksum = (npiNumber, testContext) => {
  const { createError } = testContext;
  const trimmedNPI = npiNumber.trim();
  const npiNumberArr = Array.from(trimmedNPI).map((n) => parseInt(n));
  if (npiNumberArr.length !== 10 && npiNumberArr.length !== 15) {
    return createError({ message: "NPI Number must be 10 or 15 digits" });
  }
  let checksumArr = npiNumberArr.slice(0, npiNumberArr.length - 1);
  const checksumDigit = npiNumberArr.at(-1);
  checksumArr = checksumArr.slice().reverse().map((num, index) => {
    if (index % 2 != 0)
      return num;
    return num * 2;
  }).reverse();
  let checksum = checksumArr.reduce((memo3, num) => {
    if (num >= 10) {
      memo3 = memo3 + String(num).split("").reduce((m, n) => {
        m = m + parseInt(n);
        return m;
      }, 0);
    } else {
      memo3 = memo3 + num;
    }
    return memo3;
  }, 0);
  if (trimmedNPI.length === 10) {
    checksum = checksum + 24;
  }
  checksum = parseInt(Array.from(String(checksum)).at(-1) ?? "0");
  if (checksum !== 0) {
    checksum = 10 - checksum;
  }
  if (checksum !== checksumDigit) {
    return createError({ message: "Invalid NPI Number" });
  }
  return true;
};
var validateNPINumber = (npiNumber, testContext) => {
  const { createError } = testContext;
  if (!npiNumber || npiNumber.trim() === "") {
    return createError({ message: "NPI Number is required" });
  }
  return validateNPIChecksum(npiNumber, testContext);
};
var validateNPINumberOptional = (npiNumber, testContext) => {
  if (!npiNumber || npiNumber.trim() === "") {
    return true;
  }
  return validateNPIChecksum(npiNumber, testContext);
};
var getFormTitle = (currentPage, isLast, aboutUsReferral, accessCode) => {
  const PoFPages = ["POF_INTRO", "INTERESTS", "NPI_AND_CAREER"];
  let title = "";
  const isPoF = PoFPages.includes(currentPage) && aboutUsReferral === AboutUsReferral.POF;
  const isUMP = accessCode === UMP_ACCESS_CODE && currentPage !== "NAME";
  const isJM = accessCode === JMMG_ACCESS_CODE && currentPage !== "NAME";
  const isECMA = accessCode === ECMA_ACCESS_CODE && currentPage !== "NAME";
  const isSJMG = accessCode === SJMG_ACCESS_CODE && currentPage !== "NAME";
  if (isPoF) {
    title = "Physician on FIRE introduces the Earned App";
  } else if (currentPage === "COBRANDED_INTRO") {
    if (isUMP) {
      title = "University Medical Partners welcomes you to the Earned app";
    } else if (isJM) {
      title = "John Muir Medical Group welcomes you to the Earned app";
    } else if (isECMA) {
      title = "El Camino Medical Associates welcomes you to the Earned app";
    } else if (isSJMG) {
      title = "San Jose Medical Group welcomes you to the Earned app";
    }
  } else {
    title = "Sign Up";
  }
  if (isLast) {
    title = "Complete Sign Up";
  }
  return { title, isPoF, isUMP, isJM, isECMA, isSJMG };
};
var validateAccessCode = (accessCode, testContext) => {
  const { createError } = testContext;
  accessCode = accessCode == null ? void 0 : accessCode.trim();
  if (!accessCode)
    return true;
  if (accessCode !== UMP_ACCESS_CODE && accessCode !== JMMG_ACCESS_CODE && accessCode !== ECMA_ACCESS_CODE && accessCode !== SJMG_ACCESS_CODE)
    return createError({ message: "Invalid access code" });
  return true;
};

// src/modules/signup/constants.ts
var import_lodash2 = require("lodash");
var SIGNUP_FORM_SCHEMA = yup2.object({
  FIRST_NAME: yup2.string().required("First Name is required"),
  LAST_NAME: yup2.string().required("Last Name is required"),
  // NPI Number validation logic:
  // - NOT required for non-doctors (NOT_A_DOCTOR = true)
  // - NOT required for retired physicians (CAREER_STAGE = RETIRED_PHYSICIAN)
  // - When optional, NPI format is still validated if a value is provided
  // - Required for all other career stages (medical students, residents, practicing physicians)
  NPI_NUMBER: yup2.string().when(["NOT_A_DOCTOR", "CAREER_STAGE"], {
    is: (notADoctor, careerStage) => notADoctor === true || careerStage === "RETIRED_PHYSICIAN" /* RETIRED_PHYSICIAN */,
    then: yup2.string().notRequired().test(
      "validate-npi-number",
      "Invalid NPI Number",
      validateNPINumberOptional
    ),
    otherwise: yup2.string().required("NPI Number is required").test("validate-npi-number", "Invalid NPI Number", validateNPINumber)
  }),
  CAREER_STAGE: yup2.string().when("NOT_A_DOCTOR", {
    is: true,
    then: yup2.string().notRequired().nullable(),
    otherwise: yup2.string().required("Career Stage is required").nullable()
  }),
  NOT_A_DOCTOR: yup2.boolean(),
  CREATED_BY_ADVISOR: yup2.boolean().default(void 0),
  ABOUT_US_REFERRAL: yup2.string().when("CREATED_BY_ADVISOR", {
    is: true,
    then: yup2.string().notRequired(),
    otherwise: yup2.string().required("How did you hear about us? is required").nullable()
  }),
  INTERESTS: yup2.array().when(["ABOUT_US_REFERRAL", "ACCESS_CODE"], {
    is: (aboutUsReferral, accessCode) => aboutUsReferral === AboutUsReferral.POF || !(0, import_lodash2.isEmpty)(accessCode),
    then: yup2.array().of(yup2.string()).min(1, "Select at least 1 interest").required().default([]),
    otherwise: yup2.array().nullable()
  }),
  ACCESS_CODE: yup2.string().when("ABOUT_US_REFERRAL", {
    is: AboutUsReferral.POF,
    then: yup2.string().notRequired(),
    otherwise: yup2.string().test("validate-access-code", "Invalid access code", validateAccessCode).nullable()
  }),
  SHOW_ACCESS_CODE_HELPER_TEXT: yup2.boolean().default(false)
});
var SIGNUP_PAGE_VALIDATION_MAP = {
  NAME: [
    "FIRST_NAME" /* FIRST_NAME */,
    "LAST_NAME" /* LAST_NAME */,
    "ABOUT_US_REFERRAL" /* ABOUT_US_REFERRAL */,
    "ACCESS_CODE" /* ACCESS_CODE */
  ],
  NPI_AND_CAREER: [
    "NPI_NUMBER" /* NPI_NUMBER */,
    "CAREER_STAGE" /* CAREER_STAGE */,
    "NOT_A_DOCTOR" /* NOT_A_DOCTOR */
  ],
  INTERESTS: ["INTERESTS" /* INTERESTS */],
  POF_INTRO: [],
  PREVIEW: [],
  COBRANDED_INTRO: []
};
var SIGNUP_TERMS_HEADER = `Earned Wealth Digital Properties User Agreement`;
var SIGNUP_STATE_MACHINE_CONFIG = {
  initialStep: "NAME",
  initialNavHistory: [],
  steps: {
    NAME: {
      choices: {
        POF_INTRO: {
          when: (fields) => fields["ABOUT_US_REFERRAL" /* ABOUT_US_REFERRAL */] === AboutUsReferral.POF
        },
        COBRANDED_INTRO: {
          when: (fields) => !(0, import_lodash2.isEmpty)(fields["ACCESS_CODE" /* ACCESS_CODE */])
        },
        NPI_AND_CAREER: {}
      }
    },
    NPI_AND_CAREER: {
      choices: {
        PREVIEW: {}
      }
    },
    PREVIEW: {
      isTerminal: true
    },
    POF_INTRO: {
      choices: {
        INTERESTS: {}
      }
    },
    INTERESTS: {
      choices: {
        NPI_AND_CAREER: {}
      }
    },
    COBRANDED_INTRO: {
      choices: {
        INTERESTS: {}
      }
    }
  }
};
var UMP_ACCESS_CODE = "UMP65010";
var JMMG_ACCESS_CODE = "JMMG";
var ECMA_ACCESS_CODE = "ECMA";
var SJMG_ACCESS_CODE = "SJMG";

// src/modules/signup/components/SignupWizard/SignupWizard.tsx
var React10 = __toESM(require("react"));
var import_react_hook_form7 = require("react-hook-form");

// src/modules/signup/components/SignupPageOne/SignupPageOne.tsx
var import_core12 = require("@earned/core");
var import_react_hook_form3 = require("react-hook-form");
var import_jsx_runtime20 = require("react/jsx-runtime");
var SignupPageOne = ({ showAboutUsReferralQuestion, showAccessCodeInput }) => {
  var _a, _b, _c, _d;
  const { register, formState, getValues } = (0, import_react_hook_form3.useFormContext)();
  const fields = getValues();
  return /* @__PURE__ */ (0, import_jsx_runtime20.jsxs)("div", { "data-testid": "signup-page-one", children: [
    /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
      import_core12.TextInput,
      {
        label: "First Name",
        ...register("FIRST_NAME" /* FIRST_NAME */),
        error: (_a = formState.errors["FIRST_NAME" /* FIRST_NAME */]) == null ? void 0 : _a.message
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
      import_core12.TextInput,
      {
        label: "Last Name",
        ...register("LAST_NAME" /* LAST_NAME */),
        error: (_b = formState.errors["LAST_NAME" /* LAST_NAME */]) == null ? void 0 : _b.message
      }
    ),
    showAboutUsReferralQuestion ? /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(QuestionBlock_default, { label: "How did you hear about us?", applyPadding: false, children: /* @__PURE__ */ (0, import_jsx_runtime20.jsxs)(
      import_core12.RadioGroup,
      {
        error: (_c = formState.errors["ABOUT_US_REFERRAL" /* ABOUT_US_REFERRAL */]) == null ? void 0 : _c.message,
        ...register("ABOUT_US_REFERRAL" /* ABOUT_US_REFERRAL */),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
            import_core12.Radio,
            {
              label: ABOUS_US_REFERRAL_MAPPING[AboutUsReferral.POF],
              value: AboutUsReferral.POF
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
            import_core12.Radio,
            {
              label: ABOUS_US_REFERRAL_MAPPING[AboutUsReferral.OTHER],
              value: AboutUsReferral.OTHER
            }
          )
        ]
      }
    ) }) : null,
    fields["ABOUT_US_REFERRAL" /* ABOUT_US_REFERRAL */] === AboutUsReferral.OTHER && showAccessCodeInput ? /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
      import_core12.TextInput,
      {
        label: "Do you have an access code? If so, enter it below.",
        ...register("ACCESS_CODE" /* ACCESS_CODE */),
        error: (_d = formState.errors["ACCESS_CODE" /* ACCESS_CODE */]) == null ? void 0 : _d.message,
        helperText: fields["SHOW_ACCESS_CODE_HELPER_TEXT" /* SHOW_ACCESS_CODE_HELPER_TEXT */] ? "We filled this code for you based on your email." : void 0
      }
    ) : null
  ] });
};
var SignupPageOne_default = SignupPageOne;

// src/modules/signup/components/SignupPageThree/SignupPageThree.tsx
var import_core13 = require("@earned/core");
var import_react_hook_form4 = require("react-hook-form");
var import_jsx_runtime21 = require("react/jsx-runtime");
var SignupPageThree = () => {
  var _a, _b;
  const { register, formState, control } = (0, import_react_hook_form4.useFormContext)();
  const notADoctor = (0, import_react_hook_form4.useWatch)({
    control,
    name: "NOT_A_DOCTOR" /* NOT_A_DOCTOR */
  });
  return /* @__PURE__ */ (0, import_jsx_runtime21.jsxs)("div", { "data-testid": "signup-page-three", children: [
    /* @__PURE__ */ (0, import_jsx_runtime21.jsx)("div", { className: "flex flex-col sm:flex-row sm:gap-4", children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)("div", { className: "w-full", children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
      import_core13.TextInput,
      {
        label: "NPI Number",
        ...register("NPI_NUMBER" /* NPI_NUMBER */),
        error: (_a = formState.errors["NPI_NUMBER" /* NPI_NUMBER */]) == null ? void 0 : _a.message,
        disabled: notADoctor
      }
    ) }) }),
    /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(QuestionBlock_default, { children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
      import_core13.Checkbox,
      {
        label: "I am not a doctor",
        ...register("NOT_A_DOCTOR" /* NOT_A_DOCTOR */)
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(QuestionBlock_default, { label: "What is your Career Stage?", children: /* @__PURE__ */ (0, import_jsx_runtime21.jsxs)(
      import_core13.RadioGroup,
      {
        error: (_b = formState.errors["CAREER_STAGE" /* CAREER_STAGE */]) == null ? void 0 : _b.message,
        ...register("CAREER_STAGE" /* CAREER_STAGE */),
        disabled: notADoctor,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
            import_core13.Radio,
            {
              label: CAREER_STAGE_MAPPING["MEDICAL_STUDENT" /* MEDICAL_STUDENT */],
              value: "MEDICAL_STUDENT" /* MEDICAL_STUDENT */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
            import_core13.Radio,
            {
              label: CAREER_STAGE_MAPPING["RESIDENT" /* RESIDENT */],
              value: "RESIDENT" /* RESIDENT */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
            import_core13.Radio,
            {
              label: CAREER_STAGE_MAPPING["PRACTICING_PHYSICIAN" /* PRACTICING_PHYSICIAN */],
              value: "PRACTICING_PHYSICIAN" /* PRACTICING_PHYSICIAN */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
            import_core13.Radio,
            {
              label: CAREER_STAGE_MAPPING["RETIRED_PHYSICIAN" /* RETIRED_PHYSICIAN */],
              value: "RETIRED_PHYSICIAN" /* RETIRED_PHYSICIAN */
            }
          )
        ]
      }
    ) })
  ] });
};
var SignupPageThree_default = SignupPageThree;

// src/modules/signup/components/SignupPageFour/SignupPageFour.tsx
var import_react_hook_form5 = require("react-hook-form");
var import_jsx_runtime22 = require("react/jsx-runtime");
var SignupPageFour = ({ onEditClick }) => {
  const { getValues } = (0, import_react_hook_form5.useFormContext)();
  const fields = getValues();
  return /* @__PURE__ */ (0, import_jsx_runtime22.jsx)("div", { "data-testid": "signup-page-four", children: /* @__PURE__ */ (0, import_jsx_runtime22.jsxs)("div", { className: "flex flex-col", children: [
    !fields["NOT_A_DOCTOR" /* NOT_A_DOCTOR */] && /* @__PURE__ */ (0, import_jsx_runtime22.jsxs)(ReviewBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
        ReviewList_default,
        {
          label: "NPI Number",
          value: formatters.string(fields["NPI_NUMBER" /* NPI_NUMBER */])
        }
      ),
      fields["SPECIALTY" /* SPECIALTY */] && /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
        ReviewList_default,
        {
          label: "Specialty",
          value: formatters.string(fields["SPECIALTY" /* SPECIALTY */])
        }
      ),
      fields["SUBSPECIALTY" /* SUBSPECIALTY */] && /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
        ReviewList_default,
        {
          label: "Subspecialty",
          value: formatters.string(fields["SUBSPECIALTY" /* SUBSPECIALTY */])
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
        ReviewList_default,
        {
          label: "Career Stage",
          value: formatters.careerStage(
            fields["CAREER_STAGE" /* CAREER_STAGE */]
          )
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime22.jsxs)(ReviewBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
        ReviewList_default,
        {
          label: "Name",
          value: renderFullName({
            first: fields["FIRST_NAME" /* FIRST_NAME */],
            last: fields["LAST_NAME" /* LAST_NAME */],
            placeholder: "--"
          })
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(ReviewEditLink_default, { onClick: onEditClick })
    ] })
  ] }) });
};
var SignupPageFour_default = SignupPageFour;

// src/modules/signup/components/SignupWizard/SignupWizard.tsx
var import_yup2 = require("@hookform/resolvers/yup");

// src/modules/signup/components/SignupPoFOne/SignupPoFOne.tsx
var import_core14 = require("@earned/core");
var import_jsx_runtime23 = require("react/jsx-runtime");
var SignupPoFOne = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime23.jsx)("div", { "data-testid": "signup-pof-one", className: "pb-8", children: /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(import_core14.Typography, { variant: "body", children: "Physician on FIRE is thrilled to recommend an innovative app tailored specifically for professionals like you. The Earned app offers intuitive budgeting and investment tools purpose-built for doctors, putting the power of financial management in your hands, while also keeping you informed with the latest Physician on FIRE content." }) });
};
var SignupPoFOne_default = SignupPoFOne;

// src/modules/signup/components/SignupInterests/SignupInterests.tsx
var import_core15 = require("@earned/core");
var import_react_hook_form6 = require("react-hook-form");
var import_jsx_runtime24 = require("react/jsx-runtime");
var SignupInterests = () => {
  var _a;
  const { register, formState } = (0, import_react_hook_form6.useFormContext)();
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsx)("div", { "data-testid": "signup-interests", children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(QuestionBlock_default, { label: "What topics are of greatest interest?", children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
    import_core15.CheckboxGroup,
    {
      ...register("INTERESTS" /* INTERESTS */),
      error: (_a = formState.errors["INTERESTS" /* INTERESTS */]) == null ? void 0 : _a.message,
      children: INTERESTS_OPTIONS.map((option) => /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
        import_core15.Checkbox,
        {
          label: option.label,
          value: option.value
        },
        option.value
      ))
    }
  ) }) });
};
var SignupInterests_default = SignupInterests;

// src/modules/signup/components/SignupWizard/SignupWizard.tsx
var import_pof_logo_small = __toESM(require("./pof-logo-small-DU5BN3XQ.png"));
var import_ump_logo_small = __toESM(require("./ump-logo-small-VE4UFYGN.png"));
var import_jmmg_logo_small = __toESM(require("./jmmg-logo-small-OGZSYMGS.png"));
var import_ecma_logo_small = __toESM(require("./ecma-logo-small-JUCMTCXS.png"));
var import_sjmg_logo_small = __toESM(require("./sjmg-logo-small-GUYPQUCS.png"));

// src/modules/state-machine/components/StateMachineWizardBase.tsx
var import_react2 = require("react");
var useStateMachineWizardBase = (stateMachineConfig, emitNavigationEvent) => {
  var _a;
  const initialNavHistory = ((_a = stateMachineConfig.initialNavHistory) == null ? void 0 : _a.length) ? stateMachineConfig.initialNavHistory : [stateMachineConfig.initialStep];
  const initialStepName = initialNavHistory[0];
  const [navHistory, updateNavHistory] = (0, import_react2.useState)(initialNavHistory);
  const [curStepName, setCurStepName] = (0, import_react2.useState)(
    initialNavHistory[initialNavHistory.length - 1]
  );
  const [beforeNavigateCallback, setBeforeNavigateCallback] = (0, import_react2.useState)(null);
  const registerBeforeNavigate = (0, import_react2.useCallback)(
    (callback) => {
      setBeforeNavigateCallback(() => callback);
    },
    []
  );
  const unregisterBeforeNavigate = (0, import_react2.useCallback)(() => {
    setBeforeNavigateCallback(null);
  }, []);
  const curStepPos = findStepPositionByName(navHistory, curStepName);
  const isFirstStep = curStepName === initialStepName;
  const isFinalStep = !!stateMachineConfig.steps[curStepName].isTerminal;
  const navigateTo = (0, import_react2.useCallback)(
    (step) => {
      const prevStep = curStepName;
      if (typeof step === "number") {
        const stepPos = curStepPos + step;
        if (stepPos < 0 || stepPos >= navHistory.length || navHistory[stepPos] === curStepName)
          return;
        const nextStep = navHistory[stepPos];
        setCurStepName(nextStep);
        updateNavHistory((prevNav) => prevNav.slice(0, stepPos + 1));
        emitNavigationEvent(prevStep, nextStep);
      } else {
        const stepPos = findStepPositionByName(navHistory, step);
        if (stepPos === -1) {
          setCurStepName(step);
          updateNavHistory((prevNav) => [...prevNav, step]);
          emitNavigationEvent(prevStep, step);
        } else if (navHistory[stepPos] !== curStepName) {
          setCurStepName(navHistory[stepPos]);
          updateNavHistory((prevNav) => prevNav.slice(0, stepPos + 1));
          emitNavigationEvent(prevStep, navHistory[stepPos]);
        }
      }
    },
    [curStepName, curStepPos, emitNavigationEvent, navHistory]
  );
  const determineNextStep = (stepName, wizardState) => {
    const stepMetadata = stateMachineConfig.steps[stepName];
    if (stepMetadata.isTerminal) {
      return void 0;
    }
    const availableTransitions = stepMetadata.choices;
    return Object.keys(availableTransitions).find(
      (transitionStepName) => {
        var _a2, _b, _c;
        return (
          // if when condition is not specified, this step is automatically selected as next
          // that's why it's recommended to define such fallback steps in the end of choices map
          !((_a2 = availableTransitions[transitionStepName]) == null ? void 0 : _a2.when) || !!((_c = (_b = availableTransitions[transitionStepName]) == null ? void 0 : _b.when) == null ? void 0 : _c.call(_b, wizardState))
        );
      }
    );
  };
  const goNext = async (wizardState) => {
    if (beforeNavigateCallback) {
      const shouldProceed = await beforeNavigateCallback(wizardState);
      if (!shouldProceed) {
        return;
      }
    }
    const nextStepName = determineNextStep(navHistory[curStepPos], wizardState);
    if (!nextStepName) {
      return;
    }
    if (curStepPos === navHistory.length - 1 || navHistory[curStepPos + 1] !== nextStepName) {
      const nextStepPos = findStepPositionByName(navHistory, nextStepName);
      if (nextStepPos === -1) {
        updateNavHistory(
          (prevNav) => prevNav.slice(0, curStepPos + 1).concat(nextStepName)
        );
      } else {
        updateNavHistory((prevNav) => prevNav.slice(0, nextStepPos + 1));
      }
    }
    const prevStep = curStepName;
    setCurStepName(nextStepName);
    emitNavigationEvent(prevStep, nextStepName);
  };
  const goBack = () => {
    navigateTo(-1);
  };
  const getNextStep = (wizardState) => {
    const nextStepName = determineNextStep(navHistory[curStepPos], wizardState);
    return nextStepName;
  };
  const getFormProgress = (wizardState) => {
    var _a2, _b;
    const calculateTotalPages = (startStep) => {
      const stepMetadata = stateMachineConfig.steps[startStep];
      if (stepMetadata.isTerminal) {
        return 1;
      }
      if (stepMetadata.skipProgress) {
        const nextStep2 = determineNextStep(startStep, wizardState);
        return nextStep2 ? calculateTotalPages(nextStep2) : 0;
      }
      const nextStep = determineNextStep(startStep, wizardState);
      return 1 + (nextStep ? calculateTotalPages(nextStep) : 0);
    };
    const calculateCurrentIndex = (startStep, targetStep) => {
      if (startStep === targetStep)
        return 0;
      const stepMetadata = stateMachineConfig.steps[startStep];
      if (stepMetadata.skipProgress) {
        const nextStep2 = determineNextStep(startStep, wizardState);
        return nextStep2 ? calculateCurrentIndex(nextStep2, targetStep) : 0;
      }
      const nextStep = determineNextStep(startStep, wizardState);
      if (!nextStep)
        return 0;
      return 1 + calculateCurrentIndex(nextStep, targetStep);
    };
    const totalPages = calculateTotalPages(initialStepName);
    if (totalPages <= 1)
      return 0;
    if (curStepName === initialStepName)
      return 0;
    let stepToUse = curStepName;
    if ((_a2 = stateMachineConfig.steps[curStepName]) == null ? void 0 : _a2.skipProgress) {
      for (let i = navHistory.length - 1; i >= 0; i--) {
        const step = navHistory[i];
        if (!((_b = stateMachineConfig.steps[step]) == null ? void 0 : _b.skipProgress)) {
          stepToUse = step;
          break;
        }
      }
    }
    const index = calculateCurrentIndex(initialStepName, stepToUse);
    return Math.min(index / (totalPages - 1), 1);
  };
  return {
    navHistory,
    navigateTo,
    goNext,
    goBack,
    curStepName,
    isFinalStep,
    isFirstStep,
    getNextStep,
    getFormProgress,
    registerBeforeNavigate,
    unregisterBeforeNavigate,
    updateNavHistory: (newHistory) => {
      updateNavHistory(newHistory);
      setCurStepName(newHistory[newHistory.length - 1]);
    }
  };
};
function findStepPositionByName(navHistory, stepName) {
  return navHistory.findIndex((navStepName) => navStepName === stepName);
}

// src/modules/state-machine/components/StateMachineWizard.ts
var React8 = __toESM(require("react"));
var useStateMachineWizard = (stateMachineConfig) => {
  const emitNavigationEvent = React8.useCallback(
    (from, to) => {
      const eventData = { from, to };
      window.dispatchEvent(
        new CustomEvent("wizardNavigation", {
          detail: eventData
        })
      );
    },
    []
  );
  return useStateMachineWizardBase(
    stateMachineConfig,
    emitNavigationEvent
  );
};

// src/modules/state-machine/context.tsx
var React9 = __toESM(require("react"));
var NavigationContext = React9.createContext({
  registerBeforeNavigate: () => void 0,
  unregisterBeforeNavigate: () => void 0
});
var useNavigationContext = () => {
  return React9.useContext(NavigationContext);
};

// src/modules/signup/components/SignupCobrandedIntro/SignupCobrandedIntro.tsx
var import_core16 = require("@earned/core");
var import_jsx_runtime25 = require("react/jsx-runtime");
var SignupCobrandedIntro = ({
  accessCode
}) => {
  const isUMP = accessCode === UMP_ACCESS_CODE;
  const isJMMG = accessCode === JMMG_ACCESS_CODE;
  const isECMA = accessCode === ECMA_ACCESS_CODE;
  const brand = isUMP ? "University Medical Partners" : isJMMG ? "John Muir Medical Group" : isECMA ? "El Camino Medical Associates" : "Earned";
  return /* @__PURE__ */ (0, import_jsx_runtime25.jsx)("div", { "data-testid": "signup-cobranded-intro", className: "pb-8", children: /* @__PURE__ */ (0, import_jsx_runtime25.jsxs)(import_core16.Typography, { variant: "body", children: [
    brand,
    " is thrilled to recommend an innovative app tailored specifically for professionals like you. The Earned app offers intuitive budgeting and investment tools purpose-built for doctors, putting the power of financial management in your hands."
  ] }) });
};
var SignupCobrandedIntro_default = SignupCobrandedIntro;

// src/modules/signup/components/SignupWizard/SignupWizard.tsx
var import_lodash3 = require("lodash");
var import_jsx_runtime26 = require("react/jsx-runtime");
var SignupWizard = ({
  isOpen,
  close,
  onFieldChange,
  onPageChange,
  onSubmit,
  isLoading = false,
  isSubmitting = false,
  modalRootSelector = "body",
  cache,
  showAboutUsReferralQuestion,
  initialNavHistory,
  showAccessCodeInput
}) => {
  const stateMachineConfig = React10.useMemo(
    () => ({
      ...SIGNUP_STATE_MACHINE_CONFIG,
      initialNavHistory
    }),
    [initialNavHistory]
  );
  const {
    curStepName,
    isFirstStep,
    isFinalStep,
    navigateTo,
    goNext,
    goBack,
    getFormProgress,
    navHistory
  } = useStateMachineWizard(stateMachineConfig);
  const nextLabel = React10.useMemo(
    () => isFinalStep ? "Submit" : "Next",
    [isFinalStep]
  );
  const methods = (0, import_react_hook_form7.useForm)({
    values: cache ? SIGNUP_FORM_SCHEMA.cast(cache) : void 0,
    mode: "onChange",
    resolver: (0, import_yup2.yupResolver)(SIGNUP_FORM_SCHEMA)
  });
  const { getValues, handleSubmit: submit, trigger, watch } = methods;
  const fieldValues = getValues();
  const progress = getFormProgress(fieldValues);
  const aboutUsReferral = fieldValues["ABOUT_US_REFERRAL" /* ABOUT_US_REFERRAL */];
  const accessCode = fieldValues["ACCESS_CODE" /* ACCESS_CODE */];
  const handleSubmit = React10.useCallback(
    (fields) => {
      trigger().then((isValid) => {
        if (!isValid)
          return;
        if (!(0, import_lodash3.isEmpty)(accessCode)) {
          if (accessCode === UMP_ACCESS_CODE) {
            fields["ABOUT_US_REFERRAL" /* ABOUT_US_REFERRAL */] = AboutUsReferral.UMP;
          } else if (accessCode === JMMG_ACCESS_CODE) {
            fields["ABOUT_US_REFERRAL" /* ABOUT_US_REFERRAL */] = AboutUsReferral.JMMG;
          } else if (accessCode === ECMA_ACCESS_CODE) {
            fields["ABOUT_US_REFERRAL" /* ABOUT_US_REFERRAL */] = AboutUsReferral.ECMA;
          } else if (accessCode === SJMG_ACCESS_CODE) {
            fields["ABOUT_US_REFERRAL" /* ABOUT_US_REFERRAL */] = AboutUsReferral.SJMG;
          }
        }
        onSubmit(fields);
      });
    },
    [accessCode, onSubmit, trigger]
  );
  const handleNext = React10.useCallback(() => {
    trigger(SIGNUP_PAGE_VALIDATION_MAP[curStepName]).then((valid) => {
      if (valid)
        goNext(fieldValues);
    });
  }, [curStepName, trigger, fieldValues, goNext]);
  React10.useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      const fields = value;
      const key = name;
      if (onFieldChange)
        onFieldChange({ key, value: fields[key] });
    });
    return () => subscription.unsubscribe();
  }, [watch, onFieldChange]);
  React10.useEffect(() => {
    if (onPageChange)
      onPageChange(curStepName, navHistory);
  }, [curStepName, onPageChange, navHistory]);
  const formTitle = React10.useMemo(() => {
    return getFormTitle(curStepName, isFinalStep, aboutUsReferral, accessCode);
  }, [curStepName, isFinalStep, aboutUsReferral, accessCode]);
  const renderPages = React10.useCallback(() => {
    switch (curStepName) {
      case "NAME":
        return /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
          SignupPageOne_default,
          {
            showAboutUsReferralQuestion,
            showAccessCodeInput
          }
        );
      case "NPI_AND_CAREER":
        return /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(SignupPageThree_default, {});
      case "PREVIEW":
        return /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(SignupPageFour_default, { onEditClick: () => navigateTo("NAME") });
      case "POF_INTRO":
        return /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(SignupPoFOne_default, {});
      case "INTERESTS":
        return /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(SignupInterests_default, {});
      case "COBRANDED_INTRO":
        return /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(SignupCobrandedIntro_default, { accessCode });
    }
  }, [
    curStepName,
    showAboutUsReferralQuestion,
    showAccessCodeInput,
    accessCode,
    navigateTo
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("div", { "data-testid": "signup-wizard", children: /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
    Modal_default,
    {
      title: formTitle.title,
      titleIcon: formTitle.isPoF ? /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("img", { src: import_pof_logo_small.default.src, style: { width: "16px", height: "24px" } }) : formTitle.isUMP ? /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("img", { src: import_ump_logo_small.default.src, style: { width: "24px", height: "27px" } }) : formTitle.isJM ? /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("img", { src: import_jmmg_logo_small.default.src, style: { width: "24px", height: "27px" } }) : formTitle.isECMA ? /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("img", { src: import_ecma_logo_small.default.src, style: { width: "24px", height: "27px" } }) : formTitle.isSJMG ? /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("img", { src: import_sjmg_logo_small.default.src, style: { width: "24px", height: "27px" } }) : null,
      subtitle: isFirstStep ? "We need a few more details to get you set up on the platform." : isFinalStep ? "Please review the following information before submitting." : void 0,
      open: isOpen,
      close,
      progressPercentage: isLoading ? 0 : progress,
      showProgressBar: true,
      rootSelector: modalRootSelector,
      children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("div", { className: "flex flex-row justify-center", children: /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(LoadingIndicator_default, {}) }) : /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(import_react_hook_form7.FormProvider, { ...methods, children: /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)("form", { onSubmit: submit(handleSubmit), children: [
        renderPages(),
        /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
          Footer_default,
          {
            onNextClick: handleNext,
            onPreviousClick: goBack,
            nextDisabled: isSubmitting,
            showPrevious: !isFirstStep,
            submitMode: isFinalStep,
            nextLabel,
            submitting: isFinalStep && isSubmitting
          }
        )
      ] }) })
    }
  ) });
};
var SignupWizard_default = SignupWizard;

// src/modules/profile/components/ProfileWizard/ProfileWizard.tsx
var import_core25 = require("@earned/core");

// src/modules/profile/constants.ts
var PROFILE_PAYLOAD_SCHEMA = yup_extend_default.object({
  client: yup_extend_default.object({
    ["IS_PRIMARY_CLIENT" /* IS_PRIMARY_CLIENT */]: yup_extend_default.boolean().default(true),
    ["FIRST_NAME" /* FIRST_NAME */]: yup_extend_default.string(),
    ["LAST_NAME" /* LAST_NAME */]: yup_extend_default.string(),
    ["EMAIL" /* EMAIL */]: yup_extend_default.string(),
    ["PHONE_NUMBER" /* PHONE_NUMBER */]: yup_extend_default.string().transform(transformers.payload.phone),
    ["SSN" /* SSN */]: yup_extend_default.string().transform(transformers.payload.ssn),
    ["DOB" /* DOB */]: yup_extend_default.string().transform((value) => transformers.payload.date(value)),
    ["NPI_NUMBER" /* NPI_NUMBER */]: yup_extend_default.string(),
    ["SPECIALTY" /* SPECIALTY */]: yup_extend_default.string(),
    ["CAREER_STAGE" /* CAREER_STAGE */]: yup_extend_default.string(),
    ["EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */]: yup_extend_default.string(),
    ["EMPLOYER_NAME" /* EMPLOYER_NAME */]: yup_extend_default.string(),
    ["SOURCE_INCOME" /* SOURCE_INCOME */]: yup_extend_default.string(),
    ["EMPLOYER_ADDRESS_STREET" /* EMPLOYER_ADDRESS_STREET */]: yup_extend_default.string(),
    ["EMPLOYER_ADDRESS_STREET_2" /* EMPLOYER_ADDRESS_STREET_2 */]: yup_extend_default.string(),
    ["EMPLOYER_ADDRESS_CITY" /* EMPLOYER_ADDRESS_CITY */]: yup_extend_default.string(),
    ["EMPLOYER_ADDRESS_STATE" /* EMPLOYER_ADDRESS_STATE */]: yup_extend_default.string(),
    ["EMPLOYER_ADDRESS_ZIP" /* EMPLOYER_ADDRESS_ZIP */]: yup_extend_default.string(),
    ["ADDRESS_STATE" /* ADDRESS_STATE */]: yup_extend_default.string(),
    ["ADDRESS_CITY" /* ADDRESS_CITY */]: yup_extend_default.string(),
    ["ADDRESS_STREET" /* ADDRESS_STREET */]: yup_extend_default.string(),
    ["ADDRESS_STREET_2" /* ADDRESS_STREET_2 */]: yup_extend_default.string(),
    ["ADDRESS_ZIP" /* ADDRESS_ZIP */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_STATE" /* MAILING_ADDRESS_STATE */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_CITY" /* MAILING_ADDRESS_CITY */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_STREET" /* MAILING_ADDRESS_STREET */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_STREET_2" /* MAILING_ADDRESS_STREET_2 */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_ZIP" /* MAILING_ADDRESS_ZIP */]: yup_extend_default.string(),
    ["TOTAL_ASSETS" /* TOTAL_ASSETS */]: yup_extend_default.number().fromCurrency(),
    ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.number().fromCurrency(),
    ["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */]: yup_extend_default.string(),
    ["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */]: yup_extend_default.string().transform((value) => transformers.payload.date(value)),
    ["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]: yup_extend_default.string()
  }),
  coClient: yup_extend_default.object({
    ["IS_PRIMARY_CLIENT" /* IS_PRIMARY_CLIENT */]: yup_extend_default.boolean(),
    ["EMAIL" /* EMAIL */]: yup_extend_default.string(),
    ["PHONE_NUMBER" /* PHONE_NUMBER */]: yup_extend_default.string().transform(transformers.payload.phone),
    ["FIRST_NAME" /* FIRST_NAME */]: yup_extend_default.string(),
    ["LAST_NAME" /* LAST_NAME */]: yup_extend_default.string(),
    ["SSN" /* SSN */]: yup_extend_default.string().transform(transformers.payload.ssn),
    ["DOB" /* DOB */]: yup_extend_default.string().transform((value) => transformers.payload.date(value)),
    ["EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */]: yup_extend_default.string(),
    ["OCCUPATION" /* OCCUPATION */]: yup_extend_default.string(),
    ["EMPLOYER_NAME" /* EMPLOYER_NAME */]: yup_extend_default.string(),
    ["ADDRESS_STATE" /* ADDRESS_STATE */]: yup_extend_default.string(),
    ["ADDRESS_CITY" /* ADDRESS_CITY */]: yup_extend_default.string(),
    ["ADDRESS_STREET" /* ADDRESS_STREET */]: yup_extend_default.string(),
    ["ADDRESS_STREET_2" /* ADDRESS_STREET_2 */]: yup_extend_default.string(),
    ["ADDRESS_ZIP" /* ADDRESS_ZIP */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_STATE" /* MAILING_ADDRESS_STATE */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_CITY" /* MAILING_ADDRESS_CITY */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_STREET" /* MAILING_ADDRESS_STREET */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_STREET_2" /* MAILING_ADDRESS_STREET_2 */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_ZIP" /* MAILING_ADDRESS_ZIP */]: yup_extend_default.string(),
    ["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */]: yup_extend_default.string(),
    ["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */]: yup_extend_default.string().transform((value) => transformers.payload.date(value)),
    ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.number().fromCurrency(),
    ["TOTAL_ASSETS" /* TOTAL_ASSETS */]: yup_extend_default.number().fromCurrency(),
    ["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]: yup_extend_default.string()
  }).default(void 0)
});
var PROFILE_FORM_SCHEMA = yup_extend_default.object({
  ["ADD_CO_CLIENT" /* ADD_CO_CLIENT */]: yup_extend_default.string().default("NO"),
  client: yup_extend_default.object({
    /**********  read-only fields *******/
    ["IS_PRIMARY_CLIENT" /* IS_PRIMARY_CLIENT */]: yup_extend_default.boolean(),
    ["FIRST_NAME" /* FIRST_NAME */]: yup_extend_default.string(),
    ["LAST_NAME" /* LAST_NAME */]: yup_extend_default.string(),
    ["EMAIL" /* EMAIL */]: yup_extend_default.string(),
    ["PHONE_NUMBER" /* PHONE_NUMBER */]: yup_extend_default.string().transform(transformers.form.phone),
    ["NPI_NUMBER" /* NPI_NUMBER */]: yup_extend_default.string(),
    ["SPECIALTY" /* SPECIALTY */]: yup_extend_default.string(),
    ["CAREER_STAGE" /* CAREER_STAGE */]: yup_extend_default.string(),
    ["ADDRESS_STATE" /* ADDRESS_STATE */]: yup_extend_default.string(),
    ["ADDRESS_CITY" /* ADDRESS_CITY */]: yup_extend_default.string(),
    ["ADDRESS_STREET" /* ADDRESS_STREET */]: yup_extend_default.string(),
    ["ADDRESS_STREET_2" /* ADDRESS_STREET_2 */]: yup_extend_default.string(),
    ["ADDRESS_ZIP" /* ADDRESS_ZIP */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_STATE" /* MAILING_ADDRESS_STATE */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_CITY" /* MAILING_ADDRESS_CITY */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_STREET" /* MAILING_ADDRESS_STREET */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_STREET_2" /* MAILING_ADDRESS_STREET_2 */]: yup_extend_default.string(),
    /************************************/
    ["SSN" /* SSN */]: yup_extend_default.string().transform(transformers.form.ssn).test("ssn", "Invalid SSN", validators.ssn),
    ["DOB" /* DOB */]: yup_extend_default.string().transform(transformers.form.date).test("dob", "Invalid date of birth", validators.date),
    ["EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */]: yup_extend_default.string().nullable().required("Employment status is required"),
    ["EMPLOYER_NAME" /* EMPLOYER_NAME */]: yup_extend_default.string().when("EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */, {
      is: "EMPLOYED" /* EMPLOYED */,
      then: (schema) => schema.required("Employer name is required")
    }),
    ["SOURCE_INCOME" /* SOURCE_INCOME */]: yup_extend_default.string(),
    ["PROVIDE_EMPLOYER_ADDRESS" /* PROVIDE_EMPLOYER_ADDRESS */]: yup_extend_default.string().default("NO"),
    ["EMPLOYER_ADDRESS_STREET" /* EMPLOYER_ADDRESS_STREET */]: yup_extend_default.string().when("PROVIDE_EMPLOYER_ADDRESS" /* PROVIDE_EMPLOYER_ADDRESS */, {
      is: "YES",
      then: (schema) => schema.required("Street name is required")
    }),
    ["EMPLOYER_ADDRESS_STREET_2" /* EMPLOYER_ADDRESS_STREET_2 */]: yup_extend_default.string(),
    ["EMPLOYER_ADDRESS_CITY" /* EMPLOYER_ADDRESS_CITY */]: yup_extend_default.string().when("PROVIDE_EMPLOYER_ADDRESS" /* PROVIDE_EMPLOYER_ADDRESS */, {
      is: "YES",
      then: (schema) => schema.required("City is required")
    }),
    ["EMPLOYER_ADDRESS_STATE" /* EMPLOYER_ADDRESS_STATE */]: yup_extend_default.string().when("PROVIDE_EMPLOYER_ADDRESS" /* PROVIDE_EMPLOYER_ADDRESS */, {
      is: "YES",
      then: (schema) => schema.required("State is required")
    }),
    ["EMPLOYER_ADDRESS_ZIP" /* EMPLOYER_ADDRESS_ZIP */]: yup_extend_default.string().when("PROVIDE_EMPLOYER_ADDRESS" /* PROVIDE_EMPLOYER_ADDRESS */, {
      is: "YES",
      then: (schema) => schema.required("ZIP code is required")
    }),
    ["TOTAL_ASSETS" /* TOTAL_ASSETS */]: yup_extend_default.string().currency().required("This field is required"),
    ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.string().currency().required("This field is required"),
    ["NO_LICENSE" /* NO_LICENSE */]: yup_extend_default.boolean().default(false),
    ["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */]: yup_extend_default.string().when("NO_LICENSE" /* NO_LICENSE */, {
      is: false,
      then: (schema) => schema.required("Driver's license number is required")
    }),
    ["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */]: yup_extend_default.string().transform(transformers.form.date).when("NO_LICENSE" /* NO_LICENSE */, {
      is: false,
      then: (schema) => schema.test(
        "client-dl-exp",
        "Invalid expiration date",
        validators.date
      )
    }),
    ["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]: yup_extend_default.string().when("NO_LICENSE" /* NO_LICENSE */, {
      is: false,
      then: (schema) => schema.required("Driver's license state is required")
    })
  }),
  coClient: yup_extend_default.object({
    ["IS_PRIMARY_CLIENT" /* IS_PRIMARY_CLIENT */]: yup_extend_default.boolean().default(false),
    ["FIRST_NAME" /* FIRST_NAME */]: yup_extend_default.string(),
    ["LAST_NAME" /* LAST_NAME */]: yup_extend_default.string(),
    ["EMAIL" /* EMAIL */]: yup_extend_default.string().email("Invalid email address"),
    ["PHONE_NUMBER" /* PHONE_NUMBER */]: yup_extend_default.string().transform(transformers.form.phone),
    ["SSN" /* SSN */]: yup_extend_default.string().transform(transformers.form.ssn).test("co-client-ssn", "Invalid SSN", validators.ssn),
    ["DOB" /* DOB */]: yup_extend_default.string().transform(transformers.form.date).test("co-client-dob", "Invalid birth date", validators.date),
    ["SAME_AS_MAILING" /* SAME_AS_MAILING */]: yup_extend_default.boolean().default(true),
    ["ADDRESS_STREET" /* ADDRESS_STREET */]: yup_extend_default.string(),
    ["ADDRESS_STREET_2" /* ADDRESS_STREET_2 */]: yup_extend_default.string(),
    ["ADDRESS_CITY" /* ADDRESS_CITY */]: yup_extend_default.string(),
    ["ADDRESS_STATE" /* ADDRESS_STATE */]: yup_extend_default.string(),
    ["ADDRESS_ZIP" /* ADDRESS_ZIP */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_STREET" /* MAILING_ADDRESS_STREET */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_STREET_2" /* MAILING_ADDRESS_STREET_2 */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_CITY" /* MAILING_ADDRESS_CITY */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_STATE" /* MAILING_ADDRESS_STATE */]: yup_extend_default.string(),
    ["MAILING_ADDRESS_ZIP" /* MAILING_ADDRESS_ZIP */]: yup_extend_default.string(),
    ["EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */]: yup_extend_default.string().required("Employment status is required"),
    ["EMPLOYER_NAME" /* EMPLOYER_NAME */]: yup_extend_default.string().when("EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */, {
      is: "EMPLOYED" /* EMPLOYED */,
      then: (schema) => schema.required("Employer name is required")
    }),
    ["OCCUPATION" /* OCCUPATION */]: yup_extend_default.string().when("EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */, {
      is: "EMPLOYED" /* EMPLOYED */,
      then: (schema) => schema.required("Occupation is required")
    }),
    ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.string().currency().required("This field is required"),
    ["TOTAL_ASSETS" /* TOTAL_ASSETS */]: yup_extend_default.string().currency().required("This field is required"),
    ["NO_LICENSE" /* NO_LICENSE */]: yup_extend_default.boolean().default(false),
    ["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */]: yup_extend_default.string().when("NO_LICENSE" /* NO_LICENSE */, {
      is: false,
      then: (schema) => schema.required("Driver's license number is required")
    }),
    ["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */]: yup_extend_default.string().transform(transformers.form.date).when("NO_LICENSE" /* NO_LICENSE */, {
      is: false,
      then: (schema) => schema.test(
        "co-client-dl-exp",
        "Invalid expiration date",
        validators.date
      )
    }),
    ["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]: yup_extend_default.string().when("NO_LICENSE" /* NO_LICENSE */, {
      is: false,
      then: (schema) => schema.required("Driver's license state is required")
    })
  }).optional().default(void 0)
});
var PROFILE_COCLIENT_FORM_SCHEMA = PROFILE_FORM_SCHEMA.shape({
  client: yup_extend_default.object()
});
var PROFILE_PAGE_VALIDATION_MAP = {
  0: ["client.SSN", "client.DOB"],
  1: [
    "client.EMPLOYMENT_STATUS",
    "client.EMPLOYER_NAME",
    "client.EMPLOYER_ADDRESS_STREET",
    "client.EMPLOYER_ADDRESS_STREET_2",
    "client.EMPLOYER_ADDRESS_CITY",
    "client.EMPLOYER_ADDRESS_STATE",
    "client.EMPLOYER_ADDRESS_ZIP"
  ],
  2: ["client.ANNUAL_INCOME", "client.TOTAL_ASSETS"],
  3: [
    "client.DRIVER_LICENSE_NUMBER",
    "client.DRIVER_LICENSE_STATE",
    "client.DRIVER_LICENSE_EXP"
  ],
  4: [],
  5: [
    "coClient.FIRST_NAME",
    "coClient.LAST_NAME",
    "coClient.EMAIL",
    "coClient.PHONE_NUMBER",
    "coClient.SSN",
    "coClient.DOB"
  ],
  6: [
    "coClient.ADDRESS_STREET",
    "coClient.ADDRESS_STREET_2",
    "coClient.ADDRESS_CITY",
    "coClient.ADDRESS_STATE",
    "coClient.ADDRESS_ZIP",
    "coClient.MAILING_ADDRESS_STREET",
    "coClient.MAILING_ADDRESS_STREET_2",
    "coClient.MAILING_ADDRESS_CITY",
    "coClient.MAILING_ADDRESS_STATE",
    "coClient.MAILING_ADDRESS_ZIP"
  ],
  7: [
    "coClient.EMPLOYMENT_STATUS",
    "coClient.EMPLOYER_NAME",
    "coClient.OCCUPATION"
  ],
  8: [
    "coClient.DRIVER_LICENSE_NUMBER",
    "coClient.DRIVER_LICENSE_STATE",
    "coClient.DRIVER_LICENSE_EXP"
  ],
  9: [],
  10: []
};
var PROFILE_CLIENT_PAGE_COUNT = 5;
var PROFILE_CLIENT_PAGE_VALIDATION_MAP = {
  0: ["client.SSN", "client.DOB"],
  1: [
    "client.EMPLOYMENT_STATUS",
    "client.EMPLOYER_NAME",
    "client.EMPLOYER_ADDRESS_STREET",
    "client.EMPLOYER_ADDRESS_STREET_2",
    "client.EMPLOYER_ADDRESS_CITY",
    "client.EMPLOYER_ADDRESS_STATE",
    "client.EMPLOYER_ADDRESS_ZIP"
  ],
  2: ["client.ANNUAL_INCOME", "client.TOTAL_ASSETS"],
  3: [
    "client.DRIVER_LICENSE_NUMBER",
    "client.DRIVER_LICENSE_STATE",
    "client.DRIVER_LICENSE_EXP"
  ],
  4: []
  // Review
};
var PROFILE_COCLIENT_PAGE_COUNT = 5;
var PROFILE_COCLIENT_PAGE_VALIDATION_MAP = {
  0: ["coClient.SSN", "coClient.DOB"],
  1: [
    "coClient.EMPLOYMENT_STATUS",
    "coClient.EMPLOYER_NAME",
    "coClient.OCCUPATION"
  ],
  2: ["coClient.ANNUAL_INCOME", "coClient.TOTAL_ASSETS"],
  3: [
    "coClient.DRIVER_LICENSE_NUMBER",
    "coClient.DRIVER_LICENSE_STATE",
    "coClient.DRIVER_LICENSE_EXP"
  ],
  4: []
  // Review
};

// src/modules/profile/components/ProfileWizard/ProfileWizard.tsx
var React13 = __toESM(require("react"));

// src/modules/profile/components/ProfilePageOne/ProfilePageOne.tsx
var import_core17 = require("@earned/core");
var import_react_hook_form8 = require("react-hook-form");
var import_jsx_runtime27 = require("react/jsx-runtime");
var ProfilePageOne = ({
  register,
  control
}) => {
  register("client.SSN");
  register("client.DOB");
  return /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("div", { "data-testid": "profile-page-one", children: /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)("div", { className: "flex flex-col sm:flex-row sm:gap-control-gap", children: [
    /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
      import_react_hook_form8.Controller,
      {
        control,
        name: "client.SSN",
        render: ({ field, formState }) => {
          var _a, _b;
          return /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
            import_core17.TextInput,
            {
              label: "Social Security #",
              error: (_b = (_a = formState.errors.client) == null ? void 0 : _a.SSN) == null ? void 0 : _b.message,
              placeholder: "XXX-XX-XXXX",
              maskOptions: {
                mask: "999-99-9999",
                maskChar: ""
              },
              ...field
            }
          );
        }
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
      import_react_hook_form8.Controller,
      {
        control,
        name: "client.DOB",
        render: ({ field, formState }) => {
          var _a, _b;
          return /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
            import_core17.TextInput,
            {
              label: "Date of Birth",
              placeholder: "mm/dd/yyyy",
              error: (_b = (_a = formState.errors.client) == null ? void 0 : _a.DOB) == null ? void 0 : _b.message,
              maskOptions: {
                mask: "99/99/9999",
                maskChar: ""
              },
              ...field
            }
          );
        }
      }
    ) })
  ] }) });
};
var ProfilePageOne_default = ProfilePageOne;

// src/modules/profile/components/ProfileWizard/ProfileWizard.tsx
var import_react_hook_form12 = require("react-hook-form");

// src/modules/profile/components/ProfilePageTwo/ProfilePageTwo.tsx
var import_core18 = require("@earned/core");
var import_jsx_runtime28 = require("react/jsx-runtime");
var ProfilePageTwo = ({
  register,
  formState,
  showEmployerNameField,
  showEmployerAddressField,
  showSourceOfIncome,
  fields,
  setValue
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  register("client.EMPLOYER_ADDRESS_STATE");
  return /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)("div", { "data-testid": "profile-page-two", children: [
    /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(QuestionBlock_default, { label: "What is your Employment Status?", children: /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)(
      import_core18.RadioGroup,
      {
        ...register("client.EMPLOYMENT_STATUS"),
        error: (_b = (_a = formState.errors.client) == null ? void 0 : _a.EMPLOYMENT_STATUS) == null ? void 0 : _b.message,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_core18.Radio, { value: "EMPLOYED" /* EMPLOYED */, label: "Employed" }),
          /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_core18.Radio, { value: "NOT_EMPLOYED" /* NOT_EMPLOYED */, label: "Not Employed" }),
          /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_core18.Radio, { value: "RETIRED" /* RETIRED */, label: "Retired" })
        ]
      }
    ) }),
    showEmployerNameField && /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)(QuestionBlock_default, { applyIndent: true, children: [
      /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
        import_core18.TextInput,
        {
          label: "Employer's Name",
          error: (_d = (_c = formState.errors.client) == null ? void 0 : _c.EMPLOYER_NAME) == null ? void 0 : _d.message,
          ...register("client.EMPLOYER_NAME")
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(QuestionBlock_default, { label: "Would you like to provide your employer's address? (optional)", children: /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)(import_core18.RadioGroup, { ...register("client.PROVIDE_EMPLOYER_ADDRESS"), children: [
        /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_core18.Radio, { label: "Yes", value: "YES" }),
        /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_core18.Radio, { label: "No", value: "NO" })
      ] }) }),
      showEmployerAddressField && /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)(QuestionBlock_default, { applyPadding: false, children: [
        /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
          import_core18.TextInput,
          {
            label: "Street",
            autoComplete: "none",
            error: (_f = (_e = formState.errors.client) == null ? void 0 : _e.EMPLOYER_ADDRESS_STREET) == null ? void 0 : _f.message,
            ...register("client.EMPLOYER_ADDRESS_STREET")
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
          import_core18.TextInput,
          {
            label: "Apt / Suite (optional)",
            autoComplete: "none",
            ...register("client.EMPLOYER_ADDRESS_STREET_2")
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
          import_core18.TextInput,
          {
            label: "City",
            autoComplete: "none",
            error: (_h = (_g = formState.errors.client) == null ? void 0 : _g.EMPLOYER_ADDRESS_CITY) == null ? void 0 : _h.message,
            ...register("client.EMPLOYER_ADDRESS_CITY")
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)("div", { className: "flex flex-col sm:flex-row sm:gap-4", children: [
          /* @__PURE__ */ (0, import_jsx_runtime28.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
            import_core18.SelectBox,
            {
              label: "State",
              autoComplete: "none",
              options: US_STATE_OPTIONS_OPTIONAL,
              error: (_j = (_i = formState.errors.client) == null ? void 0 : _i.EMPLOYER_ADDRESS_STATE) == null ? void 0 : _j.message,
              selected: US_STATE_OPTIONS_OPTIONAL.find(
                (opt) => opt.value === fields.client["EMPLOYER_ADDRESS_STATE" /* EMPLOYER_ADDRESS_STATE */]
              ) || US_STATE_OPTIONS_OPTIONAL[0],
              onChange: (selected) => {
                setValue(
                  "client.EMPLOYER_ADDRESS_STATE",
                  selected.value,
                  { shouldValidate: true }
                );
              }
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime28.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
            import_core18.TextInput,
            {
              autoComplete: "none",
              label: "ZIP Code",
              error: (_l = (_k = formState.errors.client) == null ? void 0 : _k.EMPLOYER_ADDRESS_ZIP) == null ? void 0 : _l.message,
              ...register("client.EMPLOYER_ADDRESS_ZIP")
            }
          ) })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
          import_core18.SelectBox,
          {
            onChange: () => null,
            label: "Country",
            disabled: true,
            options: [
              {
                id: "usa",
                label: "United States of America",
                value: "USA"
              }
            ],
            selected: {
              id: "usa",
              label: "United States of America",
              value: "USA"
            }
          }
        )
      ] })
    ] }),
    showSourceOfIncome && /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(QuestionBlock_default, { applyIndent: true, children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
      import_core18.TextInput,
      {
        label: "Source of Income (optional)",
        ...register("client.SOURCE_INCOME")
      }
    ) })
  ] });
};
var ProfilePageTwo_default = ProfilePageTwo;

// src/modules/profile/components/ProfilePageThree/ProfilePageThree.tsx
var import_core19 = require("@earned/core");
var import_jsx_runtime29 = require("react/jsx-runtime");
var ProfilePageThree = ({
  register,
  formState,
  fieldPrefix = "client"
}) => {
  var _a, _b;
  const errors = formState.errors[fieldPrefix];
  return /* @__PURE__ */ (0, import_jsx_runtime29.jsx)("div", { "data-testid": "profile-page-three", children: /* @__PURE__ */ (0, import_jsx_runtime29.jsxs)("div", { className: "flex flex-col sm:flex-row sm:gap-control-gap", children: [
    /* @__PURE__ */ (0, import_jsx_runtime29.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
      import_core19.TextInput,
      {
        label: "Annual Income",
        type: "currency",
        error: (_a = errors == null ? void 0 : errors.ANNUAL_INCOME) == null ? void 0 : _a.message,
        ...register(`${fieldPrefix}.ANNUAL_INCOME`)
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime29.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
      import_core19.TextInput,
      {
        label: "Total Assets",
        type: "currency",
        error: (_b = errors == null ? void 0 : errors.TOTAL_ASSETS) == null ? void 0 : _b.message,
        ...register(`${fieldPrefix}.TOTAL_ASSETS`)
      }
    ) })
  ] }) });
};
var ProfilePageThree_default = ProfilePageThree;

// src/modules/profile/components/ProfilePageFour/ProfilePageFour.tsx
var import_core20 = require("@earned/core");
var import_react_hook_form9 = require("react-hook-form");
var import_jsx_runtime30 = require("react/jsx-runtime");
var ProfilePageFour = ({
  register,
  disableFields,
  fields,
  formState,
  setValue,
  control
}) => {
  var _a, _b, _c, _d;
  register("client.DRIVER_LICENSE_STATE");
  register("client.DRIVER_LICENSE_EXP");
  return /* @__PURE__ */ (0, import_jsx_runtime30.jsxs)("div", { "data-testid": "profile-page-four", children: [
    /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
      import_core20.TextInput,
      {
        label: "Driver's License Number",
        disabled: disableFields,
        error: (_b = (_a = formState.errors.client) == null ? void 0 : _a.DRIVER_LICENSE_NUMBER) == null ? void 0 : _b.message,
        ...register("client.DRIVER_LICENSE_NUMBER")
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime30.jsxs)("div", { className: "flex flex-col sm:flex-row sm:gap-control-gap", children: [
      /* @__PURE__ */ (0, import_jsx_runtime30.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
        import_react_hook_form9.Controller,
        {
          control,
          name: "client.DRIVER_LICENSE_EXP",
          render: ({ field, formState: formState2 }) => {
            var _a2, _b2;
            return /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
              import_core20.TextInput,
              {
                label: "Driver's License Expiration Date",
                placeholder: "mm/dd/yyyy",
                disabled: disableFields,
                error: (_b2 = (_a2 = formState2.errors.client) == null ? void 0 : _a2.DRIVER_LICENSE_EXP) == null ? void 0 : _b2.message,
                maskOptions: {
                  mask: "99/99/9999",
                  maskChar: ""
                },
                ...field
              }
            );
          }
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime30.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
        import_core20.SelectBox,
        {
          label: "Driver's License State",
          disabled: disableFields,
          options: US_STATE_OPTIONS_OPTIONAL,
          error: (_d = (_c = formState.errors.client) == null ? void 0 : _c.DRIVER_LICENSE_STATE) == null ? void 0 : _d.message,
          selected: US_STATE_OPTIONS_OPTIONAL.find(
            (opt) => {
              var _a2;
              return opt.value === ((_a2 = fields.client) == null ? void 0 : _a2["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]);
            }
          ) || US_STATE_OPTIONS_OPTIONAL[0],
          onChange: (selected) => {
            setValue("client.DRIVER_LICENSE_STATE", selected.value, {
              shouldValidate: true
            });
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
      import_core20.Checkbox,
      {
        label: "I don't have a driver's license",
        ...register("client.NO_LICENSE")
      }
    )
  ] });
};
var ProfilePageFour_default = ProfilePageFour;

// src/modules/profile/components/ProfilePageSix/ProfilePageSix.tsx
var import_core21 = require("@earned/core");
var import_react_hook_form10 = require("react-hook-form");
var import_jsx_runtime31 = require("react/jsx-runtime");
var ProfilePageSix = ({
  register,
  control
}) => {
  register("coClient.SSN");
  register("coClient.DOB");
  return /* @__PURE__ */ (0, import_jsx_runtime31.jsx)("div", { "data-testid": "profile-page-six", children: /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)("div", { className: "flex flex-col sm:flex-row sm:gap-control-gap", children: [
    /* @__PURE__ */ (0, import_jsx_runtime31.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
      import_react_hook_form10.Controller,
      {
        control,
        name: "coClient.SSN",
        render: ({ field, formState }) => {
          var _a, _b;
          return /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
            import_core21.TextInput,
            {
              label: "Social Security #",
              error: (_b = (_a = formState.errors.coClient) == null ? void 0 : _a.SSN) == null ? void 0 : _b.message,
              placeholder: "XXX-XX-XXXX",
              maskOptions: {
                mask: "999-99-9999",
                maskChar: ""
              },
              ...field
            }
          );
        }
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime31.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
      import_react_hook_form10.Controller,
      {
        control,
        name: "coClient.DOB",
        render: ({ field, formState }) => {
          var _a, _b;
          return /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
            import_core21.TextInput,
            {
              label: "Date of Birth",
              placeholder: "mm/dd/yyyy",
              error: (_b = (_a = formState.errors.coClient) == null ? void 0 : _a.DOB) == null ? void 0 : _b.message,
              maskOptions: {
                mask: "99/99/9999",
                maskChar: ""
              },
              ...field
            }
          );
        }
      }
    ) })
  ] }) });
};
var ProfilePageSix_default = ProfilePageSix;

// src/modules/profile/components/ProfilePageEight/ProfilePageEight.tsx
var import_core22 = require("@earned/core");
var import_jsx_runtime32 = require("react/jsx-runtime");
var ProfilePageEight = ({
  register,
  formState,
  showAdditionalEmployerFields
}) => {
  var _a, _b, _c, _d, _e, _f;
  return /* @__PURE__ */ (0, import_jsx_runtime32.jsxs)("div", { "data-testid": "profile-page-eight", children: [
    /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(QuestionBlock_default, { label: "What is the Co-Client's Employment Status?", children: /* @__PURE__ */ (0, import_jsx_runtime32.jsxs)(
      import_core22.RadioGroup,
      {
        ...register("coClient.EMPLOYMENT_STATUS"),
        error: (_b = (_a = formState.errors.coClient) == null ? void 0 : _a.EMPLOYMENT_STATUS) == null ? void 0 : _b.message,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(import_core22.Radio, { value: "EMPLOYED" /* EMPLOYED */, label: "Employed" }),
          /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(import_core22.Radio, { value: "NOT_EMPLOYED" /* NOT_EMPLOYED */, label: "Not Employed" }),
          /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(import_core22.Radio, { value: "RETIRED" /* RETIRED */, label: "Retired" })
        ]
      }
    ) }),
    showAdditionalEmployerFields && /* @__PURE__ */ (0, import_jsx_runtime32.jsxs)(QuestionBlock_default, { applyIndent: true, children: [
      /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
        import_core22.TextInput,
        {
          label: "Name of the Co-Client's Employer",
          error: (_d = (_c = formState.errors.coClient) == null ? void 0 : _c.EMPLOYER_NAME) == null ? void 0 : _d.message,
          ...register("coClient.EMPLOYER_NAME")
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
        import_core22.TextInput,
        {
          label: "Co-Client's Occupation",
          error: (_f = (_e = formState.errors.coClient) == null ? void 0 : _e.OCCUPATION) == null ? void 0 : _f.message,
          ...register("coClient.OCCUPATION")
        }
      )
    ] })
  ] });
};
var ProfilePageEight_default = ProfilePageEight;

// src/modules/profile/components/ProfilePageNine/ProfilePageNine.tsx
var import_core23 = require("@earned/core");
var import_react_hook_form11 = require("react-hook-form");
var import_jsx_runtime33 = require("react/jsx-runtime");
var ProfilePageNine = ({
  register,
  setValue,
  formState,
  fields,
  control,
  disableFields
}) => {
  var _a, _b, _c, _d;
  register("coClient.DRIVER_LICENSE_STATE");
  register("coClient.DRIVER_LICENSE_EXP");
  return /* @__PURE__ */ (0, import_jsx_runtime33.jsxs)("div", { "data-testid": "profile-page-nine", children: [
    /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
      import_core23.TextInput,
      {
        label: "Driver's License Number",
        disabled: disableFields,
        error: (_b = (_a = formState.errors.coClient) == null ? void 0 : _a.DRIVER_LICENSE_NUMBER) == null ? void 0 : _b.message,
        ...register("coClient.DRIVER_LICENSE_NUMBER")
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime33.jsxs)("div", { className: "flex flex-col sm:flex-row sm:gap-control-gap", children: [
      /* @__PURE__ */ (0, import_jsx_runtime33.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
        import_react_hook_form11.Controller,
        {
          control,
          name: "coClient.DRIVER_LICENSE_EXP",
          render: ({ field, formState: formState2 }) => {
            var _a2, _b2;
            return /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
              import_core23.TextInput,
              {
                label: "Driver's License Expiration Date",
                placeholder: "mm/dd/yyyy",
                disabled: disableFields,
                error: (_b2 = (_a2 = formState2.errors.coClient) == null ? void 0 : _a2.DRIVER_LICENSE_EXP) == null ? void 0 : _b2.message,
                maskOptions: {
                  mask: "99/99/9999",
                  maskChar: ""
                },
                ...field
              }
            );
          }
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime33.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
        import_core23.SelectBox,
        {
          label: "Driver's License State",
          disabled: disableFields,
          options: US_STATE_OPTIONS_OPTIONAL,
          error: (_d = (_c = formState.errors.coClient) == null ? void 0 : _c.DRIVER_LICENSE_STATE) == null ? void 0 : _d.message,
          selected: US_STATE_OPTIONS_OPTIONAL.find(
            (opt) => {
              var _a2;
              return opt.value === ((_a2 = fields.coClient) == null ? void 0 : _a2["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]);
            }
          ) || US_STATE_OPTIONS_OPTIONAL[0],
          onChange: (selected) => {
            setValue(
              "coClient.DRIVER_LICENSE_STATE",
              selected.value,
              {
                shouldValidate: true
              }
            );
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
      import_core23.Checkbox,
      {
        label: "Co-Client doesn't have a driver's license",
        ...register("coClient.NO_LICENSE")
      }
    )
  ] });
};
var ProfilePageNine_default = ProfilePageNine;

// src/common/components/ReviewListAddress/ReviewListAddress.tsx
var import_jsx_runtime34 = require("react/jsx-runtime");
var ReviewListAddress = ({
  street,
  street2,
  city,
  state,
  zip,
  country = "United States of America"
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime34.jsxs)("div", { "data-testid": "review-list-address", children: [
    /* @__PURE__ */ (0, import_jsx_runtime34.jsx)("div", { children: formatters.string(street) }),
    street2 && /* @__PURE__ */ (0, import_jsx_runtime34.jsx)("div", { children: street2 }),
    [city, state, zip].every((v) => !!v) ? /* @__PURE__ */ (0, import_jsx_runtime34.jsxs)(import_jsx_runtime34.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime34.jsxs)("div", { children: [
        city,
        ", ",
        state,
        " ",
        zip
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime34.jsx)("div", { children: country })
    ] }) : "--"
  ] });
};
var ReviewListAddress_default = ReviewListAddress;

// src/common/components/ReviewSubheader/ReviewSubheader.tsx
var import_core24 = require("@earned/core");
var import_jsx_runtime35 = require("react/jsx-runtime");
var ReviewSubheader = ({ label }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("div", { "data-testid": "review-subheader", className: "ReviewSubheader", children: /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(import_core24.Typography, { variant: "body-xl", weight: "medium", color: "inherit", children: label }) });
};
var ReviewSubheader_default = ReviewSubheader;

// src/modules/profile/components/ProfileReviewPage/ProfileReviewPage.tsx
var React11 = __toESM(require("react"));
var import_jsx_runtime36 = require("react/jsx-runtime");
var ProfileReviewPage = ({
  fields,
  showCoClient,
  isCoClient,
  onEditClientEmploymentInfoClick,
  onEditClientDriversLicenseInfoClick,
  onEditClientBasicInfoClick,
  onEditCoClientBasicInfoClick,
  onEditCoClientEmploymentInfoClick,
  onEditCoClientDriversLicenseInfoClick
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __;
  const isClientEmployed = React11.useMemo(
    () => fields.client["EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */] === "EMPLOYED" /* EMPLOYED */,
    [fields]
  );
  const isClientEmployerAddressProvided = React11.useMemo(
    () => fields.client["PROVIDE_EMPLOYER_ADDRESS" /* PROVIDE_EMPLOYER_ADDRESS */] === "YES",
    [fields]
  );
  const doesClientHaveDL = React11.useMemo(
    () => !fields.client["NO_LICENSE" /* NO_LICENSE */],
    [fields]
  );
  const doesCoClientHaveDL = React11.useMemo(
    () => {
      var _a2;
      return !((_a2 = fields.coClient) == null ? void 0 : _a2["NO_LICENSE" /* NO_LICENSE */]);
    },
    [fields]
  );
  const isCoClientEmployed = React11.useMemo(
    () => {
      var _a2;
      return ((_a2 = fields.coClient) == null ? void 0 : _a2["EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */]) === "EMPLOYED" /* EMPLOYED */;
    },
    [fields]
  );
  const isClientAddressVisible = React11.useMemo(
    () => {
      var _a2, _b2, _c2, _d2;
      return isFullAddress(
        (_a2 = fields.client) == null ? void 0 : _a2["ADDRESS_STREET" /* ADDRESS_STREET */],
        (_b2 = fields.client) == null ? void 0 : _b2["ADDRESS_CITY" /* ADDRESS_CITY */],
        (_c2 = fields.client) == null ? void 0 : _c2["ADDRESS_STATE" /* ADDRESS_STATE */],
        (_d2 = fields.client) == null ? void 0 : _d2["ADDRESS_ZIP" /* ADDRESS_ZIP */]
      );
    },
    [fields]
  );
  const isClientMailingAddressVisible = React11.useMemo(
    () => {
      var _a2, _b2, _c2, _d2;
      return isFullAddress(
        (_a2 = fields.client) == null ? void 0 : _a2["MAILING_ADDRESS_STREET" /* MAILING_ADDRESS_STREET */],
        (_b2 = fields.client) == null ? void 0 : _b2["MAILING_ADDRESS_CITY" /* MAILING_ADDRESS_CITY */],
        (_c2 = fields.client) == null ? void 0 : _c2["MAILING_ADDRESS_STATE" /* MAILING_ADDRESS_STATE */],
        (_d2 = fields.client) == null ? void 0 : _d2["MAILING_ADDRESS_ZIP" /* MAILING_ADDRESS_ZIP */]
      );
    },
    [fields]
  );
  const isClientEmployerAddressVisible = React11.useMemo(
    () => {
      var _a2, _b2, _c2, _d2;
      return isClientEmployerAddressProvided && isFullAddress(
        (_a2 = fields.client) == null ? void 0 : _a2["EMPLOYER_ADDRESS_STREET" /* EMPLOYER_ADDRESS_STREET */],
        (_b2 = fields.client) == null ? void 0 : _b2["EMPLOYER_ADDRESS_CITY" /* EMPLOYER_ADDRESS_CITY */],
        (_c2 = fields.client) == null ? void 0 : _c2["EMPLOYER_ADDRESS_STATE" /* EMPLOYER_ADDRESS_STATE */],
        (_d2 = fields.client) == null ? void 0 : _d2["EMPLOYER_ADDRESS_ZIP" /* EMPLOYER_ADDRESS_ZIP */]
      );
    },
    [fields, isClientEmployerAddressProvided]
  );
  const isClientDriversLicenseSectionVisible = React11.useMemo(() => {
    return doesClientHaveDL && [
      fields.client["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */],
      fields.client["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */],
      fields.client["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */]
    ].some((v) => !!v);
  }, [fields, doesClientHaveDL]);
  const isCoClientDriversLicenseSectionVisible = React11.useMemo(() => {
    var _a2, _b2, _c2;
    return doesCoClientHaveDL && [
      (_a2 = fields.coClient) == null ? void 0 : _a2["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */],
      (_b2 = fields.coClient) == null ? void 0 : _b2["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */],
      (_c2 = fields.coClient) == null ? void 0 : _c2["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */]
    ].some((v) => !!v);
  }, [fields, doesCoClientHaveDL]);
  return /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)("div", { "data-testid": "profile-review-page", children: [
    !isCoClient && /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)(import_jsx_runtime36.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)(ReviewBlock_default, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewSubheader_default,
          {
            label: renderFullName({
              first: fields.client["FIRST_NAME" /* FIRST_NAME */],
              last: fields.client["LAST_NAME" /* LAST_NAME */],
              placeholder: "Client"
            }) + "'s Contact Information"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Name",
            value: renderFullName({
              first: fields.client["FIRST_NAME" /* FIRST_NAME */],
              last: fields.client["LAST_NAME" /* LAST_NAME */],
              placeholder: "--"
            })
          }
        ),
        ((_a = fields.client) == null ? void 0 : _a["EMAIL" /* EMAIL */]) && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Email",
            value: formatters.string(
              (_b = fields.client) == null ? void 0 : _b["EMAIL" /* EMAIL */]
            )
          }
        ),
        ((_c = fields.client) == null ? void 0 : _c["PHONE_NUMBER" /* PHONE_NUMBER */]) && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Phone",
            value: formatters.string(
              (_d = fields.client) == null ? void 0 : _d["PHONE_NUMBER" /* PHONE_NUMBER */]
            )
          }
        ),
        isClientAddressVisible && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Residential Address",
            value: /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
              ReviewListAddress_default,
              {
                street: (_e = fields.client) == null ? void 0 : _e["ADDRESS_STREET" /* ADDRESS_STREET */],
                street2: (_f = fields.client) == null ? void 0 : _f["ADDRESS_STREET_2" /* ADDRESS_STREET_2 */],
                city: (_g = fields.client) == null ? void 0 : _g["ADDRESS_CITY" /* ADDRESS_CITY */],
                state: (_h = fields.client) == null ? void 0 : _h["ADDRESS_STATE" /* ADDRESS_STATE */],
                zip: (_i = fields.client) == null ? void 0 : _i["ADDRESS_ZIP" /* ADDRESS_ZIP */]
              }
            )
          }
        ),
        isClientMailingAddressVisible && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Mailing Address",
            value: /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
              ReviewListAddress_default,
              {
                street: (_j = fields.client) == null ? void 0 : _j["MAILING_ADDRESS_STREET" /* MAILING_ADDRESS_STREET */],
                street2: (_k = fields.client) == null ? void 0 : _k["MAILING_ADDRESS_STREET_2" /* MAILING_ADDRESS_STREET_2 */],
                city: (_l = fields.client) == null ? void 0 : _l["MAILING_ADDRESS_CITY" /* MAILING_ADDRESS_CITY */],
                state: (_m = fields.client) == null ? void 0 : _m["MAILING_ADDRESS_STATE" /* MAILING_ADDRESS_STATE */],
                zip: (_n = fields.client) == null ? void 0 : _n["MAILING_ADDRESS_ZIP" /* MAILING_ADDRESS_ZIP */]
              }
            )
          }
        ),
        ((_o = fields.client) == null ? void 0 : _o["NPI_NUMBER" /* NPI_NUMBER */]) && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "NPI Number",
            value: formatters.string(
              (_p = fields.client) == null ? void 0 : _p["NPI_NUMBER" /* NPI_NUMBER */]
            )
          }
        ),
        ((_q = fields.client) == null ? void 0 : _q["CAREER_STAGE" /* CAREER_STAGE */]) && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Career Stage",
            value: formatters.careerStage(
              (_r = fields.client) == null ? void 0 : _r["CAREER_STAGE" /* CAREER_STAGE */]
            )
          }
        ),
        ((_s = fields.client) == null ? void 0 : _s["SPECIALTY" /* SPECIALTY */]) && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Specialty",
            value: formatters.string(
              (_t = fields.client) == null ? void 0 : _t["SPECIALTY" /* SPECIALTY */]
            )
          }
        )
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)(ReviewBlock_default, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewSubheader_default,
          {
            label: renderFullName({
              first: fields.client["FIRST_NAME" /* FIRST_NAME */],
              last: fields.client["LAST_NAME" /* LAST_NAME */],
              placeholder: "Client"
            }) + "'s Basic Information"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Social Security #",
            value: formatters.string(
              (_u = fields.client) == null ? void 0 : _u["SSN" /* SSN */]
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Date of Birth",
            value: formatters.string(
              (_v = fields.client) == null ? void 0 : _v["DOB" /* DOB */]
            )
          }
        ),
        onEditClientBasicInfoClick && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(ReviewEditLink_default, { onClick: onEditClientBasicInfoClick })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)(ReviewBlock_default, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewSubheader_default,
          {
            label: renderFullName({
              first: fields.client["FIRST_NAME" /* FIRST_NAME */],
              last: fields.client["LAST_NAME" /* LAST_NAME */],
              placeholder: "Client"
            }) + "'s Employment Information"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Annual Income",
            value: formatters.currency(
              (_w = fields.client) == null ? void 0 : _w["ANNUAL_INCOME" /* ANNUAL_INCOME */]
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Total Assets",
            value: formatters.currency(
              (_x = fields.client) == null ? void 0 : _x["TOTAL_ASSETS" /* TOTAL_ASSETS */]
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Employment Status",
            value: formatters.employmentStatus(
              (_y = fields.client) == null ? void 0 : _y["EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */]
            )
          }
        ),
        !isClientEmployed && ((_z = fields.client) == null ? void 0 : _z["SOURCE_INCOME" /* SOURCE_INCOME */]) && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Source of Income",
            value: formatters.string(
              (_A = fields.client) == null ? void 0 : _A["SOURCE_INCOME" /* SOURCE_INCOME */]
            )
          }
        ),
        isClientEmployed && ((_B = fields.client) == null ? void 0 : _B["EMPLOYER_NAME" /* EMPLOYER_NAME */]) && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Employer's Name",
            value: formatters.string(
              (_C = fields.client) == null ? void 0 : _C["EMPLOYER_NAME" /* EMPLOYER_NAME */]
            )
          }
        ),
        isClientEmployerAddressVisible && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Employer's Address",
            value: /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
              ReviewListAddress_default,
              {
                street: (_D = fields.client) == null ? void 0 : _D["EMPLOYER_ADDRESS_STREET" /* EMPLOYER_ADDRESS_STREET */],
                street2: (_E = fields.client) == null ? void 0 : _E["EMPLOYER_ADDRESS_STREET_2" /* EMPLOYER_ADDRESS_STREET_2 */],
                city: (_F = fields.client) == null ? void 0 : _F["EMPLOYER_ADDRESS_CITY" /* EMPLOYER_ADDRESS_CITY */],
                state: (_G = fields.client) == null ? void 0 : _G["EMPLOYER_ADDRESS_STATE" /* EMPLOYER_ADDRESS_STATE */],
                zip: (_H = fields.client) == null ? void 0 : _H["EMPLOYER_ADDRESS_ZIP" /* EMPLOYER_ADDRESS_ZIP */]
              }
            )
          }
        ),
        onEditClientEmploymentInfoClick && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(ReviewEditLink_default, { onClick: onEditClientEmploymentInfoClick })
      ] }),
      isClientDriversLicenseSectionVisible && /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)(ReviewBlock_default, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewSubheader_default,
          {
            label: renderFullName({
              first: fields.client["FIRST_NAME" /* FIRST_NAME */],
              last: fields.client["LAST_NAME" /* LAST_NAME */],
              placeholder: "Client"
            }) + "'s Driver's License Information"
          }
        ),
        ((_I = fields.client) == null ? void 0 : _I["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */]) && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Driver's License Number",
            value: formatters.string(
              (_J = fields.client) == null ? void 0 : _J["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */]
            )
          }
        ),
        ((_K = fields.client) == null ? void 0 : _K["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]) && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Driver's License State",
            value: formatters.string(
              (_L = fields.client) == null ? void 0 : _L["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]
            )
          }
        ),
        ((_M = fields.client) == null ? void 0 : _M["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */]) && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Driver's License Expiration Date",
            value: formatters.string(
              (_N = fields.client) == null ? void 0 : _N["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */]
            )
          }
        ),
        onEditClientDriversLicenseInfoClick && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(ReviewEditLink_default, { onClick: onEditClientDriversLicenseInfoClick })
      ] })
    ] }),
    showCoClient && /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)(import_jsx_runtime36.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)(ReviewBlock_default, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewSubheader_default,
          {
            label: renderFullName({
              first: (_O = fields.coClient) == null ? void 0 : _O["FIRST_NAME" /* FIRST_NAME */],
              last: (_P = fields.coClient) == null ? void 0 : _P["LAST_NAME" /* LAST_NAME */],
              placeholder: "Co-Client"
            }) + "'s Basic Information"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Social Security #",
            value: formatters.string(
              (_Q = fields.coClient) == null ? void 0 : _Q["SSN" /* SSN */]
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Date of Birth",
            value: formatters.string(
              (_R = fields.coClient) == null ? void 0 : _R["DOB" /* DOB */]
            )
          }
        ),
        onEditCoClientBasicInfoClick && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(ReviewEditLink_default, { onClick: onEditCoClientBasicInfoClick })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)(ReviewBlock_default, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewSubheader_default,
          {
            label: renderFullName({
              first: (_S = fields.coClient) == null ? void 0 : _S["FIRST_NAME" /* FIRST_NAME */],
              last: (_T = fields.coClient) == null ? void 0 : _T["LAST_NAME" /* LAST_NAME */],
              placeholder: "Co-Client"
            }) + "'s Employment Information"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Annual Income",
            value: formatters.currency(
              (_U = fields.coClient) == null ? void 0 : _U["ANNUAL_INCOME" /* ANNUAL_INCOME */]
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Total Assets",
            value: formatters.currency(
              (_V = fields.coClient) == null ? void 0 : _V["TOTAL_ASSETS" /* TOTAL_ASSETS */]
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Employment Status",
            value: formatters.employmentStatus(
              (_W = fields.coClient) == null ? void 0 : _W["EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */]
            )
          }
        ),
        isCoClientEmployed && ((_X = fields.coClient) == null ? void 0 : _X["EMPLOYER_NAME" /* EMPLOYER_NAME */]) && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Employer Name",
            value: formatters.string(
              (_Y = fields.coClient) == null ? void 0 : _Y["EMPLOYER_NAME" /* EMPLOYER_NAME */]
            )
          }
        ),
        isCoClientEmployed && ((_Z = fields.coClient) == null ? void 0 : _Z["OCCUPATION" /* OCCUPATION */]) && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Occupation",
            value: formatters.string(
              (__ = fields.coClient) == null ? void 0 : __["OCCUPATION" /* OCCUPATION */]
            )
          }
        ),
        onEditCoClientEmploymentInfoClick && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(ReviewEditLink_default, { onClick: onEditCoClientEmploymentInfoClick })
      ] }),
      isCoClientDriversLicenseSectionVisible && /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)(ReviewBlock_default, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewSubheader_default,
          {
            label: renderFullName({
              first: fields.coClient["FIRST_NAME" /* FIRST_NAME */],
              last: fields.coClient["LAST_NAME" /* LAST_NAME */],
              placeholder: "Co-Client"
            }) + "'s Driver's License Information"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Driver's License Number",
            value: formatters.string(
              fields.coClient["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */]
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Driver's License State",
            value: formatters.string(
              fields.coClient["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewList_default,
          {
            label: "Driver's License Expiration Date",
            value: formatters.string(
              fields.coClient["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */]
            )
          }
        ),
        onEditCoClientDriversLicenseInfoClick && /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
          ReviewEditLink_default,
          {
            onClick: onEditCoClientDriversLicenseInfoClick
          }
        )
      ] })
    ] })
  ] });
};
var ProfileReviewPage_default = ProfileReviewPage;

// src/modules/profile/components/ProfileWizard/ProfileWizard.tsx
var _4 = __toESM(require("lodash"));
var import_yup3 = require("@hookform/resolvers/yup");

// src/modules/profile/hooks.ts
var _3 = __toESM(require("lodash"));
var import_react3 = __toESM(require("react"));

// src/modules/profile/helpers.ts
var _2 = __toESM(require("lodash"));
var convertFieldsToPayload = (fields) => {
  var _a, _b, _c, _d;
  const isClientEmployed = fields.client["EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */] === "EMPLOYED" /* EMPLOYED */;
  const provideClientEmployerAddress = fields.client["PROVIDE_EMPLOYER_ADDRESS" /* PROVIDE_EMPLOYER_ADDRESS */] === "YES";
  const clientHasNoDLLicense = fields.client["NO_LICENSE" /* NO_LICENSE */];
  const isCoClientEmployed = ((_a = fields.coClient) == null ? void 0 : _a["EMPLOYMENT_STATUS" /* EMPLOYMENT_STATUS */]) === "EMPLOYED" /* EMPLOYED */;
  const coClientHasNoDLLicense = (_b = fields.coClient) == null ? void 0 : _b["NO_LICENSE" /* NO_LICENSE */];
  return PROFILE_PAYLOAD_SCHEMA.cast({
    client: {
      ...fields.client,
      ["EMPLOYER_NAME" /* EMPLOYER_NAME */]: isClientEmployed ? fields.client["EMPLOYER_NAME" /* EMPLOYER_NAME */] : void 0,
      ["EMPLOYER_ADDRESS_STREET" /* EMPLOYER_ADDRESS_STREET */]: provideClientEmployerAddress ? fields.client["EMPLOYER_ADDRESS_STREET" /* EMPLOYER_ADDRESS_STREET */] : void 0,
      ["EMPLOYER_ADDRESS_STREET_2" /* EMPLOYER_ADDRESS_STREET_2 */]: provideClientEmployerAddress ? fields.client["EMPLOYER_ADDRESS_STREET_2" /* EMPLOYER_ADDRESS_STREET_2 */] : void 0,
      ["EMPLOYER_ADDRESS_CITY" /* EMPLOYER_ADDRESS_CITY */]: provideClientEmployerAddress ? fields.client["EMPLOYER_ADDRESS_CITY" /* EMPLOYER_ADDRESS_CITY */] : void 0,
      ["EMPLOYER_ADDRESS_STATE" /* EMPLOYER_ADDRESS_STATE */]: provideClientEmployerAddress ? fields.client["EMPLOYER_ADDRESS_STATE" /* EMPLOYER_ADDRESS_STATE */] : void 0,
      ["EMPLOYER_ADDRESS_ZIP" /* EMPLOYER_ADDRESS_ZIP */]: provideClientEmployerAddress ? fields.client["EMPLOYER_ADDRESS_ZIP" /* EMPLOYER_ADDRESS_ZIP */] : void 0,
      ["SOURCE_INCOME" /* SOURCE_INCOME */]: !isClientEmployed ? fields.client["SOURCE_INCOME" /* SOURCE_INCOME */] : void 0,
      ["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */]: clientHasNoDLLicense ? void 0 : fields.client["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */],
      ["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */]: clientHasNoDLLicense ? void 0 : fields.client["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */],
      ["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]: clientHasNoDLLicense ? void 0 : fields.client["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]
    },
    coClient: fields["ADD_CO_CLIENT" /* ADD_CO_CLIENT */] === "YES" ? {
      ...fields.coClient,
      ["EMPLOYER_NAME" /* EMPLOYER_NAME */]: isCoClientEmployed ? (_c = fields.coClient) == null ? void 0 : _c["EMPLOYER_NAME" /* EMPLOYER_NAME */] : void 0,
      ["OCCUPATION" /* OCCUPATION */]: isCoClientEmployed ? (_d = fields.coClient) == null ? void 0 : _d["OCCUPATION" /* OCCUPATION */] : void 0,
      ["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */]: coClientHasNoDLLicense ? void 0 : fields.coClient["DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */],
      ["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */]: coClientHasNoDLLicense ? void 0 : fields.coClient["DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */],
      ["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]: coClientHasNoDLLicense ? void 0 : fields.coClient["DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */]
    } : void 0
  });
};
var OPTIONAL_PROFILE_FIELDS = [
  "EMPLOYER_ADDRESS_STREET" /* EMPLOYER_ADDRESS_STREET */,
  "EMPLOYER_ADDRESS_STREET_2" /* EMPLOYER_ADDRESS_STREET_2 */,
  "EMPLOYER_ADDRESS_CITY" /* EMPLOYER_ADDRESS_CITY */,
  "EMPLOYER_ADDRESS_STATE" /* EMPLOYER_ADDRESS_STATE */,
  "EMPLOYER_ADDRESS_ZIP" /* EMPLOYER_ADDRESS_ZIP */,
  "SOURCE_INCOME" /* SOURCE_INCOME */,
  "DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */,
  "DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */,
  "DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */
];
var OPTIONAL_FIELD_GROUPS = [
  [
    "DRIVER_LICENSE_NUMBER" /* DRIVER_LICENSE_NUMBER */,
    "DRIVER_LICENSE_EXP" /* DRIVER_LICENSE_EXP */,
    "DRIVER_LICENSE_STATE" /* DRIVER_LICENSE_STATE */
  ],
  [
    "EMPLOYER_ADDRESS_STREET" /* EMPLOYER_ADDRESS_STREET */,
    "EMPLOYER_ADDRESS_STREET_2" /* EMPLOYER_ADDRESS_STREET_2 */,
    "EMPLOYER_ADDRESS_CITY" /* EMPLOYER_ADDRESS_CITY */,
    "EMPLOYER_ADDRESS_STATE" /* EMPLOYER_ADDRESS_STATE */,
    "EMPLOYER_ADDRESS_ZIP" /* EMPLOYER_ADDRESS_ZIP */
  ]
];
var getErrorPaths = (errors, prefix = "") => Object.entries(errors).flatMap(([key, error]) => {
  if (!error || typeof error !== "object")
    return [];
  const path = prefix ? `${prefix}.${key}` : key;
  if (typeof error.type === "string")
    return [path];
  return getErrorPaths(error, path);
});
var expandOptionalGroups = (paths) => {
  const expanded = new Set(paths);
  paths.forEach((path) => {
    const [owner, field] = path.split(".");
    OPTIONAL_FIELD_GROUPS.filter((group) => group.includes(field)).forEach(
      (group) => group.forEach((member) => expanded.add(`${owner}.${member}`))
    );
  });
  return Array.from(expanded);
};
var partitionProfileErrors = (errors, values) => {
  const droppable = [];
  const blocking = [];
  getErrorPaths(errors).forEach((path) => {
    const value = _2.get(values, path);
    const hasValue = typeof value === "string" ? value.trim() !== "" : !!value;
    const isOptional = OPTIONAL_PROFILE_FIELDS.includes(
      _2.last(path.split(".")) ?? ""
    );
    (isOptional && hasValue ? droppable : blocking).push(path);
  });
  return { droppable: expandOptionalGroups(droppable), blocking };
};
var omitProfileFields = (values, paths) => paths.reduce((acc, path) => _2.set(acc, path, void 0), _2.cloneDeep(values));
var findFirstErrorPage = (pageValidationMap, paths) => {
  const page = Object.entries(pageValidationMap).find(
    ([, fields]) => fields.some((field) => paths.includes(field))
  );
  return page ? Number(page[0]) : void 0;
};

// src/modules/profile/hooks.ts
var useFormWatcher = ({
  currentPage,
  watch,
  setValue,
  trigger,
  formState,
  isCoClient,
  validationMap
}) => {
  var _a, _b, _c, _d, _e, _f;
  const [
    clientEmploymentStatus,
    provideClientEmployerAddress,
    clientHasNoLicense,
    coClient,
    isCoClientMailingSameAsResidential,
    coClientEmploymentStatus,
    coClientHasNoLicense
  ] = watch([
    "client.EMPLOYMENT_STATUS",
    "client.PROVIDE_EMPLOYER_ADDRESS",
    "client.NO_LICENSE",
    "coClient",
    "coClient.SAME_AS_MAILING",
    "coClient.EMPLOYMENT_STATUS",
    "coClient.NO_LICENSE"
  ]);
  const [isCoClientAdded] = watch(["ADD_CO_CLIENT"]);
  const [isCoClientAddedPrevious, setIsCoClientAddedPrevious] = (0, import_react3.useState)(void 0);
  import_react3.default.useEffect(() => {
    setIsCoClientAddedPrevious(isCoClientAdded);
  }, [isCoClientAdded]);
  const handleClientEmploymentStatusChange = (0, import_react3.useCallback)(() => {
    if (clientEmploymentStatus !== "EMPLOYED" /* EMPLOYED */ && provideClientEmployerAddress === "YES")
      setValue("client.PROVIDE_EMPLOYER_ADDRESS", "NO");
  }, [clientEmploymentStatus, provideClientEmployerAddress, setValue]);
  const handleClientHasLicenseChange = (0, import_react3.useCallback)(() => {
    var _a2, _b2, _c2;
    const hasErrors = [
      (_a2 = formState.errors.client) == null ? void 0 : _a2.DRIVER_LICENSE_NUMBER,
      (_b2 = formState.errors.client) == null ? void 0 : _b2.DRIVER_LICENSE_EXP,
      (_c2 = formState.errors.client) == null ? void 0 : _c2.DRIVER_LICENSE_STATE
    ].some((v) => !!v);
    const clientDLPage = isCoClient ? -1 : 3;
    const activeValidationMap = validationMap || PROFILE_PAGE_VALIDATION_MAP;
    if (clientHasNoLicense && currentPage === clientDLPage && hasErrors)
      trigger(activeValidationMap[currentPage]);
  }, [
    clientHasNoLicense,
    currentPage,
    (_a = formState.errors.client) == null ? void 0 : _a.DRIVER_LICENSE_EXP,
    (_b = formState.errors.client) == null ? void 0 : _b.DRIVER_LICENSE_NUMBER,
    (_c = formState.errors.client) == null ? void 0 : _c.DRIVER_LICENSE_STATE,
    trigger,
    isCoClient,
    validationMap
  ]);
  const handleAddCoClientChange = (0, import_react3.useCallback)(() => {
    if (isCoClientAdded === "NO" && !!coClient)
      setValue("coClient", void 0);
    if (!!coClient && isCoClientAdded === "YES" && (coClient == null ? void 0 : coClient["IS_PRIMARY_CLIENT" /* IS_PRIMARY_CLIENT */]) === void 0)
      setValue("coClient.IS_PRIMARY_CLIENT", false);
  }, [isCoClientAdded, coClient, setValue]);
  const handleInitializeCoClientSameAsMailing = (0, import_react3.useCallback)(() => {
    if (coClient && isCoClientMailingSameAsResidential === void 0)
      setValue("coClient.SAME_AS_MAILING", true);
  }, [coClient, isCoClientMailingSameAsResidential, setValue]);
  const handleCoClientAddressChange = (0, import_react3.useCallback)(() => {
    if (coClient && isCoClientMailingSameAsResidential) {
      if (coClient["ADDRESS_STREET" /* ADDRESS_STREET */] !== coClient["MAILING_ADDRESS_STREET" /* MAILING_ADDRESS_STREET */])
        setValue(
          "coClient.MAILING_ADDRESS_STREET",
          coClient["ADDRESS_STREET" /* ADDRESS_STREET */]
        );
      if (coClient["ADDRESS_STREET_2" /* ADDRESS_STREET_2 */] !== coClient["MAILING_ADDRESS_STREET_2" /* MAILING_ADDRESS_STREET_2 */])
        setValue(
          "coClient.MAILING_ADDRESS_STREET_2",
          coClient["ADDRESS_STREET_2" /* ADDRESS_STREET_2 */]
        );
      if (coClient["ADDRESS_CITY" /* ADDRESS_CITY */] !== coClient["MAILING_ADDRESS_CITY" /* MAILING_ADDRESS_CITY */])
        setValue(
          "coClient.MAILING_ADDRESS_CITY",
          coClient["ADDRESS_CITY" /* ADDRESS_CITY */]
        );
      if (coClient["ADDRESS_STATE" /* ADDRESS_STATE */] !== coClient["MAILING_ADDRESS_STATE" /* MAILING_ADDRESS_STATE */])
        setValue(
          "coClient.MAILING_ADDRESS_STATE",
          coClient["ADDRESS_STATE" /* ADDRESS_STATE */]
        );
      if (coClient["ADDRESS_ZIP" /* ADDRESS_ZIP */] !== coClient["MAILING_ADDRESS_ZIP" /* MAILING_ADDRESS_ZIP */])
        setValue(
          "coClient.MAILING_ADDRESS_ZIP",
          coClient["ADDRESS_ZIP" /* ADDRESS_ZIP */]
        );
    }
  }, [coClient, isCoClientMailingSameAsResidential, setValue]);
  const handleCoClientHasLicenseChange = (0, import_react3.useCallback)(() => {
    var _a2, _b2, _c2;
    const hasErrors = [
      (_a2 = formState.errors.coClient) == null ? void 0 : _a2.DRIVER_LICENSE_NUMBER,
      (_b2 = formState.errors.coClient) == null ? void 0 : _b2.DRIVER_LICENSE_EXP,
      (_c2 = formState.errors.coClient) == null ? void 0 : _c2.DRIVER_LICENSE_STATE
    ].some((v) => !!v);
    const coClientDLPage = isCoClient ? 3 : 9;
    const activeCoValidationMap = validationMap || PROFILE_PAGE_VALIDATION_MAP;
    if (coClientHasNoLicense && currentPage === coClientDLPage && hasErrors)
      trigger(activeCoValidationMap[currentPage]);
  }, [
    coClientHasNoLicense,
    currentPage,
    (_d = formState.errors.coClient) == null ? void 0 : _d.DRIVER_LICENSE_EXP,
    (_e = formState.errors.coClient) == null ? void 0 : _e.DRIVER_LICENSE_NUMBER,
    (_f = formState.errors.coClient) == null ? void 0 : _f.DRIVER_LICENSE_STATE,
    trigger,
    isCoClient,
    validationMap
  ]);
  import_react3.default.useEffect(() => {
    handleClientEmploymentStatusChange();
    handleClientHasLicenseChange();
    handleInitializeCoClientSameAsMailing();
    handleCoClientAddressChange();
    handleCoClientHasLicenseChange();
  }, [
    handleClientEmploymentStatusChange,
    handleClientHasLicenseChange,
    handleInitializeCoClientSameAsMailing,
    handleCoClientAddressChange,
    handleCoClientHasLicenseChange
  ]);
  import_react3.default.useEffect(() => {
    if (isCoClientAddedPrevious && isCoClientAdded !== isCoClientAddedPrevious) {
      handleAddCoClientChange();
    }
  }, [isCoClientAddedPrevious, handleAddCoClientChange, isCoClientAdded]);
  return (0, import_react3.useMemo)(
    () => ({
      showClientEmployerNameField: clientEmploymentStatus === "EMPLOYED" /* EMPLOYED */,
      showSourceOfIncome: [
        "NOT_EMPLOYED" /* NOT_EMPLOYED */,
        "RETIRED" /* RETIRED */
      ].includes(clientEmploymentStatus),
      showClientEmployerAddress: provideClientEmployerAddress === "YES",
      disableClientDLLicenseFields: clientHasNoLicense,
      isCoClientAdded: isCoClientAdded === "YES",
      coClient,
      isCoClientMailingSameAsResidential,
      showAdditionalCoClientEmployerFields: coClientEmploymentStatus === "EMPLOYED" /* EMPLOYED */,
      disableCoClientDLLicenseFields: coClientHasNoLicense
    }),
    [
      clientEmploymentStatus,
      provideClientEmployerAddress,
      clientHasNoLicense,
      isCoClientAdded,
      coClient,
      isCoClientMailingSameAsResidential,
      coClientEmploymentStatus,
      coClientHasNoLicense
    ]
  );
};
var useProfileSubmitErrors = ({
  schema,
  validationMap,
  getValues,
  goTo,
  trigger,
  onSubmit
}) => {
  const [submitError, setSubmitError] = (0, import_react3.useState)();
  const clearSubmitError = (0, import_react3.useCallback)(() => setSubmitError(void 0), []);
  const handleInvalid = (0, import_react3.useCallback)(
    (errors) => {
      const values = getValues();
      const { droppable, blocking } = partitionProfileErrors(errors, values);
      if (!blocking.length) {
        try {
          onSubmit(
            schema.cast(omitProfileFields(values, droppable), {
              assert: false
            })
          );
          return;
        } catch {
        }
      }
      const messages = _3.uniq(
        blocking.map((path) => _3.get(errors, `${path}.message`)).filter(Boolean)
      );
      setSubmitError(
        `Please review your answers: ${messages.join(", ") || "some fields need attention"}.`
      );
      const page = findFirstErrorPage(validationMap, blocking);
      if (page === void 0)
        return;
      goTo(page);
      trigger(validationMap[page]);
    },
    [getValues, onSubmit, schema, validationMap, goTo, trigger]
  );
  return { submitError, clearSubmitError, handleInvalid };
};

// src/modules/profile/components/ProfileWizard/ProfileWizard.tsx
var import_jsx_runtime37 = require("react/jsx-runtime");
var ProfileWizard = ({
  isOpen,
  close,
  isLoading,
  isSuccess,
  onSubmit,
  onDone,
  isSubmitting,
  cache,
  modalRootSelector,
  isCoClient,
  onFieldChange,
  onPageChange,
  primaryClientName,
  coClientName
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  const pageCount = isCoClient ? PROFILE_COCLIENT_PAGE_COUNT : PROFILE_CLIENT_PAGE_COUNT;
  const formSchema = isCoClient ? PROFILE_COCLIENT_FORM_SCHEMA : PROFILE_FORM_SCHEMA;
  const validationMap = isCoClient ? PROFILE_COCLIENT_PAGE_VALIDATION_MAP : PROFILE_CLIENT_PAGE_VALIDATION_MAP;
  const {
    currentPage,
    goNext,
    goBack,
    goToFirst,
    goTo,
    progress,
    isFirst,
    isLast
  } = useWizardControls({
    pages: pageCount
  });
  const {
    register,
    formState,
    handleSubmit: submit,
    control,
    watch,
    getValues,
    setValue,
    trigger
  } = (0, import_react_hook_form12.useForm)({
    values: cache ? PROFILE_FORM_SCHEMA.cast({
      ...cache,
      ADD_CO_CLIENT: isCoClient ? "YES" : "NO",
      client: {
        ...cache.client,
        PROVIDE_EMPLOYER_ADDRESS: !![
          (_a = cache.client) == null ? void 0 : _a["EMPLOYER_ADDRESS_STREET" /* EMPLOYER_ADDRESS_STREET */],
          (_b = cache.client) == null ? void 0 : _b["EMPLOYER_ADDRESS_STREET_2" /* EMPLOYER_ADDRESS_STREET_2 */],
          (_c = cache.client) == null ? void 0 : _c["EMPLOYER_ADDRESS_CITY" /* EMPLOYER_ADDRESS_CITY */],
          (_d = cache.client) == null ? void 0 : _d["EMPLOYER_ADDRESS_STATE" /* EMPLOYER_ADDRESS_STATE */],
          (_e = cache.client) == null ? void 0 : _e["EMPLOYER_ADDRESS_ZIP" /* EMPLOYER_ADDRESS_ZIP */]
        ].some((v) => !!v) ? "YES" : "NO"
      },
      coClient: isCoClient && cache.coClient ? {
        ...cache.coClient,
        IS_PRIMARY_CLIENT: false,
        SAME_AS_MAILING: !_4.difference(
          [
            (_f = cache.coClient) == null ? void 0 : _f["MAILING_ADDRESS_STREET" /* MAILING_ADDRESS_STREET */],
            (_g = cache.coClient) == null ? void 0 : _g["MAILING_ADDRESS_STREET_2" /* MAILING_ADDRESS_STREET_2 */],
            (_h = cache.coClient) == null ? void 0 : _h["MAILING_ADDRESS_CITY" /* MAILING_ADDRESS_CITY */],
            (_i = cache.coClient) == null ? void 0 : _i["MAILING_ADDRESS_STATE" /* MAILING_ADDRESS_STATE */],
            (_j = cache.coClient) == null ? void 0 : _j["MAILING_ADDRESS_ZIP" /* MAILING_ADDRESS_ZIP */]
          ],
          [
            (_k = cache.coClient) == null ? void 0 : _k["ADDRESS_STREET" /* ADDRESS_STREET */],
            (_l = cache.coClient) == null ? void 0 : _l["ADDRESS_STREET_2" /* ADDRESS_STREET_2 */],
            (_m = cache.coClient) == null ? void 0 : _m["ADDRESS_CITY" /* ADDRESS_CITY */],
            (_n = cache.coClient) == null ? void 0 : _n["ADDRESS_STATE" /* ADDRESS_STATE */],
            (_o = cache.coClient) == null ? void 0 : _o["ADDRESS_ZIP" /* ADDRESS_ZIP */]
          ]
        ).length
      } : void 0
    }) : void 0,
    defaultValues: {
      ADD_CO_CLIENT: isCoClient ? "YES" : "NO",
      client: {
        IS_PRIMARY_CLIENT: true,
        PROVIDE_EMPLOYER_ADDRESS: "NO",
        NO_LICENSE: false
      },
      coClient: void 0
    },
    mode: "onTouched",
    resolver: (0, import_yup3.yupResolver)(formSchema)
  });
  const fieldValues = getValues();
  const {
    showClientEmployerNameField,
    showSourceOfIncome,
    showClientEmployerAddress,
    disableClientDLLicenseFields,
    isCoClientMailingSameAsResidential,
    showAdditionalCoClientEmployerFields,
    disableCoClientDLLicenseFields
  } = useFormWatcher({
    initialFields: fieldValues,
    watch,
    setValue,
    currentPage,
    trigger,
    formState,
    isCoClient,
    validationMap
  });
  const title = React13.useMemo(() => {
    if (isCoClient)
      return "Update Co-Client Profile";
    return "Complete your Profile";
  }, [isCoClient]);
  const subtitle = React13.useMemo(() => {
    if (isFirst)
      return "Please provide the necessary details to complete your profile. This information will be used to assist in setting up various investment accounts and insurance policies.";
    if (isLast)
      return "Please review the following information before submitting the application.";
    return "";
  }, [isFirst, isLast]);
  const nextLabel = React13.useMemo(() => {
    return isLast ? "Submit" : "Next";
  }, [isLast]);
  const titleTag = React13.useMemo(() => {
    if (isCoClient)
      return coClientName;
    return primaryClientName;
  }, [primaryClientName, coClientName, isCoClient]);
  const isNextButtonDisabled = isSubmitting;
  const renderPages = React13.useCallback(() => {
    const fields = getValues();
    if (isCoClient) {
      switch (currentPage) {
        case 0:
          return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
            ProfilePageSix_default,
            {
              control,
              register,
              formState,
              fields,
              setValue
            }
          );
        case 1:
          return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
            ProfilePageEight_default,
            {
              register,
              formState,
              setValue,
              fields,
              showAdditionalEmployerFields: showAdditionalCoClientEmployerFields
            }
          );
        case 2:
          return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
            ProfilePageThree_default,
            {
              register,
              formState,
              fields,
              setValue,
              fieldPrefix: isCoClient ? "coClient" : "client"
            }
          );
        case 3:
          return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
            ProfilePageNine_default,
            {
              fields,
              control,
              setValue,
              register,
              formState,
              disableFields: disableCoClientDLLicenseFields
            }
          );
        case 4:
          return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
            ProfileReviewPage_default,
            {
              fields,
              isCoClient: true,
              showCoClient: true,
              onEditCoClientBasicInfoClick: goToFirst,
              onEditCoClientEmploymentInfoClick: () => goTo(1),
              onEditCoClientDriversLicenseInfoClick: () => goTo(3)
            }
          );
        default:
          return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(import_jsx_runtime37.Fragment, {});
      }
    }
    switch (currentPage) {
      case 0:
        return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
          ProfilePageOne_default,
          {
            control,
            register,
            formState,
            fields,
            setValue
          }
        );
      case 1:
        return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
          ProfilePageTwo_default,
          {
            fields,
            setValue,
            register,
            formState,
            showEmployerAddressField: showClientEmployerAddress,
            showEmployerNameField: showClientEmployerNameField,
            showSourceOfIncome
          }
        );
      case 2:
        return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
          ProfilePageThree_default,
          {
            register,
            formState,
            fields,
            setValue
          }
        );
      case 3:
        return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
          ProfilePageFour_default,
          {
            fields,
            setValue,
            register,
            control,
            formState,
            disableFields: disableClientDLLicenseFields
          }
        );
      case 4:
        return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
          ProfileReviewPage_default,
          {
            fields,
            isCoClient: false,
            showCoClient: false,
            onEditClientBasicInfoClick: goToFirst,
            onEditClientEmploymentInfoClick: () => goTo(1),
            onEditClientDriversLicenseInfoClick: () => goTo(3)
          }
        );
      default:
        return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(import_jsx_runtime37.Fragment, {});
    }
  }, [
    currentPage,
    formState,
    register,
    getValues,
    setValue,
    goTo,
    goToFirst,
    control,
    isCoClient,
    showClientEmployerNameField,
    showSourceOfIncome,
    showClientEmployerAddress,
    disableClientDLLicenseFields,
    showAdditionalCoClientEmployerFields,
    disableCoClientDLLicenseFields
  ]);
  const handleSubmit = React13.useCallback(
    (fields) => {
      const payload = convertFieldsToPayload(fields);
      onSubmit(payload);
    },
    [onSubmit]
  );
  const { submitError, clearSubmitError, handleInvalid } = useProfileSubmitErrors({
    schema: formSchema,
    validationMap,
    getValues,
    goTo,
    trigger,
    onSubmit: handleSubmit
  });
  const handleNext = React13.useCallback(async () => {
    clearSubmitError();
    await trigger(validationMap[currentPage]).then((valid) => {
      if (valid)
        goNext();
    });
  }, [trigger, goNext, currentPage, validationMap, clearSubmitError]);
  const handleBack = React13.useCallback(() => {
    clearSubmitError();
    goBack();
  }, [goBack, clearSubmitError]);
  React13.useEffect(() => {
    if (isLast)
      trigger();
  }, [isLast, trigger]);
  React13.useEffect(() => {
    if (formState.isValid)
      clearSubmitError();
  }, [formState.isValid, clearSubmitError]);
  React13.useEffect(() => {
    const subscription = watch((...[values, field]) => {
      if (!onFieldChange)
        return;
      const value = _4.get(values, field.name);
      const schema = _4.get(
        PROFILE_PAYLOAD_SCHEMA.fields,
        field.name.split(".").join(".fields.")
      );
      if (schema)
        trigger(field.name).then((valid) => {
          if (valid)
            onFieldChange({
              key: field.name,
              field: schema.cast(value)
            });
        });
    });
    return () => subscription.unsubscribe();
  }, [watch, onFieldChange, trigger]);
  React13.useEffect(() => {
    if (!onPageChange)
      return;
    onPageChange(currentPage);
  }, [currentPage, onPageChange]);
  return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)("div", { "data-testid": "profile-wizard", children: /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
    Modal_default,
    {
      open: isOpen,
      close,
      title,
      titleTag,
      subtitle,
      progressPercentage: isLoading ? 0 : progress,
      showProgressBar: true,
      showConfirmation: isSuccess,
      renderConfirmation: () => /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(SuccessPanel_default, { onDone }),
      rootSelector: modalRootSelector,
      children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime37.jsx)("div", { className: "flex flex-row justify-center", children: /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(LoadingIndicator_default, {}) }) : /* @__PURE__ */ (0, import_jsx_runtime37.jsxs)("form", { onSubmit: submit(handleSubmit, handleInvalid), children: [
        renderPages(),
        submitError && /* @__PURE__ */ (0, import_jsx_runtime37.jsx)("div", { role: "alert", "data-testid": "profile-submit-error", children: /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(import_core25.Typography, { variant: "body", color: "danger", children: submitError }) }),
        /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
          Footer_default,
          {
            onNextClick: handleNext,
            onPreviousClick: handleBack,
            showPrevious: !isFirst,
            nextDisabled: isNextButtonDisabled,
            submitMode: isLast,
            nextLabel,
            submitting: isLast && isSubmitting
          }
        )
      ] })
    }
  ) });
};
var ProfileWizard_default = ProfileWizard;

// src/modules/risk-tolerance/constants.ts
var yup3 = __toESM(require("yup"));
var RISK_TOLERANCE_PAGE_COUNT = 6;
var RISK_TOLERANCE_FORM_SCHEMA = yup3.object({
  // these are filled out automatically, so no need to add error message:
  ["CAREER_STAGE" /* CAREER_STAGE */]: yup3.string().nullable(),
  ["RTQ_SCORE" /* RTQ_SCORE */]: yup3.number().nullable().required(),
  ["NOT_A_DOCTOR" /* NOT_A_DOCTOR */]: yup3.boolean(),
  ["CAREER_STAGE_EXPANDED" /* CAREER_STAGE_EXPANDED */]: yup3.string().when("NOT_A_DOCTOR", {
    is: true,
    then: yup3.string().notRequired().nullable(),
    otherwise: yup3.string().required("This question is required").nullable()
  }),
  ["RTQ_EXPECTED_MONEY_NEED_PERIOD" /* RTQ_EXPECTED_MONEY_NEED_PERIOD */]: yup3.string().nullable().required("This question is required"),
  ["RTQ_INCOME_PROJECTION" /* RTQ_INCOME_PROJECTION */]: yup3.string().nullable().required("This question is required"),
  ["RTQ_FINANCIAL_EMERGENCY_ABILITY" /* RTQ_FINANCIAL_EMERGENCY_ABILITY */]: yup3.string().nullable().required("This question is required"),
  ["RTQ_INCOME_PROTECTION_STATUS" /* RTQ_INCOME_PROJECTION_STATUS */]: yup3.string().nullable().required("This question is required"),
  ["RTQ_INVESTMENT_KNOWLEDGE" /* RTQ_INVESTMENT_KNOWLEDGE */]: yup3.string().nullable().required("This question is required"),
  ["RTQ_INVESTMENT_GOAL" /* RTQ_INVESTMENT_GOAL */]: yup3.string().nullable().required("This question is required"),
  ["RTQ_COVID_19_INVESTMENT_STRATEGY" /* RTQ_COVID_19_INVESTMENT_STRATEGY */]: yup3.string().nullable().required("This question is required"),
  ["RTQ_INVESTMENT_CHECK_FREQUENCY" /* RTQ_INVESTMENT_CHECK_FREQUENCY */]: yup3.string().nullable().required("This question is required"),
  ["RTQ_INVESTMENT_PORTFOLIO_CHOICE" /* RTQ_INVESTMENT_PORTFOLIO_CHOICE */]: yup3.string().nullable().required("This question is required")
});
var RISK_TOLERANCE_VALIDATION_MAP = {
  0: [
    "CAREER_STAGE_EXPANDED" /* CAREER_STAGE_EXPANDED */,
    "NOT_A_DOCTOR" /* NOT_A_DOCTOR */
  ],
  1: [
    "RTQ_EXPECTED_MONEY_NEED_PERIOD" /* RTQ_EXPECTED_MONEY_NEED_PERIOD */,
    "RTQ_INCOME_PROJECTION" /* RTQ_INCOME_PROJECTION */
  ],
  2: [
    "RTQ_FINANCIAL_EMERGENCY_ABILITY" /* RTQ_FINANCIAL_EMERGENCY_ABILITY */,
    "RTQ_INCOME_PROTECTION_STATUS" /* RTQ_INCOME_PROJECTION_STATUS */
  ],
  3: [
    "RTQ_INVESTMENT_KNOWLEDGE" /* RTQ_INVESTMENT_KNOWLEDGE */,
    "RTQ_INVESTMENT_GOAL" /* RTQ_INVESTMENT_GOAL */,
    "RTQ_COVID_19_INVESTMENT_STRATEGY" /* RTQ_COVID_19_INVESTMENT_STRATEGY */,
    "RTQ_INVESTMENT_CHECK_FREQUENCY" /* RTQ_INVESTMENT_CHECK_FREQUENCY */
  ],
  4: ["RTQ_INVESTMENT_PORTFOLIO_CHOICE" /* RTQ_INVESTMENT_PORTFOLIO_CHOICE */],
  5: []
};
var RISK_TOLERANCE_SCORE_MAP = {
  ["CAREER_STAGE_EXPANDED" /* CAREER_STAGE_EXPANDED */]: {
    ["MEDICAL_STUDENT" /* MEDICAL_STUDENT */]: 25,
    ["RESIDENT" /* RESIDENT */]: 25,
    ["PRACTICING_PHYSICIAN_EARLY" /* PRACTICING_PHYSICIAN_EARLY */]: 22,
    ["PRACTICING_PHYSICIAN_MID" /* PRACTICING_PHYSICIAN_MID */]: 15,
    ["PRACTICING_PHYSICIAN_LATE" /* PRACTICING_PHYSICIAN_LATE */]: 8,
    ["RETIRED_PHYSICIAN" /* RETIRED_PHYSICIAN */]: 0
  },
  ["RTQ_EXPECTED_MONEY_NEED_PERIOD" /* RTQ_EXPECTED_MONEY_NEED_PERIOD */]: {
    ["MORE_THAN_TWENTY_YEARS" /* MORE_THAN_TWENTY_YEARS */]: 25,
    ["TEN_TO_TWENTY_YEARS" /* TEN_TO_TWENTY_YEARS */]: 20,
    ["FIVE_TO_TEN_YEARS" /* FIVE_TO_TEN_YEARS */]: 10,
    ["IN_LESS_THAN_FIVE_YEARS" /* IN_LESS_THAN_FIVE_YEARS */]: 0,
    ["CURRENTLY_IN_WITHDRAWAL_PHASE" /* CURRENTLY_IN_WITHDRAWAL_PHASE */]: 0
  },
  ["RTQ_FINANCIAL_EMERGENCY_ABILITY" /* RTQ_FINANCIAL_EMERGENCY_ABILITY */]: {
    ["VERY_ABLE" /* VERY_ABLE */]: 5,
    ["MOSTLY" /* MOSTLY */]: 4,
    ["ABLE" /* ABLE */]: 3,
    ["SOMEWHAT" /* SOMEWHAT */]: 2,
    ["NOT_ABLE" /* NOT_ABLE */]: 0
  },
  ["RTQ_INCOME_PROTECTION_STATUS" /* RTQ_INCOME_PROJECTION_STATUS */]: {
    ["NOT_ADEQUATELY_PROTECTED" /* NOT_ADEQUATELY_PROTECTED */]: 0,
    ["ADEQUATELY_PROTECTED" /* ADEQUATELY_PROTECTED */]: 3,
    ["MORE_THAN_ADEQUATELY_PROTECTED" /* MORE_THAN_ADEQUATELY_PROTECTED */]: 5
  },
  ["RTQ_INCOME_PROJECTION" /* RTQ_INCOME_PROJECTION */]: {
    ["DECREASE_SWITCH_OR_RETIRE" /* DECREASE_SWITCH_OR_RETIRE */]: 0,
    ["DECREASE_SIGNIFICANTLY" /* DECREASE_SIGNIFICANTLY */]: 1,
    ["DECREASE_MODERATELY" /* DECREASE_MODERATELY */]: 2,
    ["STABLE" /* STABLE */]: 3,
    ["INCREASE_MODERATELY" /* INCREASE_MODERATELY */]: 4,
    ["INCREASE_SIGNIFICANTLY" /* INCREASE_SIGNIFICANTLY */]: 5
  },
  ["RTQ_INVESTMENT_GOAL" /* RTQ_INVESTMENT_GOAL */]: {
    ["AGGRESSIVE_GROWTH_LONG_TERM" /* AGGRESSIVE_GROWTH_LONG_TERM */]: 10,
    ["MODERATE_RISK_GROWTH" /* MODERATE_RISK_GROWTH */]: 7,
    ["GENERATE_INCOME" /* GENERATE_INCOME */]: 4,
    ["PROTECT_CURRENT_VALUE" /* PROTECT_CURRENT_VALUE */]: 0
  },
  ["RTQ_INVESTMENT_KNOWLEDGE" /* RTQ_INVESTMENT_KNOWLEDGE */]: {
    ["NONE" /* NONE */]: 0,
    ["LIMITED" /* LIMITED */]: 1,
    ["GENERAL" /* GENERAL */]: 3,
    ["COMPREHENSIVE" /* COMPREHENSIVE */]: 5
  },
  ["RTQ_COVID_19_INVESTMENT_STRATEGY" /* RTQ_COVID_19_INVESTMENT_STRATEGY */]: {
    ["INVESTED_MORE" /* INVESTED_MORE */]: 10,
    ["STAYED_COURSE" /* STAYED_COURSE */]: 6,
    ["MOVED_TO_BONDS" /* MOVED_TO_BONDS */]: 3,
    ["SOLD_FOR_CASH" /* SOLD_FOR_CASH */]: 0
  },
  ["RTQ_INVESTMENT_PORTFOLIO_CHOICE" /* RTQ_INVESTMENT_PORTFOLIO_CHOICE */]: {
    ["PORTFOLIO_A" /* PORTFOLIO_A */]: 5,
    ["PORTFOLIO_B" /* PORTFOLIO_B */]: 4,
    ["PORTFOLIO_C" /* PORTFOLIO_C */]: 3,
    ["PORTFOLIO_D" /* PORTFOLIO_D */]: 2,
    ["PORTFOLIO_E" /* PORTFOLIO_E */]: 0
  },
  ["RTQ_INVESTMENT_CHECK_FREQUENCY" /* RTQ_INVESTMENT_CHECK_FREQUENCY */]: {
    ["DAILY" /* DAILY */]: 0,
    ["ONCE_A_MONTH" /* ONCE_A_MONTH */]: 2,
    ["ONCE_A_QUARTER" /* ONCE_A_QUARTER */]: 4,
    ["ONCE_A_YEAR" /* ONCE_A_YEAR */]: 5
  }
};
var RISK_TOLERANCE_OPTIONS = [
  "0% Equities / 100% Fixed Income" /* STOCKS_0 */,
  "10% Equities / 90% Fixed Income" /* STOCKS_10 */,
  "20% Equities / 80% Fixed Income" /* STOCKS_20 */,
  "30% Equities / 70% Fixed Income" /* STOCKS_30 */,
  "40% Equities / 60% Fixed Income" /* STOCKS_40 */,
  "50% Equities / 50% Fixed Income" /* STOCKS_50 */,
  "60% Equities / 40% Fixed Income" /* STOCKS_60 */,
  "70% Equities / 30% Fixed Income" /* STOCKS_70 */,
  "80% Equities / 20% Fixed Income" /* STOCKS_80 */,
  "90% Equities / 10% Fixed Income" /* STOCKS_90 */,
  "100% Equities / 0% Fixed Income" /* STOCKS_100 */
];

// src/modules/risk-tolerance/components/RiskToleranceWizard/RiskToleranceWizard.tsx
var React15 = __toESM(require("react"));
var import_react_hook_form13 = require("react-hook-form");

// src/modules/risk-tolerance/components/RiskTolerancePageOne/RiskTolerancePageOne.tsx
var import_core26 = require("@earned/core");
var React14 = __toESM(require("react"));
var import_jsx_runtime38 = require("react/jsx-runtime");
var RiskTolerancePageOne = ({ register, formState, watch, setValue }) => {
  var _a;
  const notADoctor = watch("NOT_A_DOCTOR" /* NOT_A_DOCTOR */);
  React14.useEffect(() => {
    if (notADoctor) {
      setValue("CAREER_STAGE_EXPANDED" /* CAREER_STAGE_EXPANDED */, null);
    }
  }, [notADoctor, setValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime38.jsxs)("div", { "data-testid": "risk-tolerance-page-one", children: [
    /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(QuestionBlock_default, { label: "What is your Career Stage?", applyPadding: false, children: /* @__PURE__ */ (0, import_jsx_runtime38.jsxs)(
      import_core26.RadioGroup,
      {
        ...register("CAREER_STAGE_EXPANDED" /* CAREER_STAGE_EXPANDED */),
        error: (_a = formState.errors["CAREER_STAGE_EXPANDED" /* CAREER_STAGE_EXPANDED */]) == null ? void 0 : _a.message,
        disabled: notADoctor,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            import_core26.Radio,
            {
              label: "Medical Student",
              value: "MEDICAL_STUDENT" /* MEDICAL_STUDENT */,
              disabled: notADoctor
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            import_core26.Radio,
            {
              label: "Resident",
              value: "RESIDENT" /* RESIDENT */,
              disabled: notADoctor
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            import_core26.Radio,
            {
              label: "Early-Stage Practicing Doctor",
              value: "PRACTICING_PHYSICIAN_EARLY" /* PRACTICING_PHYSICIAN_EARLY */,
              disabled: notADoctor
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            import_core26.Radio,
            {
              label: "Mid-Stage Practicing Doctor",
              value: "PRACTICING_PHYSICIAN_MID" /* PRACTICING_PHYSICIAN_MID */,
              disabled: notADoctor
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            import_core26.Radio,
            {
              label: "Late-Stage Practicing Doctor",
              value: "PRACTICING_PHYSICIAN_LATE" /* PRACTICING_PHYSICIAN_LATE */,
              disabled: notADoctor
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
            import_core26.Radio,
            {
              label: "Retired",
              value: "RETIRED_PHYSICIAN" /* RETIRED_PHYSICIAN */,
              disabled: notADoctor
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
      import_core26.Checkbox,
      {
        label: "I am not a doctor",
        ...register("NOT_A_DOCTOR" /* NOT_A_DOCTOR */)
      }
    )
  ] });
};
var RiskTolerancePageOne_default = RiskTolerancePageOne;

// src/modules/risk-tolerance/components/RiskTolerancePageTwo/RiskTolerancePageTwo.tsx
var import_core27 = require("@earned/core");
var import_jsx_runtime39 = require("react/jsx-runtime");
var RiskTolerancePageTwo = ({ register, formState }) => {
  var _a, _b;
  return /* @__PURE__ */ (0, import_jsx_runtime39.jsxs)("div", { "data-testid": "risk-tolerance-page-two", children: [
    /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(QuestionBlock_default, { label: "When do you expect to need this money?", children: /* @__PURE__ */ (0, import_jsx_runtime39.jsxs)(
      import_core27.RadioGroup,
      {
        ...register("RTQ_EXPECTED_MONEY_NEED_PERIOD" /* RTQ_EXPECTED_MONEY_NEED_PERIOD */),
        error: (_a = formState.errors["RTQ_EXPECTED_MONEY_NEED_PERIOD" /* RTQ_EXPECTED_MONEY_NEED_PERIOD */]) == null ? void 0 : _a.message,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            import_core27.Radio,
            {
              label: "More than 20 years",
              value: "MORE_THAN_TWENTY_YEARS" /* MORE_THAN_TWENTY_YEARS */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            import_core27.Radio,
            {
              label: "10 - 20 years",
              value: "TEN_TO_TWENTY_YEARS" /* TEN_TO_TWENTY_YEARS */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            import_core27.Radio,
            {
              label: "5 - 10 years",
              value: "FIVE_TO_TEN_YEARS" /* FIVE_TO_TEN_YEARS */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            import_core27.Radio,
            {
              label: "In less than 5 years",
              value: "IN_LESS_THAN_FIVE_YEARS" /* IN_LESS_THAN_FIVE_YEARS */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            import_core27.Radio,
            {
              label: "Currently in withdrawal phase",
              value: "CURRENTLY_IN_WITHDRAWAL_PHASE" /* CURRENTLY_IN_WITHDRAWAL_PHASE */
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(QuestionBlock_default, { label: "How likely is your income to decrease or increase over the next five years?", children: /* @__PURE__ */ (0, import_jsx_runtime39.jsxs)(
      import_core27.RadioGroup,
      {
        ...register("RTQ_INCOME_PROJECTION" /* RTQ_INCOME_PROJECTION */),
        error: (_b = formState.errors["RTQ_INCOME_PROJECTION" /* RTQ_INCOME_PROJECTION */]) == null ? void 0 : _b.message,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            import_core27.Radio,
            {
              label: "Likely to decrease, as I am considering changing professions or retiring from practicing medicine",
              value: "DECREASE_SWITCH_OR_RETIRE" /* DECREASE_SWITCH_OR_RETIRE */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            import_core27.Radio,
            {
              label: "Likely to decrease significantly",
              value: "DECREASE_SIGNIFICANTLY" /* DECREASE_SIGNIFICANTLY */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            import_core27.Radio,
            {
              label: "Likely to decrease moderately",
              value: "DECREASE_MODERATELY" /* DECREASE_MODERATELY */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(import_core27.Radio, { label: "Likely to be stable", value: "STABLE" /* STABLE */ }),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            import_core27.Radio,
            {
              label: "Likely to increase moderately",
              value: "INCREASE_MODERATELY" /* INCREASE_MODERATELY */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
            import_core27.Radio,
            {
              label: "Likely to increase significantly",
              value: "INCREASE_SIGNIFICANTLY" /* INCREASE_SIGNIFICANTLY */
            }
          )
        ]
      }
    ) })
  ] });
};
var RiskTolerancePageTwo_default = RiskTolerancePageTwo;

// src/modules/risk-tolerance/components/RiskTolerancePageThree/RiskTolerancePageThree.tsx
var import_core28 = require("@earned/core");
var import_jsx_runtime40 = require("react/jsx-runtime");
var RiskTolerancePageThree = ({ register, formState }) => {
  var _a, _b;
  return /* @__PURE__ */ (0, import_jsx_runtime40.jsxs)("div", { "data-testid": "risk-tolerance-page-three", children: [
    /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(QuestionBlock_default, { label: "How able are you to handle financial emergencies with assets outside of your investment account(s)?", children: /* @__PURE__ */ (0, import_jsx_runtime40.jsxs)(
      import_core28.RadioGroup,
      {
        ...register(
          "RTQ_FINANCIAL_EMERGENCY_ABILITY" /* RTQ_FINANCIAL_EMERGENCY_ABILITY */
        ),
        error: (_a = formState.errors["RTQ_FINANCIAL_EMERGENCY_ABILITY" /* RTQ_FINANCIAL_EMERGENCY_ABILITY */]) == null ? void 0 : _a.message,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            import_core28.Radio,
            {
              label: "Very able",
              value: "VERY_ABLE" /* VERY_ABLE */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(import_core28.Radio, { label: "Mostly", value: "MOSTLY" /* MOSTLY */ }),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(import_core28.Radio, { label: "Able", value: "ABLE" /* ABLE */ }),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(import_core28.Radio, { label: "Somewhat", value: "SOMEWHAT" /* SOMEWHAT */ }),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(import_core28.Radio, { label: "Not Able", value: "NOT_ABLE" /* NOT_ABLE */ })
        ]
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(QuestionBlock_default, { label: "How well protected is your income if you become disabled or sued for malpractice?", children: /* @__PURE__ */ (0, import_jsx_runtime40.jsxs)(
      import_core28.RadioGroup,
      {
        ...register("RTQ_INCOME_PROTECTION_STATUS" /* RTQ_INCOME_PROJECTION_STATUS */),
        error: (_b = formState.errors["RTQ_INCOME_PROTECTION_STATUS" /* RTQ_INCOME_PROJECTION_STATUS */]) == null ? void 0 : _b.message,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            import_core28.Radio,
            {
              label: "My income may not be adequately protected",
              value: "NOT_ADEQUATELY_PROTECTED" /* NOT_ADEQUATELY_PROTECTED */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            import_core28.Radio,
            {
              label: "My income is adequately protected",
              value: "ADEQUATELY_PROTECTED" /* ADEQUATELY_PROTECTED */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
            import_core28.Radio,
            {
              label: "My income is more than adequately protected",
              value: "MORE_THAN_ADEQUATELY_PROTECTED" /* MORE_THAN_ADEQUATELY_PROTECTED */
            }
          )
        ]
      }
    ) })
  ] });
};
var RiskTolerancePageThree_default = RiskTolerancePageThree;

// src/modules/risk-tolerance/components/RiskTolerancePageFour/RiskTolerancePageFour.tsx
var import_core29 = require("@earned/core");
var import_jsx_runtime41 = require("react/jsx-runtime");
var RiskTolerancePageFour = ({ register, formState }) => {
  var _a, _b, _c, _d;
  return /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)("div", { "data-testid": "risk-tolerance-page-four", children: [
    /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(QuestionBlock_default, { label: "How would you describe your investment knowledge?", children: /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)(
      import_core29.RadioGroup,
      {
        ...register("RTQ_INVESTMENT_KNOWLEDGE" /* RTQ_INVESTMENT_KNOWLEDGE */),
        error: (_a = formState.errors["RTQ_INVESTMENT_KNOWLEDGE" /* RTQ_INVESTMENT_KNOWLEDGE */]) == null ? void 0 : _a.message,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "None",
              value: "NONE" /* NONE */,
              helperText: "The financial markets are a mystery to me"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "Limited",
              value: "LIMITED" /* LIMITED */,
              helperText: "I understand the basics like the difference between a stock and a bond"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "General",
              value: "GENERAL" /* GENERAL */,
              helperText: "I understand how to interpret my investment statements"
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "Comprehensive",
              value: "COMPREHENSIVE" /* COMPREHENSIVE */,
              helperText: "If I had time, I could write a book on investing"
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(QuestionBlock_default, { label: "Which investment goal do you value the most?", children: /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)(
      import_core29.RadioGroup,
      {
        ...register("RTQ_INVESTMENT_GOAL" /* RTQ_INVESTMENT_GOAL */),
        error: (_b = formState.errors["RTQ_INVESTMENT_GOAL" /* RTQ_INVESTMENT_GOAL */]) == null ? void 0 : _b.message,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "Aggressively grow my investments for the long term",
              value: "AGGRESSIVE_GROWTH_LONG_TERM" /* AGGRESSIVE_GROWTH_LONG_TERM */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "Grow my investments with moderate risk",
              value: "MODERATE_RISK_GROWTH" /* MODERATE_RISK_GROWTH */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "Generate investment income",
              value: "GENERATE_INCOME" /* GENERATE_INCOME */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "Protect the current value of my investments",
              value: "PROTECT_CURRENT_VALUE" /* PROTECT_CURRENT_VALUE */
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(QuestionBlock_default, { label: "When the market dropped sharply during the onset of COVID-19, what changes did you make to your investments?", children: /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)(
      import_core29.RadioGroup,
      {
        ...register(
          "RTQ_COVID_19_INVESTMENT_STRATEGY" /* RTQ_COVID_19_INVESTMENT_STRATEGY */
        ),
        error: (_c = formState.errors["RTQ_COVID_19_INVESTMENT_STRATEGY" /* RTQ_COVID_19_INVESTMENT_STRATEGY */]) == null ? void 0 : _c.message,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "Invested more money in the market",
              value: "INVESTED_MORE" /* INVESTED_MORE */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "Stayed the course",
              value: "STAYED_COURSE" /* STAYED_COURSE */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "Moved a portion of my stocks to bonds",
              value: "MOVED_TO_BONDS" /* MOVED_TO_BONDS */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "Sold most of my investments and went to cash",
              value: "SOLD_FOR_CASH" /* SOLD_FOR_CASH */
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(QuestionBlock_default, { label: "How frequently do you check the value of your investments?", children: /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)(
      import_core29.RadioGroup,
      {
        ...register("RTQ_INVESTMENT_CHECK_FREQUENCY" /* RTQ_INVESTMENT_CHECK_FREQUENCY */),
        error: (_d = formState.errors["RTQ_INVESTMENT_CHECK_FREQUENCY" /* RTQ_INVESTMENT_CHECK_FREQUENCY */]) == null ? void 0 : _d.message,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(import_core29.Radio, { label: "Daily", value: "DAILY" /* DAILY */ }),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "About once a month",
              value: "ONCE_A_MONTH" /* ONCE_A_MONTH */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "About once a quarter",
              value: "ONCE_A_QUARTER" /* ONCE_A_QUARTER */
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            import_core29.Radio,
            {
              label: "Maybe once a year",
              value: "ONCE_A_YEAR" /* ONCE_A_YEAR */
            }
          )
        ]
      }
    ) })
  ] });
};
var RiskTolerancePageFour_default = RiskTolerancePageFour;

// src/modules/risk-tolerance/components/RiskToleranceReviewPage/RiskToleranceReviewPage.tsx
var import_core30 = require("@earned/core");
var import_jsx_runtime42 = require("react/jsx-runtime");
var RiskToleranceReviewPage = ({
  riskTolerance
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)("div", { "data-testid": "risk-tolerance-review-page", children: [
    /* @__PURE__ */ (0, import_jsx_runtime42.jsx)("div", { className: "pb-2", children: /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(import_core30.Typography, { variant: "body", color: "secondary", children: "Your Risk Tolerance is:" }) }),
    /* @__PURE__ */ (0, import_jsx_runtime42.jsx)("div", { className: "pb-10", children: /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(import_core30.Typography, { variant: "title-md", weight: "medium", color: "primary", children: riskTolerance }) }),
    /* @__PURE__ */ (0, import_jsx_runtime42.jsx)("div", { className: "flex flex-col gap-4", children: RISK_TOLERANCE_OPTIONS.map((opt) => /* @__PURE__ */ (0, import_jsx_runtime42.jsx)("div", { children: opt === riskTolerance ? /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(import_core30.Typography, { variant: "body", weight: "medium", color: "primary", children: opt }) : /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(import_core30.Typography, { variant: "body", color: "secondary", children: opt }) }, opt)) })
  ] });
};
var RiskToleranceReviewPage_default = RiskToleranceReviewPage;

// src/modules/risk-tolerance/components/RiskTolerancePageFive/RiskTolerancePageFive.tsx
var import_core31 = require("@earned/core");
var import_jsx_runtime43 = require("react/jsx-runtime");
var RiskTolerancePageFive = ({ register, formState }) => {
  var _a;
  return /* @__PURE__ */ (0, import_jsx_runtime43.jsx)("div", { "data-testid": "risk-tolerance-page-five", children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(QuestionBlock_default, { label: "Assume you are investing $100,000 and can choose from the five hypothetical portfolios shown below. The dollar values for each portfolio represent two possible returns - low and high - after one year.", children: /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)(
    import_core31.RadioGroup,
    {
      ...register(
        "RTQ_INVESTMENT_PORTFOLIO_CHOICE" /* RTQ_INVESTMENT_PORTFOLIO_CHOICE */
      ),
      error: (_a = formState.errors["RTQ_INVESTMENT_PORTFOLIO_CHOICE" /* RTQ_INVESTMENT_PORTFOLIO_CHOICE */]) == null ? void 0 : _a.message,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
          import_core31.Radio,
          {
            label: "Portfolio A",
            value: "PORTFOLIO_A" /* PORTFOLIO_A */,
            helperText: "High Value: $160,000, Low Value: $55,000"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
          import_core31.Radio,
          {
            label: "Portfolio B",
            value: "PORTFOLIO_B" /* PORTFOLIO_B */,
            helperText: "High Value: $150,000, Low Value: $65,000"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
          import_core31.Radio,
          {
            label: "Portfolio C",
            value: "PORTFOLIO_C" /* PORTFOLIO_C */,
            helperText: "High Value: $135,000, Low Value: $75,000"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
          import_core31.Radio,
          {
            label: "Portfolio D",
            value: "PORTFOLIO_D" /* PORTFOLIO_D */,
            helperText: "High Value: $125,000, Low Value: $85,000"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
          import_core31.Radio,
          {
            label: "Portfolio E",
            value: "PORTFOLIO_E" /* PORTFOLIO_E */,
            helperText: "High Value: $110,000, Low Value: $95,000"
          }
        )
      ]
    }
  ) }) });
};
var RiskTolerancePageFive_default = RiskTolerancePageFive;

// src/modules/risk-tolerance/hooks.ts
var import_react4 = require("react");

// src/modules/risk-tolerance/helper.ts
var getPortfolioTypeFromRiskScore = (riskScore) => {
  switch (true) {
    case riskScore >= 91:
      return "100% Equities / 0% Fixed Income" /* STOCKS_100 */;
    case riskScore >= 82:
      return "90% Equities / 10% Fixed Income" /* STOCKS_90 */;
    case riskScore >= 73:
      return "80% Equities / 20% Fixed Income" /* STOCKS_80 */;
    case riskScore >= 64:
      return "70% Equities / 30% Fixed Income" /* STOCKS_70 */;
    case riskScore >= 55:
      return "60% Equities / 40% Fixed Income" /* STOCKS_60 */;
    case riskScore >= 46:
      return "50% Equities / 50% Fixed Income" /* STOCKS_50 */;
    case riskScore >= 37:
      return "40% Equities / 60% Fixed Income" /* STOCKS_40 */;
    case riskScore >= 28:
      return "30% Equities / 70% Fixed Income" /* STOCKS_30 */;
    case riskScore >= 19:
      return "20% Equities / 80% Fixed Income" /* STOCKS_20 */;
    case riskScore >= 10:
      return "10% Equities / 90% Fixed Income" /* STOCKS_10 */;
    default:
      return "0% Equities / 100% Fixed Income" /* STOCKS_0 */;
  }
};

// src/modules/risk-tolerance/hooks.ts
var useRiskToleranceResults = (fields) => {
  const riskScore = (0, import_react4.useMemo)(() => {
    return Object.keys(RISK_TOLERANCE_SCORE_MAP).reduce((sum, key) => {
      const fieldKey = key;
      const fieldValue = fields[fieldKey];
      if (!fieldValue)
        return sum;
      const fieldScores = RISK_TOLERANCE_SCORE_MAP[fieldKey];
      return sum + fieldScores[fieldValue];
    }, 0);
  }, [fields]);
  const riskTolerance = (0, import_react4.useMemo)(() => {
    return getPortfolioTypeFromRiskScore(riskScore);
  }, [riskScore]);
  return {
    riskTolerance,
    riskScore
  };
};

// src/modules/risk-tolerance/components/RiskToleranceWizard/RiskToleranceWizard.tsx
var import_yup4 = require("@hookform/resolvers/yup");
var import_jsx_runtime44 = require("react/jsx-runtime");
var RiskToleranceWizard = ({
  isOpen,
  close,
  cache,
  onSubmit,
  isSuccess,
  onDone,
  isSubmitting = false,
  isLoading = false,
  modalRootSelector = "body",
  infoOwnerName
}) => {
  const { isFirst, isLast, currentPage, goNext, goBack, reset, progress } = useWizardControls({ pages: RISK_TOLERANCE_PAGE_COUNT });
  const {
    register,
    getValues,
    formState,
    handleSubmit: submit,
    trigger,
    setValue,
    watch
  } = (0, import_react_hook_form13.useForm)({
    values: cache ? cache : void 0,
    mode: "onTouched",
    resolver: (0, import_yup4.yupResolver)(RISK_TOLERANCE_FORM_SCHEMA)
  });
  const fieldValues = getValues();
  const { riskTolerance, riskScore } = useRiskToleranceResults(fieldValues);
  const subtitle = React15.useMemo(() => {
    if (isFirst)
      return "Please provide the necessary information for us to finalize your profile. This information help be used to help use setup different investment accounts and insurance polices.";
    if (isLast)
      return "Results";
    return "";
  }, [isFirst, isLast]);
  const nextLabel = React15.useMemo(() => isLast ? "Submit" : "Next", [isLast]);
  const handleSubmit = React15.useCallback(
    (fields) => {
      onSubmit(fields);
    },
    [onSubmit]
  );
  const handleNext = React15.useCallback(() => {
    trigger(RISK_TOLERANCE_VALIDATION_MAP[currentPage]).then((valid) => {
      if (valid)
        goNext();
    });
  }, [trigger, goNext, currentPage]);
  const renderPages = React15.useCallback(() => {
    switch (currentPage) {
      case 0:
        return /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
          RiskTolerancePageOne_default,
          {
            register,
            formState,
            fields: fieldValues,
            setValue,
            watch
          }
        );
      case 1:
        return /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
          RiskTolerancePageTwo_default,
          {
            register,
            formState,
            fields: fieldValues,
            setValue
          }
        );
      case 2:
        return /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
          RiskTolerancePageThree_default,
          {
            register,
            formState,
            fields: fieldValues,
            setValue
          }
        );
      case 3:
        return /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
          RiskTolerancePageFour_default,
          {
            register,
            formState,
            fields: fieldValues,
            setValue
          }
        );
      case 4:
        return /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
          RiskTolerancePageFive_default,
          {
            register,
            formState,
            fields: fieldValues,
            setValue
          }
        );
      case 5:
        return /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(RiskToleranceReviewPage_default, { riskTolerance });
      default:
        return /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(import_jsx_runtime44.Fragment, {});
    }
  }, [
    currentPage,
    register,
    fieldValues,
    formState,
    riskTolerance,
    setValue,
    watch
  ]);
  console.log(formState.errors);
  React15.useEffect(() => {
    if (isLast)
      trigger();
  }, [isLast, trigger]);
  React15.useEffect(() => {
    const subscription = watch((fields) => {
      const expandedFields = [
        "PRACTICING_PHYSICIAN_EARLY" /* PRACTICING_PHYSICIAN_EARLY */,
        "PRACTICING_PHYSICIAN_MID" /* PRACTICING_PHYSICIAN_MID */,
        "PRACTICING_PHYSICIAN_LATE" /* PRACTICING_PHYSICIAN_LATE */
      ];
      const careerStage = fields["CAREER_STAGE" /* CAREER_STAGE */];
      const expandedCareerStage = fields["CAREER_STAGE_EXPANDED" /* CAREER_STAGE_EXPANDED */];
      if (expandedFields.includes(expandedCareerStage) && careerStage !== "PRACTICING_PHYSICIAN" /* PRACTICING_PHYSICIAN */) {
        setValue(
          "CAREER_STAGE" /* CAREER_STAGE */,
          "PRACTICING_PHYSICIAN" /* PRACTICING_PHYSICIAN */
        );
      }
      if (!expandedFields.includes(expandedCareerStage) && careerStage !== expandedCareerStage) {
        setValue(
          "CAREER_STAGE" /* CAREER_STAGE */,
          expandedCareerStage
        );
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, setValue]);
  React15.useEffect(() => {
    setValue("RTQ_SCORE" /* RTQ_SCORE */, riskScore);
  }, [riskScore, setValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime44.jsx)("div", { "data-testid": "risk-tolerance-wizard", children: /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
    Modal_default,
    {
      title: "Risk Tolerance",
      titleTag: infoOwnerName,
      subtitle,
      open: isOpen,
      close,
      showConfirmation: isSuccess,
      progressPercentage: isLoading ? 0 : progress,
      renderConfirmation: () => /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(SuccessPanel_default, { onDone }),
      showProgressBar: true,
      rootSelector: modalRootSelector,
      children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime44.jsx)("div", { className: "flex flex-row justify-center", children: /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(LoadingIndicator_default, {}) }) : /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)("form", { onSubmit: submit(handleSubmit), children: [
        renderPages(),
        /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
          Footer_default,
          {
            onNextClick: handleNext,
            onPreviousClick: goBack,
            nextDisabled: isLast && (!formState.isValid || isSubmitting),
            showPrevious: !isFirst,
            submitMode: isLast,
            nextLabel,
            submitting: isLast && isSubmitting
          }
        )
      ] })
    }
  ) });
};
var RiskToleranceWizard_default = RiskToleranceWizard;

// src/modules/money-guide-pro/components/MGPWizard/MGPWizard.tsx
var React45 = __toESM(require("react"));

// src/modules/money-guide-pro/types.ts
var MgpGoalType = /* @__PURE__ */ ((MgpGoalType2) => {
  MgpGoalType2["TRAVEL"] = "TRAVEL";
  MgpGoalType2["CAR"] = "CAR";
  MgpGoalType2["LEAVE_BEQUEST"] = "LEAVE_BEQUEST";
  MgpGoalType2["CELEBRATION"] = "CELEBRATION";
  MgpGoalType2["PRIVATE_SCHOOL"] = "PRIVATE_SCHOOL";
  MgpGoalType2["COLLEGE"] = "COLLEGE";
  MgpGoalType2["PROVIDE_CARE"] = "PROVIDE_CARE";
  MgpGoalType2["MAJOR_PURCHASE"] = "MAJOR_PURCHASE";
  MgpGoalType2["WEDDING"] = "WEDDING";
  MgpGoalType2["START_BUSINESS"] = "START_BUSINESS";
  MgpGoalType2["NEW_HOME"] = "NEW_HOME";
  MgpGoalType2["GIFT_OR_DONATION"] = "GIFT_OR_DONATION";
  MgpGoalType2["HOME_IMPROVEMENT"] = "HOME_IMPROVEMENT";
  MgpGoalType2["INSURANCE_POLICY_PREMIUM"] = "INSURANCE_POLICY_PREMIUM";
  return MgpGoalType2;
})(MgpGoalType || {});

// src/modules/money-guide-pro/constants.ts
var import_core32 = require("@earned/core");
var NO_SELECTION_OPTION2 = {
  id: import_core32.DEFAULT_NO_SELECTION_ID,
  label: "Select an option",
  value: void 0
};
var IMPORTANT_RELATIONSHIPS_PERSON_RELATIONSHIP_OPTIONS = [
  NO_SELECTION_OPTION2,
  { label: "Child", value: "CHILD", id: "CHILD" },
  { label: "Grandchild", value: "GRANDCHILD", id: "GRANDCHILD" },
  {
    label: "Great Grandchild",
    value: "GREAT_GRANDCHILD",
    id: "GREAT_GRANDCHILD"
  },
  { label: "Parent", value: "PARENT", id: "PARENT" },
  { label: "Sibling", value: "SIBLING", id: "SIBLING" },
  { label: "Niece or Nephew", value: "NIECE_OR_NEPHEW", id: "NIECE_OR_NEPHEW" },
  { label: "Aunt or Uncle", value: "AUNT_OR_UNCLE", id: "AUNT_OR_UNCLE" },
  { label: "Cousin", value: "COUSIN", id: "COUSIN" },
  { label: "Friend", value: "FRIEND", id: "FRIEND" },
  { label: "Trusted Contact", value: "TRUSTED_CONTACT", id: "TRUSTED_CONTACT" },
  { label: "Other", value: "OTHER", id: "OTHER" }
];
var IMPORTANT_RELATIONSHIP_ORGANIZATION_TYPE_OPTIONS = [
  NO_SELECTION_OPTION2,
  { label: "Trust", value: "TRUST", id: "trust" },
  {
    label: "Religious Organization",
    value: "RELIGIOUS",
    id: "RELIGIOUS"
  },
  { label: "Charity", value: "CHARITY", id: "CHARITY" },
  { label: "Business", value: "BUSINESS", id: "BUSINESS" }
];
var IMPORTANT_RELATIONSHIP_BASE_DEPENDENT_STATUS_OPTIONS = [
  NO_SELECTION_OPTION2,
  {
    label: "Not a Dependent",
    value: "NOT_A_DEPENDENT",
    id: "NOT_A_DEPENDENT"
  },
  {
    label: "Dependent of Both",
    value: "DEPENDENT_OF_BOTH",
    id: "DEPENDENT_OF_BOTH"
  }
];
var IMPORTANT_RELATIONSHIP_TYPE = {
  PERSON: "PERSON",
  ORGANIZATION: "ORGANIZATION"
};
var CAREER_CHANGE_OPTIONS = [
  {
    label: "Retirement/Semi-Retirement",
    value: "RETIREMENT",
    id: "RETIREMENT",
    inputKey: "CAREER_CHANGE_RETIREMENT" /* CAREER_CHANGE_RETIREMENT */
  },
  {
    label: "Job Change",
    value: "JOB_CHANGE",
    id: "JOB_CHANGE",
    inputKey: "CAREER_CHANGE_JOB_CHANGE" /* CAREER_CHANGE_JOB_CHANGE */
  },
  {
    label: "Business Sale",
    value: "SELL_BUSINESS",
    id: "SELL_BUSINESS",
    inputKey: "CAREER_CHANGE_SELL_BUSINESS" /* CAREER_CHANGE_SELL_BUSINESS */
  },
  {
    label: "Other",
    value: "OTHER",
    id: "OTHER",
    inputKey: "CAREER_CHANGE_OTHER" /* CAREER_CHANGE_OTHER */
  }
];
var EMPLOYMENT_TYPE = {
  EMPLOYEE: "EMPLOYEE",
  CONTRACTOR: "CONTRACTOR",
  BUSINESS_OWNER: "BUSINESS_OWNER",
  OTHER: "OTHER"
};
var EMPLOYMENT_TYPE_OPTIONS = [
  {
    label: "Employee",
    value: EMPLOYMENT_TYPE.EMPLOYEE,
    id: EMPLOYMENT_TYPE.EMPLOYEE
  },
  {
    label: "Contractor",
    value: EMPLOYMENT_TYPE.CONTRACTOR,
    id: EMPLOYMENT_TYPE.CONTRACTOR
  },
  {
    label: "Business Owner",
    value: EMPLOYMENT_TYPE.BUSINESS_OWNER,
    id: EMPLOYMENT_TYPE.BUSINESS_OWNER
  },
  {
    label: "Other",
    value: EMPLOYMENT_TYPE.OTHER,
    id: EMPLOYMENT_TYPE.OTHER
  }
];
var GOALS_OPTIONS = [
  {
    label: "Travel",
    value: "TRAVEL" /* TRAVEL */
  },
  {
    label: "Car",
    value: "CAR" /* CAR */
  },
  {
    label: "Leave Bequest",
    value: "LEAVE_BEQUEST" /* LEAVE_BEQUEST */
  },
  {
    label: "Celebration",
    value: "CELEBRATION" /* CELEBRATION */
  },
  {
    label: "Private School",
    value: "PRIVATE_SCHOOL" /* PRIVATE_SCHOOL */
  },
  {
    label: "College",
    value: "COLLEGE" /* COLLEGE */
  },
  {
    label: "Provide Care",
    value: "PROVIDE_CARE" /* PROVIDE_CARE */
  },
  {
    label: "Major Purchase",
    value: "MAJOR_PURCHASE" /* MAJOR_PURCHASE */
  },
  {
    label: "Wedding",
    value: "WEDDING" /* WEDDING */
  },
  {
    label: "Start a Business",
    value: "START_BUSINESS" /* START_BUSINESS */
  },
  {
    label: "New Home",
    value: "NEW_HOME" /* NEW_HOME */
  },
  {
    label: "Gift or Donation",
    value: "GIFT_OR_DONATION" /* GIFT_OR_DONATION */
  },
  {
    label: "Home Improvement",
    value: "HOME_IMPROVEMENT" /* HOME_IMPROVEMENT */
  },
  {
    label: "Insurance Policy Premium",
    value: "INSURANCE_POLICY_PREMIUM" /* INSURANCE_POLICY_PREMIUM */
  }
];
var ADDITIONAL_INCOME_SOURCE_OPTIONS = [
  NO_SELECTION_OPTION2,
  {
    label: "Pension Income",
    value: "PENSION",
    id: "PENSION"
  },
  {
    label: "Royalties",
    value: "ROYALTIES",
    id: "ROYALTIES"
  },
  {
    label: "Annuity Income",
    value: "ANNUITY",
    id: "ANNUITY"
  },
  {
    label: "Alimony",
    value: "ALIMONY",
    id: "ALIMONY"
  },
  {
    label: "Rental Property Income",
    value: "RENTAL_PROPERTY",
    id: "RENTAL_PROPERTY"
  },
  {
    label: "Part-Time Employment",
    value: "PART_TIME",
    id: "PART_TIME"
  },
  {
    label: "Reverse Mortgage Proceeds",
    value: "REVERSE_MORTGAGE",
    id: "REVERSE_MORTGAGE"
  },
  { label: "Other Income", value: "OTHER", id: "OTHER" }
];
var WILLING_TO_RETIRE_LATER_OPTIONS = [
  { label: "Not at all", value: "NOT_AT_ALL", id: "NOT_AT_ALL" },
  { label: "Slightly", value: "SLIGHTLY", id: "SLIGHTLY" },
  { label: "Somewhat", value: "SOMEWHAT", id: "SOMEWHAT" },
  { label: "Very", value: "VERY", id: "VERY" }
];
var CONSIDER_PART_TIME_RETIREMENT_OPTIONS = [
  { label: "Yes", value: "YES", id: "YES" },
  { label: "No", value: "NO", id: "NO" },
  { label: "Maybe/Unsure", value: "MAYBE", id: "MAYBE" }
];
var INSURANCE_POLICIES_OPTIONS = [
  { label: "Term Life", value: "TERM_LIFE", id: "TERM_LIFE" },
  { label: "Whole Life", value: "WHOLE_LIFE", id: "WHOLE_LIFE" },
  { label: "Universal Life", value: "UNIVERSAL_LIFE", id: "UNIVERSAL_LIFE" },
  { label: "Disability", value: "DISABILITY", id: "DISABILITY" },
  { label: "Long-term Care", value: "LONG_TERM_CARE", id: "LONG_TERM_CARE" }
];
var ESTATE_PLANNING_OPTIONS = [
  {
    label: "Last Will and Testament",
    value: "LAST_WILL_AND_TESTAMENT",
    id: "LAST_WILL_AND_TESTAMENT"
  },
  {
    label: "General Power of Attorney",
    value: "GENERAL_POWER_OF_ATTORNEY",
    id: "GENERAL_POWER_OF_ATTORNEY"
  },
  {
    label: "Durable Power of Attorney",
    value: "DURABLE_POWER_OF_ATTORNEY",
    id: "DURABLE_POWER_OF_ATTORNEY"
  },
  {
    label: "Healthcare Power of Attorney",
    value: "HEALTHCARE_POWER_OF_ATTORNEY",
    id: "HEALTHCARE_POWER_OF_ATTORNEY"
  },
  { label: "Living Trust", value: "LIVING_TRUST", id: "LIVING_TRUST" },
  {
    label: "Healthcare Directive",
    value: "HEALTHCARE_DIRECTIVE",
    id: "HEALTHCARE_DIRECTIVE"
  }
];
var HELPER_FIELDS = {
  IMPORTANT_RELATIONSHIP_SELECT: "IMPORTANT_RELATIONSHIP_SELECT",
  CUSTOM_GOAL: "CUSTOM_GOAL"
};
var IMPORTANT_RELATIONSHIP_PERSON_SCHEMA = yup_extend_default.object({
  ["TYPE" /* TYPE */]: yup_extend_default.mixed().oneOf([IMPORTANT_RELATIONSHIP_TYPE.PERSON]).default(IMPORTANT_RELATIONSHIP_TYPE.PERSON).defined(),
  ["FIRST_NAME" /* FIRST_NAME */]: yup_extend_default.string().required("Enter first name"),
  ["LAST_NAME" /* LAST_NAME */]: yup_extend_default.string().required("Enter last name"),
  ["RELATIONSHIP" /* RELATIONSHIP */]: yup_extend_default.string().required("Select relationship").default(IMPORTANT_RELATIONSHIPS_PERSON_RELATIONSHIP_OPTIONS[0].value),
  ["DOB" /* DOB */]: yup_extend_default.string().transform(transformers.form.date).test("dob", "Enter valid date of birth", validators.date),
  ["DEPENDENT_STATUS" /* DEPENDENT_STATUS */]: yup_extend_default.string().required("Select dependent status").default(IMPORTANT_RELATIONSHIP_BASE_DEPENDENT_STATUS_OPTIONS[0].value)
});
var IMPORTANT_RELATIONSHIP_ORGANIZATION_SCHEMA = yup_extend_default.object({
  ["TYPE" /* TYPE */]: yup_extend_default.mixed().oneOf([IMPORTANT_RELATIONSHIP_TYPE.ORGANIZATION]).default(IMPORTANT_RELATIONSHIP_TYPE.ORGANIZATION).defined(),
  ["NAME" /* NAME */]: yup_extend_default.string().required("Enter organization name"),
  ["ORGANIZATION_TYPE" /* ORGANIZATION_TYPE */]: yup_extend_default.string().required("Select organization type").default(IMPORTANT_RELATIONSHIP_ORGANIZATION_TYPE_OPTIONS[0].value)
});
var MGP_CLIENT_SCHEMA = yup_extend_default.object({
  ["EMPLOYER_NAME" /* EMPLOYER_NAME */]: yup_extend_default.string(),
  ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.string().currency().required("Enter annual income"),
  ["FIRST_NAME" /* FIRST_NAME */]: yup_extend_default.string(),
  ["LAST_NAME" /* LAST_NAME */]: yup_extend_default.string(),
  ["CAREER_CHANGE" /* CAREER_CHANGE */]: yup_extend_default.array().of(yup_extend_default.string().required()).required().default([]),
  ["CAREER_CHANGE_RETIREMENT" /* CAREER_CHANGE_RETIREMENT */]: yup_extend_default.string().when("CAREER_CHANGE" /* CAREER_CHANGE */, {
    is: (careerChange) => careerChange == null ? void 0 : careerChange.includes("RETIREMENT"),
    then: (schema) => schema.required("Describe retirement/semi-retirement"),
    otherwise: (schema) => schema.optional()
  }),
  ["CAREER_CHANGE_JOB_CHANGE" /* CAREER_CHANGE_JOB_CHANGE */]: yup_extend_default.string().when("CAREER_CHANGE" /* CAREER_CHANGE */, {
    is: (careerChange) => careerChange == null ? void 0 : careerChange.includes("JOB_CHANGE"),
    then: (schema) => schema.required("Describe job change"),
    otherwise: (schema) => schema.optional()
  }),
  ["CAREER_CHANGE_SELL_BUSINESS" /* CAREER_CHANGE_SELL_BUSINESS */]: yup_extend_default.string().when("CAREER_CHANGE" /* CAREER_CHANGE */, {
    is: (careerChange) => careerChange == null ? void 0 : careerChange.includes("SELL_BUSINESS"),
    then: (schema) => schema.required("Describe business sale"),
    otherwise: (schema) => schema.optional()
  }),
  ["CAREER_CHANGE_OTHER" /* CAREER_CHANGE_OTHER */]: yup_extend_default.string().when("CAREER_CHANGE" /* CAREER_CHANGE */, {
    is: (careerChange) => careerChange == null ? void 0 : careerChange.includes("OTHER"),
    then: (schema) => schema.required("Describe other"),
    otherwise: (schema) => schema.optional()
  }),
  ["TARGET_RETIREMENT_AGE" /* TARGET_RETIREMENT_AGE */]: yup_extend_default.string().required("Enter target retirement age"),
  ["WILLING_TO_RETIRE_LATER" /* WILLING_TO_RETIRE_LATER */]: yup_extend_default.string().required("Please select an option.").nullable(),
  ["CONSIDER_PART_TIME_RETIREMENT" /* CONSIDER_PART_TIME_RETIREMENT */]: yup_extend_default.string().required("Please select an option.").nullable(),
  ["CURRENT_INSURANCE_POLICIES" /* CURRENT_INSURANCE_POLICIES */]: yup_extend_default.array().of(yup_extend_default.string()).defined().default([]),
  ["CURRENT_ESTATE_PLANNING" /* CURRENT_ESTATE_PLANNING */]: yup_extend_default.array().of(yup_extend_default.string()).defined().default([]),
  ["CLIENT_ID" /* CLIENT_ID */]: yup_extend_default.string().optional()
});
var MGP_CO_CLIENT_SCHEMA = MGP_CLIENT_SCHEMA.clone().shape({
  ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.string().currency().when("FIRST_NAME", {
    is: (firstName) => !!(firstName == null ? void 0 : firstName.trim()),
    then: (schema) => schema.required("Enter annual income"),
    otherwise: (schema) => schema.optional()
  }),
  ["TARGET_RETIREMENT_AGE" /* TARGET_RETIREMENT_AGE */]: yup_extend_default.string().when("FIRST_NAME", {
    is: (firstName) => !!(firstName == null ? void 0 : firstName.trim()),
    then: (schema) => schema.required("Enter target retirement age"),
    otherwise: (schema) => schema.optional()
  }),
  ["WILLING_TO_RETIRE_LATER" /* WILLING_TO_RETIRE_LATER */]: yup_extend_default.string().when("FIRST_NAME", {
    is: (firstName) => !!(firstName == null ? void 0 : firstName.trim()),
    then: (schema) => schema.required("Enter first name"),
    otherwise: (schema) => schema.optional()
  }),
  ["CONSIDER_PART_TIME_RETIREMENT" /* CONSIDER_PART_TIME_RETIREMENT */]: yup_extend_default.string().when("FIRST_NAME", {
    is: (firstName) => !!(firstName == null ? void 0 : firstName.trim()),
    then: (schema) => schema.required("Enter first name"),
    otherwise: (schema) => schema.optional()
  })
});
var MGP_IMPORTANT_RELATIONSHIP_SCHEMA = yup_extend_default.array().of(
  yup_extend_default.mixed().test("is-valid-relationship", "Invalid relationship", function(value) {
    if (!value)
      return false;
    if (value.TYPE === IMPORTANT_RELATIONSHIP_TYPE.PERSON) {
      return IMPORTANT_RELATIONSHIP_PERSON_SCHEMA.isValidSync(value);
    }
    return IMPORTANT_RELATIONSHIP_ORGANIZATION_SCHEMA.isValidSync(value);
  })
).defined().default([]);
var MGP_EMPLOYMENT_SCHEMA = yup_extend_default.object({
  ["TITLE" /* TITLE */]: yup_extend_default.string().required("Enter title"),
  ["EMPLOYER_NAME" /* EMPLOYER_NAME */]: yup_extend_default.string().required("Enter employer name"),
  ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.string().currency().required("Enter valid amount"),
  ["TYPE" /* TYPE */]: yup_extend_default.string().required("Please select an employment type.").nullable(),
  ["OTHER_TYPE" /* OTHER_TYPE */]: yup_extend_default.string().when("TYPE" /* TYPE */, {
    is: (type) => type === EMPLOYMENT_TYPE.OTHER,
    then: (schema) => schema.required("Enter other employment type"),
    otherwise: (schema) => schema.optional()
  }),
  ["CLIENT_ID" /* CLIENT_ID */]: yup_extend_default.string().required("Select client name")
});
var MGP_GOALS_SCHEMA = yup_extend_default.object({
  ["TYPE" /* TYPE */]: yup_extend_default.string().required().defined(),
  ["CUSTOM_TYPE" /* CUSTOM_TYPE */]: yup_extend_default.string().optional()
});
var MGP_ADITIONAL_RET_INCOME_SCHEMA = yup_extend_default.object({
  ["INCOME_SOURCE" /* INCOME_SOURCE */]: yup_extend_default.string().required("Describe income source"),
  ["MONTHLY_INCOME" /* MONTHLY_INCOME */]: yup_extend_default.string().currency().required("Enter valid amount"),
  ["DESCRIPTION" /* DESCRIPTION */]: yup_extend_default.string().required("Enter income source description"),
  ["START_YEAR" /* START_YEAR */]: yup_extend_default.string().required("Enter start year"),
  ["END_YEAR" /* END_YEAR */]: yup_extend_default.string().optional(),
  ["ADJUST_FOR_INFLATION" /* ADJUST_FOR_INFLATION */]: yup_extend_default.boolean().default(false),
  ["OWNER_NAME" /* OWNER_NAME */]: yup_extend_default.string().required("Select client name")
});
var MGP_HOUSEHOLD_SCHEMA = yup_extend_default.object({
  ["CURRENT_MONTHLY_LIVING_EXPENSES" /* CURRENT_MONTHLY_LIVING_EXPENSES */]: yup_extend_default.string().currency().required("Enter current monthly living expenses"),
  ["RETIREMENT_MONTHLY_LIVING_EXPENSES" /* RETIREMENT_MONTHLY_LIVING_EXPENSES */]: yup_extend_default.string().currency().required("Enter retirement monthly living expenses"),
  ["WILLING_TO_SAVE_EXTRA_ANNUAL_AMOUNT" /* WILLING_TO_SAVE_EXTRA_ANNUAL_AMOUNT */]: yup_extend_default.string().currency().required("Enter valid amount"),
  ["WILLING_TO_SAVE_EXTRA" /* WILLING_TO_SAVE_EXTRA */]: yup_extend_default.string().nullable().required("Select option"),
  importantRelationships: MGP_IMPORTANT_RELATIONSHIP_SCHEMA,
  goals: yup_extend_default.array().of(MGP_GOALS_SCHEMA.required()).required().default([]),
  employments: yup_extend_default.array().of(MGP_EMPLOYMENT_SCHEMA).defined().default([]),
  retirementIncomes: yup_extend_default.array().of(MGP_ADITIONAL_RET_INCOME_SCHEMA).defined().default([])
});
var MGP_FORM_SCHEMA = yup_extend_default.object({
  client: MGP_CLIENT_SCHEMA.required(),
  coClient: MGP_CO_CLIENT_SCHEMA,
  household: MGP_HOUSEHOLD_SCHEMA.required(),
  [HELPER_FIELDS.IMPORTANT_RELATIONSHIP_SELECT]: yup_extend_default.string().default(IMPORTANT_RELATIONSHIP_TYPE.PERSON),
  [HELPER_FIELDS.CUSTOM_GOAL]: yup_extend_default.string().when("household.goals", {
    is: (goals) => !(goals == null ? void 0 : goals.length),
    then: (schema) => schema.required(
      'Please select at least one option, or enter information into "Other."'
    ),
    otherwise: (schema) => schema.optional()
  })
});
var MGP_PAYLOAD_SCHEMA = MGP_FORM_SCHEMA.clone().shape({
  client: MGP_CLIENT_SCHEMA.clone().shape({
    ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.number().fromCurrency(),
    ["TARGET_RETIREMENT_AGE" /* TARGET_RETIREMENT_AGE */]: yup_extend_default.number()
  }),
  coClient: MGP_CO_CLIENT_SCHEMA.clone().shape({
    ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.number().fromCurrency(),
    ["TARGET_RETIREMENT_AGE" /* TARGET_RETIREMENT_AGE */]: yup_extend_default.number()
  }).optional(),
  household: MGP_HOUSEHOLD_SCHEMA.clone().shape({
    ["CURRENT_MONTHLY_LIVING_EXPENSES" /* CURRENT_MONTHLY_LIVING_EXPENSES */]: yup_extend_default.number().fromCurrency(),
    ["RETIREMENT_MONTHLY_LIVING_EXPENSES" /* RETIREMENT_MONTHLY_LIVING_EXPENSES */]: yup_extend_default.number().fromCurrency(),
    ["WILLING_TO_SAVE_EXTRA_ANNUAL_AMOUNT" /* WILLING_TO_SAVE_EXTRA_ANNUAL_AMOUNT */]: yup_extend_default.number().fromCurrency().optional(),
    employments: yup_extend_default.array().of(
      MGP_EMPLOYMENT_SCHEMA.clone().shape({
        ["ANNUAL_INCOME" /* ANNUAL_INCOME */]: yup_extend_default.number().fromCurrency()
      })
    ),
    retirementIncomes: yup_extend_default.array().of(
      MGP_ADITIONAL_RET_INCOME_SCHEMA.clone().shape({
        ["MONTHLY_INCOME" /* MONTHLY_INCOME */]: yup_extend_default.number().fromCurrency(),
        ["START_YEAR" /* START_YEAR */]: yup_extend_default.number(),
        ["END_YEAR" /* END_YEAR */]: yup_extend_default.mixed().transform((value) => {
          if (!value || value === "")
            return void 0;
          const num = Number(value);
          return isNaN(num) ? void 0 : num;
        })
      })
    ).defined(),
    importantRelationships: yup_extend_default.array().of(
      IMPORTANT_RELATIONSHIP_PERSON_SCHEMA.clone().shape({
        ["DOB" /* DOB */]: yup_extend_default.string().transform((value) => transformers.payload.date(value))
      })
    )
  })
});
var MGP_PAGE_VALIDATION_MAP = {
  INTRO: [],
  IMPORTANT_RELATIONSHIPS: ["household.importantRelationships"],
  IMPORTANT_RELATIONSHIPS_SELECT: [],
  IMPORTANT_RELATIONSHIPS_PERSON_FORM: [],
  IMPORTANT_RELATIONSHIPS_ORGANIZATION_FORM: [],
  ANNUAL_INCOME: [
    `client.${"ANNUAL_INCOME" /* ANNUAL_INCOME */}`,
    `coClient.${"ANNUAL_INCOME" /* ANNUAL_INCOME */}`
  ],
  CAREER_CHANGE: [
    `client.${"CAREER_CHANGE" /* CAREER_CHANGE */}`,
    `client.${"CAREER_CHANGE_OTHER" /* CAREER_CHANGE_OTHER */}`,
    `client.${"CAREER_CHANGE_RETIREMENT" /* CAREER_CHANGE_RETIREMENT */}`,
    `client.${"CAREER_CHANGE_JOB_CHANGE" /* CAREER_CHANGE_JOB_CHANGE */}`,
    `client.${"CAREER_CHANGE_SELL_BUSINESS" /* CAREER_CHANGE_SELL_BUSINESS */}`
  ],
  CAREER_CHANGE_CO_CLIENT: [
    `coClient.${"CAREER_CHANGE" /* CAREER_CHANGE */}`,
    `coClient.${"CAREER_CHANGE_OTHER" /* CAREER_CHANGE_OTHER */}`,
    `coClient.${"CAREER_CHANGE_RETIREMENT" /* CAREER_CHANGE_RETIREMENT */}`,
    `coClient.${"CAREER_CHANGE_JOB_CHANGE" /* CAREER_CHANGE_JOB_CHANGE */}`,
    `coClient.${"CAREER_CHANGE_SELL_BUSINESS" /* CAREER_CHANGE_SELL_BUSINESS */}`
  ],
  RETIREMENT_EXPENSES: [
    `household.${"CURRENT_MONTHLY_LIVING_EXPENSES" /* CURRENT_MONTHLY_LIVING_EXPENSES */}`,
    `household.${"RETIREMENT_MONTHLY_LIVING_EXPENSES" /* RETIREMENT_MONTHLY_LIVING_EXPENSES */}`
  ],
  EMPLOYMENT: ["household.employments"],
  EMPLOYMENT_FORM: [],
  GOALS: ["household.goals", HELPER_FIELDS.CUSTOM_GOAL],
  REVIEW: [],
  ADDITIONAL_INCOME: ["household.retirementIncomes"],
  ADDITIONAL_INCOME_FORM: [],
  RETIREMENT_AGE: [
    `client.${"TARGET_RETIREMENT_AGE" /* TARGET_RETIREMENT_AGE */}`,
    `client.${"WILLING_TO_RETIRE_LATER" /* WILLING_TO_RETIRE_LATER */}`,
    `client.${"CONSIDER_PART_TIME_RETIREMENT" /* CONSIDER_PART_TIME_RETIREMENT */}`
  ],
  RETIREMENT_AGE_CO_CLIENT: [
    `coClient.${"TARGET_RETIREMENT_AGE" /* TARGET_RETIREMENT_AGE */}`,
    `coClient.${"WILLING_TO_RETIRE_LATER" /* WILLING_TO_RETIRE_LATER */}`,
    `coClient.${"CONSIDER_PART_TIME_RETIREMENT" /* CONSIDER_PART_TIME_RETIREMENT */}`
  ],
  EXTRA_SAVINGS: [
    `household.${"WILLING_TO_SAVE_EXTRA_ANNUAL_AMOUNT" /* WILLING_TO_SAVE_EXTRA_ANNUAL_AMOUNT */}`,
    `household.${"WILLING_TO_SAVE_EXTRA" /* WILLING_TO_SAVE_EXTRA */}`
  ],
  PROTECTION_AND_LEGACY_PLANNING: [
    `client.${"CURRENT_INSURANCE_POLICIES" /* CURRENT_INSURANCE_POLICIES */}`,
    `client.${"CURRENT_ESTATE_PLANNING" /* CURRENT_ESTATE_PLANNING */}`
  ],
  PROTECTION_AND_LEGACY_PLANNING_CO_CLIENT: [
    `coClient.${"CURRENT_INSURANCE_POLICIES" /* CURRENT_INSURANCE_POLICIES */}`,
    `coClient.${"CURRENT_ESTATE_PLANNING" /* CURRENT_ESTATE_PLANNING */}`
  ]
};
var RETIREMENT_MONTHLY_EXPENSES_TOOLTIP_COPY = "It\u2019s okay if you don\u2019t have a solid number in mind at this stage. You can discuss it together with your advisor at your next meeting. Please enter the amount in todays dollars. Don\u2019t include the following expenses:";
var INTRO_TITLE = "What to Expect";
var INTRO_COPY = "This form helps your advisor create a personalized financial plan for you. It takes about 30 minutes, and your progress is saved automatically to your device. If you have a co-client (like a spouse), you\u2019ll need to fill it out together. It is easiest to fill this form out on a desktop computer or laptop.";
var ANNUAL_INCOME_TITLE = "Confirm Your Information";
var IMPORTANT_RELATIONSHIPS_TITLE = "Important Relationships";
var IMPORTANT_RELATIONSHIPS_COPY = "List children, other family members, or organizations important to you for financial and charitable planning.";
var IMPORTANT_RELATIONSHIPS_PERSON_COPY = "List children and other family members important to you for financial and charitable planning.";
var IMPORTANT_RELATIONSHIPS_ORGANIZATION_COPY = "List organizations important to you for financial and charitable planning.";
var IMPORTANT_RELATIONSHIPS_PERSON_TITLE = "Add an Important Person";
var IMPORTANT_RELATIONSHIPS_ORGANIZATION_TITLE = "Add an Important Organization";
var RETIREMENT_EXPENSES_TITLE = "Current and Retirement Expenses";
var RETIREMENT_EXPENSES_COPY = "What are your monthly expenses currently, and what do you predict your monthly expenses will be in retirement?";
var EMPLOYMENT_TITLE = "Employment";
var EMPLOYMENT_COPY = "Add your W2 and 1099 Employment income.";
var RETIREMENT_AGE_TITLE = "Retirement Age";
var RETIREMENT_AGE_COPY = "When would you like to retire? Enter your Target Retirement Age. Then, indicate how willing you are to delay retirement beyond that age, if it helps you fund your goals.";
var CAREER_CHANGE_TITLE = "Career Change";
var CAREER_CHANGE_COPY = "Are you considering making a career transition in the next 1 - 2 years?";
var ADDITIONAL_INCOME_TITLE = "Additional Income";
var ADDITIONAL_INCOME_COPY = "Add any additional income such as rental, alimony, royalties, promissory note and pension.";
var GOALS_TITLE = "Add Your Goals";
var GOALS_COPY = "What financial goals would you like to save for, from now through retirement? Select all that apply.";
var REVIEW_TITLE = "Review your Information";
var REVIEW_COPY = "Please review the following information before submitting the questionnaire.";
var EXTRA_SAVINGS_TITLE = "Extra Savings";
var EXTRA_SAVINGS_COPY = "Enter the maximum additional amount you could save each year above existing annual savings.";
var PROTECTION_AND_LEGACY_PLANNING_TITLE = "Protection & Legacy Planning";
var PROTECTION_AND_LEGACY_PLANNING_COPY = "Identify the insurance and estate planning tools you have in place to secure your future. Select \u201CNext\u201D if not applicable.";
var MGP_STATE_MACHINE_CONFIG = {
  initialStep: "INTRO",
  initialNavHistory: [],
  steps: {
    INTRO: {
      stepTitle: INTRO_TITLE,
      stepSubtitle: INTRO_COPY,
      choices: {
        ANNUAL_INCOME: {
          when: () => true
        }
      }
    },
    ANNUAL_INCOME: {
      stepTitle: ANNUAL_INCOME_TITLE,
      choices: {
        IMPORTANT_RELATIONSHIPS: {
          when: () => true
        }
      }
    },
    IMPORTANT_RELATIONSHIPS: {
      stepTitle: IMPORTANT_RELATIONSHIPS_TITLE,
      stepSubtitle: (fields) => `${IMPORTANT_RELATIONSHIPS_COPY}${fields.household.importantRelationships.length > 0 ? "" : " Select \u201Cnext\u201D if not applicable."}`,
      choices: {
        EMPLOYMENT: {
          when: () => true
        }
      }
    },
    IMPORTANT_RELATIONSHIPS_SELECT: {
      stepTitle: IMPORTANT_RELATIONSHIPS_TITLE,
      stepSubtitle: IMPORTANT_RELATIONSHIPS_COPY,
      skipProgress: true,
      choices: {
        IMPORTANT_RELATIONSHIPS_PERSON_FORM: {
          when: (fields) => fields[HELPER_FIELDS.IMPORTANT_RELATIONSHIP_SELECT] === IMPORTANT_RELATIONSHIP_TYPE.PERSON
        },
        IMPORTANT_RELATIONSHIPS_ORGANIZATION_FORM: {
          when: (fields) => fields[HELPER_FIELDS.IMPORTANT_RELATIONSHIP_SELECT] === IMPORTANT_RELATIONSHIP_TYPE.ORGANIZATION
        }
      }
    },
    IMPORTANT_RELATIONSHIPS_PERSON_FORM: {
      stepTitle: IMPORTANT_RELATIONSHIPS_PERSON_TITLE,
      stepSubtitle: IMPORTANT_RELATIONSHIPS_PERSON_COPY,
      skipProgress: true,
      choices: {
        IMPORTANT_RELATIONSHIPS: {
          when: () => true
        }
      }
    },
    IMPORTANT_RELATIONSHIPS_ORGANIZATION_FORM: {
      stepTitle: IMPORTANT_RELATIONSHIPS_ORGANIZATION_TITLE,
      stepSubtitle: IMPORTANT_RELATIONSHIPS_ORGANIZATION_COPY,
      skipProgress: true,
      choices: {
        IMPORTANT_RELATIONSHIPS: {
          when: () => true
        }
      }
    },
    EMPLOYMENT: {
      stepTitle: EMPLOYMENT_TITLE,
      stepSubtitle: EMPLOYMENT_COPY,
      choices: {
        CAREER_CHANGE: {
          when: () => true
        }
      }
    },
    EMPLOYMENT_FORM: {
      stepTitle: EMPLOYMENT_TITLE,
      stepSubtitle: EMPLOYMENT_COPY,
      choices: {
        EMPLOYMENT: {
          when: () => true
        }
      },
      skipProgress: true
    },
    CAREER_CHANGE: {
      stepTitle: CAREER_CHANGE_TITLE,
      stepSubtitle: (fields) => `${CAREER_CHANGE_COPY}${fields.client.CAREER_CHANGE.length > 0 ? "" : " If not applicable, select \u201CNext\u201D"}`,
      choices: {
        CAREER_CHANGE_CO_CLIENT: {
          when: (fields) => {
            var _a;
            return !!((_a = fields["coClient"]) == null ? void 0 : _a.FIRST_NAME);
          }
        },
        ADDITIONAL_INCOME: {
          when: () => true
        }
      }
    },
    CAREER_CHANGE_CO_CLIENT: {
      stepTitle: CAREER_CHANGE_TITLE,
      stepSubtitle: (fields) => `${CAREER_CHANGE_COPY}${fields.coClient.CAREER_CHANGE.length > 0 ? "" : " If not applicable, select \u201CNext\u201D"}`,
      choices: {
        ADDITIONAL_INCOME: {
          when: () => true
        }
      }
    },
    ADDITIONAL_INCOME: {
      stepTitle: ADDITIONAL_INCOME_TITLE,
      stepSubtitle: ADDITIONAL_INCOME_COPY,
      choices: {
        GOALS: {
          when: () => true
        }
      }
    },
    ADDITIONAL_INCOME_FORM: {
      stepTitle: ADDITIONAL_INCOME_TITLE,
      stepSubtitle: ADDITIONAL_INCOME_COPY,
      choices: {
        ADDITIONAL_INCOME: {
          when: () => true
        }
      },
      skipProgress: true
    },
    GOALS: {
      stepTitle: GOALS_TITLE,
      stepSubtitle: GOALS_COPY,
      choices: {
        RETIREMENT_EXPENSES: {
          when: () => true
        }
      }
    },
    RETIREMENT_EXPENSES: {
      stepTitle: RETIREMENT_EXPENSES_TITLE,
      stepSubtitle: RETIREMENT_EXPENSES_COPY,
      choices: {
        RETIREMENT_AGE: {
          when: () => true
        }
      }
    },
    RETIREMENT_AGE: {
      stepTitle: RETIREMENT_AGE_TITLE,
      stepSubtitle: RETIREMENT_AGE_COPY,
      choices: {
        RETIREMENT_AGE_CO_CLIENT: {
          when: (fields) => {
            var _a;
            return !!((_a = fields["coClient"]) == null ? void 0 : _a.FIRST_NAME);
          }
        },
        EXTRA_SAVINGS: {
          when: () => true
        }
      }
    },
    RETIREMENT_AGE_CO_CLIENT: {
      stepTitle: RETIREMENT_AGE_TITLE,
      stepSubtitle: RETIREMENT_AGE_COPY,
      choices: {
        EXTRA_SAVINGS: {
          when: () => true
        }
      }
    },
    EXTRA_SAVINGS: {
      stepTitle: EXTRA_SAVINGS_TITLE,
      stepSubtitle: EXTRA_SAVINGS_COPY,
      choices: {
        PROTECTION_AND_LEGACY_PLANNING: {
          when: () => true
        }
      }
    },
    PROTECTION_AND_LEGACY_PLANNING: {
      stepTitle: PROTECTION_AND_LEGACY_PLANNING_TITLE,
      stepSubtitle: PROTECTION_AND_LEGACY_PLANNING_COPY,
      choices: {
        PROTECTION_AND_LEGACY_PLANNING_CO_CLIENT: {
          when: (fields) => {
            var _a;
            return !!((_a = fields["coClient"]) == null ? void 0 : _a.FIRST_NAME);
          }
        },
        REVIEW: {
          when: () => true
        }
      }
    },
    PROTECTION_AND_LEGACY_PLANNING_CO_CLIENT: {
      stepTitle: PROTECTION_AND_LEGACY_PLANNING_TITLE,
      stepSubtitle: PROTECTION_AND_LEGACY_PLANNING_COPY,
      choices: {
        REVIEW: {
          when: () => true
        }
      }
    },
    REVIEW: {
      stepTitle: REVIEW_TITLE,
      stepSubtitle: REVIEW_COPY,
      isTerminal: true
    }
  }
};
var IMPORTANT_RELATINOSHIPS_FIELD_ARRAY_NAME = "household.importantRelationships";
var RETIREMENT_MONTHLY_EXPENSES_TOOLTIP_ITEMS = [
  "Mortgage payments",
  "Work-related expense",
  "Retirement contributions",
  "Life insurance premiums",
  "Debt payments",
  "Dependent-related costs",
  "Social Security taxes"
];
var EMPLOYMENT_FIELD_ARRAY_NAME = "household.employments";
var ADDITIONAL_INCOME_FIELD_ARRAY_NAME = "household.retirementIncomes";
var LIST_FORM_PAGES = [
  "ADDITIONAL_INCOME_FORM",
  "EMPLOYMENT_FORM",
  "IMPORTANT_RELATIONSHIPS_PERSON_FORM",
  "IMPORTANT_RELATIONSHIPS_ORGANIZATION_FORM"
];

// src/modules/money-guide-pro/components/MGPWizard/MGPWizard.tsx
var import_react_hook_form34 = require("react-hook-form");
var import_yup9 = require("@hookform/resolvers/yup");

// src/common/components/AddButton/AddButton.tsx
var import_core33 = require("@earned/core");
var import_jsx_runtime45 = require("react/jsx-runtime");
var AddButton = ({ onClick, label }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime45.jsxs)(
    "button",
    {
      type: "button",
      "data-testid": "add-button",
      className: "AddButton",
      onClick,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime45.jsx)("span", { className: "AddButtonIcon", children: /* @__PURE__ */ (0, import_jsx_runtime45.jsx)(import_core33.Icon.Plus, { color: "link", size: 24 }) }),
        /* @__PURE__ */ (0, import_jsx_runtime45.jsx)("span", { className: "AddButtonLabel", children: label })
      ]
    }
  );
};
var AddButton_default = AddButton;

// src/common/components/ListDivider/ListDivider.tsx
var import_jsx_runtime46 = require("react/jsx-runtime");
var ListDivider = ({ useBlock, children }) => useBlock ? /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(ReviewBlock_default, { children }) : /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(import_jsx_runtime46.Fragment, { children });
var ListDivider_default = ListDivider;

// src/common/components/ListItemRemoveDialog/ListItemRemoveDialog.tsx
var import_core34 = require("@earned/core");
var import_jsx_runtime47 = require("react/jsx-runtime");
var ListItemRemoveDialog = ({
  onRemove,
  isOpen,
  onClose
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
    import_core34.Dialog,
    {
      onClose,
      isOpen,
      title: "Remove",
      onSubmitText: "Remove",
      onSubmit: onRemove,
      onSubmitVariant: "danger",
      onCloseText: "Back",
      children: /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(import_core34.Typography, { variant: "body", color: "primary", children: "Are you sure you want to remove this?" })
    }
  );
};
var ListItemRemoveDialog_default = ListItemRemoveDialog;

// src/common/components/UserSummary/UserSummary.tsx
var import_core35 = require("@earned/core");
var React16 = __toESM(require("react"));
var import_core36 = require("@earned/core");
var import_classnames3 = __toESM(require("classnames"));
var import_jsx_runtime48 = require("react/jsx-runtime");
var UserSummary = ({
  title,
  subtitle,
  children,
  defaultExpanded,
  onEditClick,
  onRemoveClick,
  hideRemoveButton
}) => {
  const [expanded, setExpanded] = React16.useState(defaultExpanded);
  const bodyClassName = React16.useMemo(
    () => (0, import_classnames3.default)("UserSummaryContent", {
      "UserSummaryContent--visible": expanded
    }),
    [expanded]
  );
  const iconClassName = React16.useMemo(
    () => (0, import_classnames3.default)("UserSummaryControlIcon", {
      "UserSummaryControlIcon--expanded": expanded
    }),
    [expanded]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime48.jsxs)("div", { "data-testid": "user-summary", className: "UserSummary", children: [
    /* @__PURE__ */ (0, import_jsx_runtime48.jsxs)("header", { className: "UserSummaryHeader", children: [
      /* @__PURE__ */ (0, import_jsx_runtime48.jsxs)("div", { className: "UserSummaryTitle", children: [
        /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(import_core35.Typography, { variant: "body-xl", weight: "medium", children: title }),
        subtitle && /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(import_core35.Typography, { variant: "body-lg", weight: "medium", children: subtitle })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime48.jsxs)("div", { className: "UserSummaryControls", children: [
        /* @__PURE__ */ (0, import_jsx_runtime48.jsxs)(
          "button",
          {
            type: "button",
            className: "UserSummaryControl UserSummaryControlDetails",
            onClick: () => setExpanded((open) => !open),
            children: [
              "Details",
              " ",
              /* @__PURE__ */ (0, import_jsx_runtime48.jsx)("span", { className: iconClassName, children: /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(import_core36.Icon.ChevronDown, { color: "link", size: 24 }) })
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime48.jsxs)("div", { className: "UserSummaryControlGroup", children: [
          /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(
            "button",
            {
              type: "button",
              className: "UserSummaryControl",
              onClick: onEditClick,
              children: "Edit"
            }
          ),
          !hideRemoveButton && /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(
            "button",
            {
              type: "button",
              className: "UserSummaryControl",
              onClick: onRemoveClick,
              children: "Remove"
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime48.jsx)("section", { className: bodyClassName, children })
  ] });
};
var UserSummary_default = UserSummary;

// src/modules/money-guide-pro/components/ImportantRelationshipsList/ImportantRelationshipsList.tsx
var React17 = __toESM(require("react"));
var import_jsx_runtime49 = require("react/jsx-runtime");
var ImportantRelationshipsList = ({
  navigateTo,
  removeImportantRelationship,
  importantRelationshipsFields,
  onEditClick
}) => {
  const handleAddClick = () => {
    navigateTo("IMPORTANT_RELATIONSHIPS_SELECT");
  };
  const [removeItemIndex, setRemoveItemIndex] = React17.useState(
    null
  );
  const onCloseRemoveDialog = () => setRemoveItemIndex(null);
  const onRemove = () => {
    removeImportantRelationship(removeItemIndex);
    onCloseRemoveDialog();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime49.jsxs)("div", { "data-testid": "mgp-page-important-relationships-list", children: [
    /* @__PURE__ */ (0, import_jsx_runtime49.jsxs)("div", { className: "flex flex-col gap-8", children: [
      /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
        AddButton_default,
        {
          label: "Add important relationship",
          onClick: handleAddClick
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime49.jsx)("div", { children: importantRelationshipsFields.map((field, index) => /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(ListDivider_default, { useBlock: index !== 0, children: field["TYPE" /* TYPE */] === IMPORTANT_RELATIONSHIP_TYPE.PERSON ? /* @__PURE__ */ (0, import_jsx_runtime49.jsxs)(
        UserSummary_default,
        {
          title: `${field["FIRST_NAME" /* FIRST_NAME */]} ${field["LAST_NAME" /* LAST_NAME */]}`,
          onEditClick: () => onEditClick(index),
          onRemoveClick: () => setRemoveItemIndex(index),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
              ReviewList_default,
              {
                label: "Relationship",
                value: formatters.string(
                  getReviewListValue(
                    IMPORTANT_RELATIONSHIPS_PERSON_RELATIONSHIP_OPTIONS,
                    field["RELATIONSHIP" /* RELATIONSHIP */]
                  )
                )
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
              ReviewList_default,
              {
                label: "Date of Birth",
                value: formatters.string(
                  transformers.form.date(
                    field["DOB" /* DOB */]
                  )
                )
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
              ReviewList_default,
              {
                label: "Dependent Status",
                value: formatters.string(
                  getReviewListValue(
                    IMPORTANT_RELATIONSHIP_BASE_DEPENDENT_STATUS_OPTIONS,
                    field["DEPENDENT_STATUS" /* DEPENDENT_STATUS */]
                  )
                )
              }
            )
          ]
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime49.jsxs)(
        UserSummary_default,
        {
          title: field["NAME" /* NAME */],
          onEditClick: () => onEditClick(index),
          onRemoveClick: () => setRemoveItemIndex(index),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
              ReviewList_default,
              {
                label: "Name",
                value: formatters.string(
                  field["NAME" /* NAME */]
                )
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
              ReviewList_default,
              {
                label: "Type",
                value: formatters.string(
                  getReviewListValue(
                    IMPORTANT_RELATIONSHIP_ORGANIZATION_TYPE_OPTIONS,
                    field["ORGANIZATION_TYPE" /* ORGANIZATION_TYPE */]
                  )
                )
              }
            )
          ]
        }
      ) }, field.id)) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
      ListItemRemoveDialog_default,
      {
        isOpen: removeItemIndex !== null,
        onClose: onCloseRemoveDialog,
        onRemove
      }
    )
  ] });
};
var ImportantRelationshipsList_default = ImportantRelationshipsList;

// src/modules/money-guide-pro/components/ImportantRelationshipsSelect/ImportantRelationshipsSelect.tsx
var import_core37 = require("@earned/core");
var import_react_hook_form14 = require("react-hook-form");
var import_jsx_runtime50 = require("react/jsx-runtime");
var ImportantRelationshipsSelect = () => {
  const { register } = (0, import_react_hook_form14.useFormContext)();
  return /* @__PURE__ */ (0, import_jsx_runtime50.jsx)("div", { "data-testid": "mgp-page-important-relationships-select", children: /* @__PURE__ */ (0, import_jsx_runtime50.jsxs)(import_core37.RadioGroup, { ...register(HELPER_FIELDS.IMPORTANT_RELATIONSHIP_SELECT), children: [
    /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(import_core37.Radio, { label: "Person", value: IMPORTANT_RELATIONSHIP_TYPE.PERSON }),
    /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
      import_core37.Radio,
      {
        label: "Organization",
        value: IMPORTANT_RELATIONSHIP_TYPE.ORGANIZATION
      }
    )
  ] }) });
};
var ImportantRelationshipsSelect_default = ImportantRelationshipsSelect;

// src/modules/money-guide-pro/components/ImportantRelationshipsPersonForm/ImportantRelationshipsPersonForm.tsx
var import_core38 = require("@earned/core");
var import_yup5 = require("@hookform/resolvers/yup");
var React18 = __toESM(require("react"));
var import_react_hook_form15 = require("react-hook-form");
var import_jsx_runtime51 = require("react/jsx-runtime");
var Block = ({ children }) => /* @__PURE__ */ (0, import_jsx_runtime51.jsx)("div", { className: "sm:w-[50%]", children });
var ImportantRelationshipsPersonForm = ({ clients, update, append, editValues, editIndex }) => {
  var _a, _b, _c, _d;
  const {
    register,
    formState: { errors },
    setValue,
    control,
    handleSubmit,
    watch
  } = (0, import_react_hook_form15.useForm)({
    values: editValues ? IMPORTANT_RELATIONSHIP_PERSON_SCHEMA.cast(
      editValues
    ) : IMPORTANT_RELATIONSHIP_PERSON_SCHEMA.getDefault(),
    mode: "onTouched",
    resolver: (0, import_yup5.yupResolver)(IMPORTANT_RELATIONSHIP_PERSON_SCHEMA)
  });
  const { watch: watchForm } = (0, import_react_hook_form15.useFormContext)();
  const coClient = watchForm("coClient");
  const hasCoClient = !!(coClient == null ? void 0 : coClient.FIRST_NAME);
  const importantRelationship = watch(
    "RELATIONSHIP" /* RELATIONSHIP */
  );
  const selectedRelationship = IMPORTANT_RELATIONSHIPS_PERSON_RELATIONSHIP_OPTIONS.find(
    (option) => option.value === importantRelationship
  ) || IMPORTANT_RELATIONSHIPS_PERSON_RELATIONSHIP_OPTIONS[0];
  const DEPENDENT_STATUS_OPTIONS = React18.useMemo(() => {
    let options = [...IMPORTANT_RELATIONSHIP_BASE_DEPENDENT_STATUS_OPTIONS];
    if (!hasCoClient) {
      options = options.filter(
        (option) => option.value !== "DEPENDENT_OF_BOTH"
      );
    }
    clients.forEach((client) => {
      options.push({
        label: `${client.firstName ?? ""} ${client.lastName ?? ""}'s Dependent`,
        value: `${client.firstName ?? ""} ${client.lastName ?? ""}'s Dependent`,
        id: client.id
      });
    });
    return options;
  }, [clients, hasCoClient]);
  const selectedDependentStatus = watch(
    "DEPENDENT_STATUS" /* DEPENDENT_STATUS */
  );
  const selectedDependent = DEPENDENT_STATUS_OPTIONS.find(
    (option) => option.value === selectedDependentStatus
  ) || DEPENDENT_STATUS_OPTIONS[0];
  const { registerBeforeNavigate, unregisterBeforeNavigate } = useNavigationContext();
  React18.useEffect(() => {
    const beforeNavigate = async () => {
      return new Promise(
        (accept) => handleSubmit(
          async (values) => {
            if (editIndex !== void 0) {
              update(editIndex, values);
            } else {
              append({
                ...values,
                ["TYPE" /* TYPE */]: IMPORTANT_RELATIONSHIP_TYPE.PERSON
              });
            }
            accept(true);
          },
          () => accept(false)
        )()
      );
    };
    registerBeforeNavigate(beforeNavigate);
    return () => unregisterBeforeNavigate();
  }, [
    registerBeforeNavigate,
    unregisterBeforeNavigate,
    update,
    handleSubmit,
    editIndex,
    editValues,
    append
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime51.jsx)("div", { "data-testid": "mgp-page-important-relationships-person-form", children: /* @__PURE__ */ (0, import_jsx_runtime51.jsxs)("div", { className: "flex flex-col gap-8", children: [
    /* @__PURE__ */ (0, import_jsx_runtime51.jsxs)("div", { className: "flex flex-col sm:flex-row sm:gap-control-gap", children: [
      /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(Block, { children: /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
        import_core38.TextInput,
        {
          label: "First Name",
          ...register("FIRST_NAME" /* FIRST_NAME */),
          error: (_a = errors["FIRST_NAME" /* FIRST_NAME */]) == null ? void 0 : _a.message,
          autoFocus: true
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(Block, { children: /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
        import_core38.TextInput,
        {
          label: "Last Name",
          ...register("LAST_NAME" /* LAST_NAME */),
          error: (_b = errors["LAST_NAME" /* LAST_NAME */]) == null ? void 0 : _b.message
        }
      ) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime51.jsxs)("div", { className: "flex flex-col sm:flex-row sm:gap-control-gap", children: [
      /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(Block, { children: /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
        import_core38.SelectBox,
        {
          label: "Relationship",
          options: IMPORTANT_RELATIONSHIPS_PERSON_RELATIONSHIP_OPTIONS,
          error: (_c = errors["RELATIONSHIP" /* RELATIONSHIP */]) == null ? void 0 : _c.message,
          selected: selectedRelationship,
          onChange: (selected) => {
            setValue(
              "RELATIONSHIP" /* RELATIONSHIP */,
              selected.value ?? "",
              { shouldValidate: true }
            );
          }
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(Block, { children: /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
        import_react_hook_form15.Controller,
        {
          control,
          name: "DOB" /* DOB */,
          render: ({ field }) => {
            var _a2;
            return /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
              import_core38.TextInput,
              {
                label: "Date of Birth",
                placeholder: "mm/dd/yyyy",
                error: (_a2 = errors["DOB" /* DOB */]) == null ? void 0 : _a2.message,
                maskOptions: {
                  mask: "99/99/9999",
                  maskChar: ""
                },
                ...field
              }
            );
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime51.jsx)("div", { className: "w-full", children: /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
      import_core38.SelectBox,
      {
        label: "Dependent Status",
        options: DEPENDENT_STATUS_OPTIONS,
        error: (_d = errors["DEPENDENT_STATUS" /* DEPENDENT_STATUS */]) == null ? void 0 : _d.message,
        selected: selectedDependent,
        onChange: (selected) => {
          setValue(
            "DEPENDENT_STATUS" /* DEPENDENT_STATUS */,
            selected.value ?? "",
            { shouldValidate: true }
          );
        }
      }
    ) })
  ] }) });
};
var ImportantRelationshipsPersonForm_default = ImportantRelationshipsPersonForm;

// src/modules/money-guide-pro/hooks.ts
var import_react5 = require("react");
var import_react_hook_form16 = require("react-hook-form");
var import_lodash4 = require("lodash");
var useImportantRelationshipsList = ({
  control
}) => {
  const [selectedImportantRelationship, setSelectedImportantRelationship] = (0, import_react5.useState)(void 0);
  const {
    fields: importantRelationshipsFields,
    append: appendImportantRelationship,
    remove: removeImportantRelationship,
    update: updateImportantRelationship
  } = (0, import_react_hook_form16.useFieldArray)({
    control,
    name: IMPORTANT_RELATINOSHIPS_FIELD_ARRAY_NAME
  });
  const handleNavigation = (0, import_react5.useCallback)(
    (event) => {
      const { from, to } = event.detail;
      if (from === "IMPORTANT_RELATIONSHIPS_PERSON_FORM" || from === "IMPORTANT_RELATIONSHIPS_ORGANIZATION_FORM") {
        setSelectedImportantRelationship(void 0);
      }
    },
    []
  );
  (0, import_react5.useEffect)(() => {
    if (handleNavigation) {
      window.addEventListener(
        "wizardNavigation",
        handleNavigation
      );
      return () => window.removeEventListener(
        "wizardNavigation",
        handleNavigation
      );
    }
  }, [handleNavigation]);
  return {
    importantRelationshipsFields,
    appendImportantRelationship,
    removeImportantRelationship,
    updateImportantRelationship,
    selectedImportantRelationship,
    setSelectedImportantRelationship
  };
};
var useEmploymentsList = ({
  control
}) => {
  const [selectedEmployment, setSelectedEmployment] = (0, import_react5.useState)(void 0);
  const {
    fields: employmentsFields,
    append: appendEmployments,
    remove: removeEmployments,
    update: updateEmployments
  } = (0, import_react_hook_form16.useFieldArray)({
    control,
    name: EMPLOYMENT_FIELD_ARRAY_NAME
  });
  const handleNavigation = (0, import_react5.useCallback)(
    (event) => {
      const { from, to } = event.detail;
      if (from === "EMPLOYMENT_FORM") {
        setSelectedEmployment(void 0);
      }
    },
    []
  );
  (0, import_react5.useEffect)(() => {
    window.addEventListener(
      "wizardNavigation",
      handleNavigation
    );
    return () => window.removeEventListener(
      "wizardNavigation",
      handleNavigation
    );
  }, [handleNavigation]);
  return {
    employmentsFields,
    appendEmployments,
    removeEmployments,
    updateEmployments,
    selectedEmployment,
    setSelectedEmployment
  };
};
var useAdditionalIncomeList = ({
  control
}) => {
  const [selectedAdditionalIncome, setSelectedAdditionalIncome] = (0, import_react5.useState)(void 0);
  const {
    fields: additionalIncomeFields,
    append: appendAdditionalIncome,
    remove: removeAdditionalIncome,
    update: updateAdditionalIncome
  } = (0, import_react_hook_form16.useFieldArray)({
    control,
    name: ADDITIONAL_INCOME_FIELD_ARRAY_NAME
  });
  const handleNavigation = (0, import_react5.useCallback)(
    (event) => {
      const { from, to } = event.detail;
      if (from === "ADDITIONAL_INCOME_FORM") {
        setSelectedAdditionalIncome(void 0);
      }
    },
    []
  );
  (0, import_react5.useEffect)(() => {
    window.addEventListener(
      "wizardNavigation",
      handleNavigation
    );
    return () => window.removeEventListener(
      "wizardNavigation",
      handleNavigation
    );
  }, [handleNavigation]);
  return {
    additionalIncomeFields,
    appendAdditionalIncome,
    removeAdditionalIncome,
    updateAdditionalIncome,
    selectedAdditionalIncome,
    setSelectedAdditionalIncome
  };
};
var useEmploymentPrefill = ({
  client,
  coClient,
  setValue,
  isEditing,
  employments
}) => {
  (0, import_react5.useEffect)(() => {
    if (!isEditing) {
      if (employments.length === 0) {
        const clientId = client.CLIENT_ID;
        if (clientId) {
          setValue("CLIENT_ID" /* CLIENT_ID */, clientId);
          setValue("EMPLOYER_NAME" /* EMPLOYER_NAME */, client.EMPLOYER_NAME ?? "");
          setValue("ANNUAL_INCOME" /* ANNUAL_INCOME */, client.ANNUAL_INCOME ?? "");
        }
      } else if (employments.length === 1) {
        const coClientId = coClient.CLIENT_ID;
        if (coClientId) {
          setValue("CLIENT_ID" /* CLIENT_ID */, coClientId);
          setValue(
            "EMPLOYER_NAME" /* EMPLOYER_NAME */,
            coClient.EMPLOYER_NAME ?? ""
          );
          setValue(
            "ANNUAL_INCOME" /* ANNUAL_INCOME */,
            coClient.ANNUAL_INCOME ?? ""
          );
        }
      }
    }
  }, [client, coClient, setValue, employments.length, isEditing]);
};
var useClients = (fieldValues) => {
  const clients = (0, import_react5.useMemo)(() => {
    const client = {
      firstName: fieldValues["client"]["FIRST_NAME" /* FIRST_NAME */],
      lastName: fieldValues["client"]["LAST_NAME" /* LAST_NAME */],
      id: fieldValues["client"]["CLIENT_ID" /* CLIENT_ID */]
    };
    const coClient = {
      firstName: fieldValues["coClient"]["FIRST_NAME" /* FIRST_NAME */],
      lastName: fieldValues["coClient"]["LAST_NAME" /* LAST_NAME */],
      id: fieldValues["coClient"]["CLIENT_ID" /* CLIENT_ID */]
    };
    const clients2 = [];
    if (client.firstName) {
      clients2.push(client);
    }
    if (coClient.firstName) {
      clients2.push(coClient);
    }
    return clients2;
  }, [fieldValues]);
  return clients;
};
var useTitleTag = (fieldValues, currentStep) => {
  const { client, coClient } = fieldValues;
  if ((0, import_lodash4.isEmpty)(coClient) || !coClient.FIRST_NAME) {
    return void 0;
  }
  if (currentStep === "CAREER_CHANGE_CO_CLIENT" || currentStep === "RETIREMENT_AGE_CO_CLIENT" || currentStep === "PROTECTION_AND_LEGACY_PLANNING_CO_CLIENT") {
    const firstName = coClient.FIRST_NAME || "";
    const lastName = coClient.LAST_NAME || "";
    return `${firstName} ${lastName}`;
  }
  if (currentStep === "CAREER_CHANGE" || currentStep === "RETIREMENT_AGE" || currentStep === "PROTECTION_AND_LEGACY_PLANNING") {
    const firstName = client.FIRST_NAME || "";
    const lastName = client.LAST_NAME || "";
    return `${firstName} ${lastName}`;
  }
  return void 0;
};

// src/modules/money-guide-pro/components/ImportantRelationshipsOrganizationForm/ImportantRelationshipsOrganizationForm.tsx
var import_core39 = require("@earned/core");
var import_yup6 = require("@hookform/resolvers/yup");
var React19 = __toESM(require("react"));
var import_react_hook_form17 = require("react-hook-form");
var import_jsx_runtime52 = require("react/jsx-runtime");
var ImportantRelationshipsOrganizationForm = ({ update, append, editValues, editIndex }) => {
  var _a, _b;
  const {
    register,
    formState: { errors },
    setValue,
    handleSubmit,
    watch
  } = (0, import_react_hook_form17.useForm)({
    values: editValues ? IMPORTANT_RELATIONSHIP_ORGANIZATION_SCHEMA.cast(
      editValues
    ) : IMPORTANT_RELATIONSHIP_ORGANIZATION_SCHEMA.getDefault(),
    mode: "onTouched",
    resolver: (0, import_yup6.yupResolver)(IMPORTANT_RELATIONSHIP_ORGANIZATION_SCHEMA)
  });
  const importantOrganizationType = watch(
    "ORGANIZATION_TYPE" /* ORGANIZATION_TYPE */
  );
  const selectedOrganizationType = IMPORTANT_RELATIONSHIP_ORGANIZATION_TYPE_OPTIONS.find(
    (option) => option.value === importantOrganizationType
  ) || IMPORTANT_RELATIONSHIP_ORGANIZATION_TYPE_OPTIONS[0];
  const { registerBeforeNavigate, unregisterBeforeNavigate } = useNavigationContext();
  React19.useEffect(() => {
    const beforeNavigate = async () => {
      return new Promise(
        (accept) => handleSubmit(
          async (values) => {
            if (editIndex !== void 0) {
              update(editIndex, values);
            } else {
              append({
                ...values,
                ["TYPE" /* TYPE */]: IMPORTANT_RELATIONSHIP_TYPE.ORGANIZATION
              });
            }
            accept(true);
          },
          () => accept(false)
        )()
      );
    };
    registerBeforeNavigate(beforeNavigate);
    return () => unregisterBeforeNavigate();
  }, [
    registerBeforeNavigate,
    unregisterBeforeNavigate,
    update,
    handleSubmit,
    editIndex,
    editValues,
    append
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("div", { "data-testid": "mgp-page-important-relationships-organization-form", children: /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("div", { "data-testid": "mgp-page-important-relationships-person-form", children: /* @__PURE__ */ (0, import_jsx_runtime52.jsxs)("div", { className: "flex flex-col sm:flex-row sm:gap-control-gap", children: [
    /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(
      import_core39.SelectBox,
      {
        label: "Organization Type",
        options: IMPORTANT_RELATIONSHIP_ORGANIZATION_TYPE_OPTIONS,
        error: (_a = errors["ORGANIZATION_TYPE" /* ORGANIZATION_TYPE */]) == null ? void 0 : _a.message,
        selected: selectedOrganizationType,
        onChange: (selected) => {
          setValue(
            "ORGANIZATION_TYPE" /* ORGANIZATION_TYPE */,
            selected.value ?? "",
            { shouldValidate: true }
          );
        }
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(
      import_core39.TextInput,
      {
        label: "Organization Name",
        ...register("NAME" /* NAME */),
        error: (_b = errors["NAME" /* NAME */]) == null ? void 0 : _b.message
      }
    ) })
  ] }) }) });
};
var ImportantRelationshipsOrganizationForm_default = ImportantRelationshipsOrganizationForm;

// src/modules/money-guide-pro/components/AnnualIncome/AnnualIncome.tsx
var import_core40 = require("@earned/core");
var import_react_hook_form18 = require("react-hook-form");
var import_jsx_runtime53 = require("react/jsx-runtime");
var AnnualIncome = () => {
  var _a, _b, _c, _d;
  const {
    register,
    formState: { errors },
    watch
  } = (0, import_react_hook_form18.useFormContext)();
  const client = watch("client");
  const coClient = watch("coClient");
  const hasCoClient = !!(coClient == null ? void 0 : coClient.FIRST_NAME);
  return /* @__PURE__ */ (0, import_jsx_runtime53.jsxs)("div", { "data-testid": "annual-income", children: [
    /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(
      import_core40.TextInput,
      {
        label: hasCoClient ? `${client.FIRST_NAME} ${client.LAST_NAME} Annual Income` : "Annual Income",
        type: "currency",
        ...register(`client.${"ANNUAL_INCOME" /* ANNUAL_INCOME */}`),
        error: (_b = (_a = errors == null ? void 0 : errors["client"]) == null ? void 0 : _a["ANNUAL_INCOME" /* ANNUAL_INCOME */]) == null ? void 0 : _b.message,
        autoFocus: true
      }
    ),
    hasCoClient && /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(
      import_core40.TextInput,
      {
        label: `${coClient.FIRST_NAME} ${coClient.LAST_NAME} Annual Income`,
        type: "currency",
        ...register(`coClient.${"ANNUAL_INCOME" /* ANNUAL_INCOME */}`),
        error: (_d = (_c = errors == null ? void 0 : errors["coClient"]) == null ? void 0 : _c["ANNUAL_INCOME" /* ANNUAL_INCOME */]) == null ? void 0 : _d.message
      }
    )
  ] });
};
var AnnualIncome_default = AnnualIncome;

// src/modules/money-guide-pro/components/CareerChange/CareerChange.tsx
var import_core41 = require("@earned/core");
var React20 = __toESM(require("react"));
var import_react_hook_form19 = require("react-hook-form");
var import_jsx_runtime54 = require("react/jsx-runtime");
var CareerChange = ({
  isCoClientPage = false
}) => {
  var _a, _b;
  const {
    register,
    formState: { errors },
    watch,
    setValue
  } = (0, import_react_hook_form19.useFormContext)();
  const client = watch("client");
  const coClient = watch("coClient");
  const formKey = isCoClientPage ? "coClient" : "client";
  const careerChange = isCoClientPage ? coClient["CAREER_CHANGE" /* CAREER_CHANGE */] : client["CAREER_CHANGE" /* CAREER_CHANGE */];
  const contextKey = React20.useMemo(() => `career-change-${formKey}`, [formKey]);
  const handleCareerChange = React20.useCallback(
    (option, checked) => {
      const currentValue = careerChange || [];
      if (checked) {
        setValue(`${formKey}.${"CAREER_CHANGE" /* CAREER_CHANGE */}`, [
          ...currentValue,
          option.value
        ]);
      } else {
        setValue(
          `${formKey}.${"CAREER_CHANGE" /* CAREER_CHANGE */}`,
          currentValue.filter((v) => v !== option.value)
        );
        setValue(`${formKey}.${option.inputKey}`, "");
      }
    },
    [careerChange, formKey, setValue]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime54.jsx)("div", { "data-testid": "career-change", children: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
    import_core41.CheckboxGroup,
    {
      ...register(`${formKey}.${"CAREER_CHANGE" /* CAREER_CHANGE */}`),
      error: (_b = (_a = errors[formKey]) == null ? void 0 : _a[`${"CAREER_CHANGE" /* CAREER_CHANGE */}`]) == null ? void 0 : _b.message,
      children: CAREER_CHANGE_OPTIONS.map((option) => {
        var _a2, _b2;
        const isChecked = careerChange == null ? void 0 : careerChange.includes(option.value);
        return /* @__PURE__ */ (0, import_jsx_runtime54.jsxs)(React20.Fragment, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
            import_core41.Checkbox,
            {
              label: option.label,
              value: option.value,
              checked: isChecked,
              onChange: (e) => handleCareerChange(option, e.target.checked)
            }
          ),
          isChecked && /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(QuestionBlock_default, { applyIndent: true, applyPadding: false, children: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
            import_core41.TextInput,
            {
              label: "Please describe",
              ...register(`${formKey}.${option.inputKey}`),
              error: (_b2 = (_a2 = errors[formKey]) == null ? void 0 : _a2[`${option.inputKey}`]) == null ? void 0 : _b2.message,
              autoFocus: true
            }
          ) })
        ] }, `${contextKey}-${option.value}`);
      })
    },
    contextKey
  ) });
};
var CareerChange_default = CareerChange;

// src/modules/money-guide-pro/components/RetirementExpenses/RetirementExpenses.tsx
var import_core42 = require("@earned/core");
var import_react_hook_form20 = require("react-hook-form");
var import_jsx_runtime55 = require("react/jsx-runtime");
var RetirementExpenses = () => {
  var _a, _b, _c, _d;
  const {
    register,
    formState: { errors }
  } = (0, import_react_hook_form20.useFormContext)();
  return /* @__PURE__ */ (0, import_jsx_runtime55.jsxs)("div", { "data-testid": "retirement-expenses", children: [
    /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
      import_core42.TextInput,
      {
        label: "Current Monthly Expenses",
        type: "currency",
        ...register(
          `household.${"CURRENT_MONTHLY_LIVING_EXPENSES" /* CURRENT_MONTHLY_LIVING_EXPENSES */}`
        ),
        error: (_b = (_a = errors["household"]) == null ? void 0 : _a.CURRENT_MONTHLY_LIVING_EXPENSES) == null ? void 0 : _b.message,
        autoFocus: true
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
      import_core42.TextInput,
      {
        label: "Retirement Monthly Expenses",
        type: "currency",
        ...register(
          `household.${"RETIREMENT_MONTHLY_LIVING_EXPENSES" /* RETIREMENT_MONTHLY_LIVING_EXPENSES */}`
        ),
        error: (_d = (_c = errors["household"]) == null ? void 0 : _c.RETIREMENT_MONTHLY_LIVING_EXPENSES) == null ? void 0 : _d.message,
        tooltip: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
          import_core42.Tooltip,
          {
            title: "Monthly Retirement Expense Amount",
            description: /* @__PURE__ */ (0, import_jsx_runtime55.jsxs)("div", { children: [
              /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(import_core42.Typography, { variant: "body", color: "primary", children: RETIREMENT_MONTHLY_EXPENSES_TOOLTIP_COPY }),
              /* @__PURE__ */ (0, import_jsx_runtime55.jsx)("ul", { className: "ml-4 list-disc", children: RETIREMENT_MONTHLY_EXPENSES_TOOLTIP_ITEMS.map(
                (item, index) => /* @__PURE__ */ (0, import_jsx_runtime55.jsx)("li", { className: "pl-1", children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(import_core42.Typography, { variant: "body", color: "primary", children: item }) }, index)
              ) })
            ] }),
            children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)("div", { className: "text-link", children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
              import_core42.Typography,
              {
                variant: "body",
                color: "inherit",
                className: "hover:underline",
                children: "Details"
              }
            ) })
          }
        ) })
      }
    )
  ] });
};
var RetirementExpenses_default = RetirementExpenses;

// src/common/components/ListFooterTotals/ListFooterTotals.tsx
var import_core43 = require("@earned/core");
var import_jsx_runtime56 = require("react/jsx-runtime");
var ListFooterTotals = ({
  totalAmount,
  label
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime56.jsx)(ListDivider_default, { useBlock: true, children: /* @__PURE__ */ (0, import_jsx_runtime56.jsx)("div", { "data-testid": "list-footer-totals", children: /* @__PURE__ */ (0, import_jsx_runtime56.jsx)("div", { className: "flex w-full justify-end", children: /* @__PURE__ */ (0, import_jsx_runtime56.jsxs)(import_core43.Typography, { variant: "title-xs", weight: "semibold", children: [
    label,
    ": ",
    formatters.currency(totalAmount.toString())
  ] }) }) }) });
};
var ListFooterTotals_default = ListFooterTotals;

// src/modules/money-guide-pro/components/Employment/Employment.tsx
var React21 = __toESM(require("react"));
var import_react_hook_form21 = require("react-hook-form");
var import_jsx_runtime57 = require("react/jsx-runtime");
var Employment2 = ({
  navigateTo,
  employmentsFields,
  removeEmployment,
  onEditClick,
  clients
}) => {
  const handleAddClick = () => {
    navigateTo("EMPLOYMENT_FORM");
  };
  const [removeItemIndex, setRemoveItemIndex] = React21.useState(
    null
  );
  const onCloseRemoveDialog = () => setRemoveItemIndex(null);
  const onRemove = () => {
    removeEmployment(removeItemIndex);
    onCloseRemoveDialog();
  };
  const { watch } = (0, import_react_hook_form21.useFormContext)();
  const coClient = watch("coClient");
  const hasCoClient = !!(coClient == null ? void 0 : coClient.FIRST_NAME);
  const clientsOptions = React21.useMemo(() => {
    return clients.map((client) => ({
      label: `${client.firstName} ${client.lastName}`,
      value: client.id
    }));
  }, [clients]);
  const totalAnnualIncome = React21.useMemo(
    () => employmentsFields.reduce(
      (total, field) => total + Number(field["ANNUAL_INCOME" /* ANNUAL_INCOME */].replace(/[^\d.]/g, "")),
      0
    ),
    [employmentsFields]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime57.jsxs)("div", { "data-testid": "employment", children: [
    /* @__PURE__ */ (0, import_jsx_runtime57.jsxs)("div", { className: "flex flex-col gap-8", children: [
      /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(AddButton_default, { label: "Add Employment", onClick: handleAddClick }),
      /* @__PURE__ */ (0, import_jsx_runtime57.jsxs)("div", { children: [
        employmentsFields.map((field, index) => /* @__PURE__ */ (0, import_jsx_runtime57.jsxs)(
          UserSummary_default,
          {
            title: field["TITLE" /* TITLE */],
            subtitle: formatters.currency(
              field["ANNUAL_INCOME" /* ANNUAL_INCOME */]
            ),
            onEditClick: () => onEditClick(index),
            onRemoveClick: () => setRemoveItemIndex(index),
            children: [
              hasCoClient && /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
                ReviewList_default,
                {
                  label: "Client Name",
                  value: formatters.string(
                    getReviewListValue(
                      clientsOptions,
                      field["CLIENT_ID" /* CLIENT_ID */]
                    )
                  )
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
                ReviewList_default,
                {
                  label: "Employer Name",
                  value: formatters.string(
                    field["EMPLOYER_NAME" /* EMPLOYER_NAME */]
                  )
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
                ReviewList_default,
                {
                  label: "Employment Type",
                  value: formatters.string(
                    field["TYPE" /* TYPE */] === EMPLOYMENT_TYPE.OTHER ? getReviewListValue(
                      EMPLOYMENT_TYPE_OPTIONS,
                      field["OTHER_TYPE" /* OTHER_TYPE */]
                    ) : getReviewListValue(
                      EMPLOYMENT_TYPE_OPTIONS,
                      field["TYPE" /* TYPE */]
                    )
                  )
                }
              )
            ]
          },
          field.id
        )),
        employmentsFields.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
          ListFooterTotals_default,
          {
            totalAmount: totalAnnualIncome,
            label: "Total Annual Employment Income"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
      ListItemRemoveDialog_default,
      {
        isOpen: removeItemIndex !== null,
        onClose: onCloseRemoveDialog,
        onRemove
      }
    )
  ] });
};
var Employment_default = Employment2;

// src/modules/money-guide-pro/components/EmploymentForm/EmploymentForm.tsx
var import_core45 = require("@earned/core");
var import_yup7 = require("@hookform/resolvers/yup");
var React23 = __toESM(require("react"));
var import_react_hook_form23 = require("react-hook-form");

// src/modules/money-guide-pro/components/EmploymentOptions/EmploymentOptions.tsx
var import_core44 = require("@earned/core");
var import_react6 = __toESM(require("react"));
var import_react_hook_form22 = require("react-hook-form");
var import_jsx_runtime58 = require("react/jsx-runtime");
var EmploymentOptions = import_react6.default.forwardRef(
  ({ ...props }, ref) => {
    const {
      register,
      formState: { errors },
      watch
    } = (0, import_react_hook_form22.useFormContext)();
    const selectedType = watch("TYPE" /* TYPE */);
    return /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(import_jsx_runtime58.Fragment, { children: EMPLOYMENT_TYPE_OPTIONS.map((option) => {
      var _a;
      return /* @__PURE__ */ (0, import_jsx_runtime58.jsxs)(import_react6.default.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
          import_core44.Radio,
          {
            label: option.label,
            ...props,
            value: option.value,
            ref
          }
        ),
        option.value === EMPLOYMENT_TYPE.OTHER && selectedType === EMPLOYMENT_TYPE.OTHER && /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(QuestionBlock_default, { applyPadding: false, applyIndent: true, children: /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
          import_core44.TextInput,
          {
            error: (_a = errors == null ? void 0 : errors["OTHER_TYPE" /* OTHER_TYPE */]) == null ? void 0 : _a.message,
            ...register("OTHER_TYPE" /* OTHER_TYPE */),
            autoFocus: true
          }
        ) })
      ] }, option.value);
    }) });
  }
);
var EmploymentOptions_default = EmploymentOptions;

// src/modules/money-guide-pro/components/EmploymentForm/EmploymentForm.tsx
var import_classnames4 = __toESM(require("classnames"));
var import_jsx_runtime59 = require("react/jsx-runtime");
var Title = ({
  hasCoClient,
  errors,
  register
}) => {
  var _a;
  return /* @__PURE__ */ (0, import_jsx_runtime59.jsx)("div", { className: (0, import_classnames4.default)(!hasCoClient && "row-start-2"), children: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
    import_core45.TextInput,
    {
      label: "Title",
      error: (_a = errors == null ? void 0 : errors["TITLE" /* TITLE */]) == null ? void 0 : _a.message,
      ...register("TITLE" /* TITLE */)
    }
  ) });
};
var EmployerName = ({
  hasCoClient,
  errors,
  register
}) => {
  var _a;
  return /* @__PURE__ */ (0, import_jsx_runtime59.jsx)("div", { className: (0, import_classnames4.default)(!hasCoClient && "EmployerName"), children: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
    import_core45.TextInput,
    {
      label: "Employer Name",
      error: (_a = errors == null ? void 0 : errors["EMPLOYER_NAME" /* EMPLOYER_NAME */]) == null ? void 0 : _a.message,
      ...register("EMPLOYER_NAME" /* EMPLOYER_NAME */)
    }
  ) });
};
var AnnualEmploymentIncome = ({
  hasCoClient,
  errors,
  register
}) => {
  var _a;
  return /* @__PURE__ */ (0, import_jsx_runtime59.jsx)("div", { className: (0, import_classnames4.default)(!hasCoClient && "AnnualEmploymentIncomeNoCoClient"), children: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
    import_core45.TextInput,
    {
      label: "Annual Employment Income",
      type: "currency",
      error: (_a = errors == null ? void 0 : errors["ANNUAL_INCOME" /* ANNUAL_INCOME */]) == null ? void 0 : _a.message,
      ...register("ANNUAL_INCOME" /* ANNUAL_INCOME */),
      tooltip: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
        import_core45.Tooltip,
        {
          title: "Annual Employment Income",
          description: "Enter your gross employment income including salary, commissions, and bonuses.",
          children: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)("div", { className: "text-link", children: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
            import_core45.Typography,
            {
              variant: "body",
              color: "inherit",
              className: "hover:underline",
              children: "Details"
            }
          ) })
        }
      ) })
    }
  ) });
};
var EmploymentForm = ({
  clients,
  update,
  append,
  editValues,
  editIndex
}) => {
  var _a, _b;
  const methods = (0, import_react_hook_form23.useForm)({
    values: editValues ? MGP_EMPLOYMENT_SCHEMA.cast(editValues) : MGP_EMPLOYMENT_SCHEMA.getDefault(),
    mode: "onTouched",
    resolver: (0, import_yup7.yupResolver)(MGP_EMPLOYMENT_SCHEMA)
  });
  const {
    register,
    formState: { errors },
    setValue,
    handleSubmit,
    watch
  } = methods;
  const { watch: watchForm } = (0, import_react_hook_form23.useFormContext)();
  const client = watchForm("client");
  const coClient = watchForm("coClient");
  const hasCoClient = !!(coClient == null ? void 0 : coClient.FIRST_NAME);
  const clientNameOptions = React23.useMemo(() => {
    return clients.map((client2) => ({
      label: `${client2.firstName} ${client2.lastName}`,
      value: client2.id,
      id: client2.id
    }));
  }, [clients]);
  const selectedClientId = watch("CLIENT_ID" /* CLIENT_ID */);
  const selectedClient = clientNameOptions.find((option) => option.value === selectedClientId) || clientNameOptions[0];
  React23.useEffect(() => {
    if (!selectedClientId) {
      setValue("CLIENT_ID" /* CLIENT_ID */, clientNameOptions[0].value);
    }
  }, [selectedClientId, clientNameOptions, setValue]);
  const { registerBeforeNavigate, unregisterBeforeNavigate } = useNavigationContext();
  React23.useEffect(() => {
    const beforeNavigate = async () => {
      return new Promise(
        (accept) => handleSubmit(
          async (values) => {
            if (editIndex !== void 0) {
              update(editIndex, values);
            } else {
              append(values);
            }
            accept(true);
          },
          () => accept(false)
        )()
      );
    };
    registerBeforeNavigate(beforeNavigate);
    return () => unregisterBeforeNavigate();
  }, [
    registerBeforeNavigate,
    unregisterBeforeNavigate,
    update,
    handleSubmit,
    editIndex,
    editValues,
    append,
    selectedClientId
  ]);
  const employments = watchForm(EMPLOYMENT_FIELD_ARRAY_NAME);
  useEmploymentPrefill({
    client,
    coClient,
    setValue,
    isEditing: editIndex !== void 0,
    employments
  });
  return /* @__PURE__ */ (0, import_jsx_runtime59.jsx)("div", { "data-testid": "employment-form", className: "EmploymentForm", children: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(import_react_hook_form23.FormProvider, { ...methods, children: /* @__PURE__ */ (0, import_jsx_runtime59.jsxs)("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ (0, import_jsx_runtime59.jsxs)(
      "div",
      {
        className: (0, import_classnames4.default)(
          "Grid",
          hasCoClient ? "RowsCoClient" : "RowsNoCoClient"
        ),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
            "div",
            {
              className: (0, import_classnames4.default)(
                !hasCoClient ? "invisible m-0 h-0 overflow-hidden" : "col-span-1"
              ),
              children: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
                import_core45.SelectBox,
                {
                  label: "Client Name",
                  error: (_a = errors == null ? void 0 : errors["CLIENT_ID" /* CLIENT_ID */]) == null ? void 0 : _a.message,
                  options: [NO_SELECTION_OPTION, ...clientNameOptions],
                  selected: selectedClient,
                  onChange: (selected) => {
                    setValue(
                      "CLIENT_ID" /* CLIENT_ID */,
                      selected.value
                    );
                  }
                }
              )
            }
          ),
          hasCoClient ? /* @__PURE__ */ (0, import_jsx_runtime59.jsxs)(import_jsx_runtime59.Fragment, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
              AnnualEmploymentIncome,
              {
                hasCoClient,
                errors,
                register
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
              Title,
              {
                hasCoClient,
                errors,
                register
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
              EmployerName,
              {
                hasCoClient,
                errors,
                register
              }
            )
          ] }) : /* @__PURE__ */ (0, import_jsx_runtime59.jsxs)(import_jsx_runtime59.Fragment, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
              Title,
              {
                hasCoClient,
                errors,
                register
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
              EmployerName,
              {
                hasCoClient,
                errors,
                register
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
              AnnualEmploymentIncome,
              {
                hasCoClient,
                errors,
                register
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(QuestionBlock_default, { label: "Type", children: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
      import_core45.RadioGroup,
      {
        error: (_b = errors == null ? void 0 : errors["TYPE" /* TYPE */]) == null ? void 0 : _b.message,
        ...register("TYPE" /* TYPE */),
        children: /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(EmploymentOptions_default, {})
      }
    ) })
  ] }) }) });
};
var EmploymentForm_default = EmploymentForm;

// src/common/components/MultiSelectIconGrid/MultiSelectIconGrid.tsx
var React24 = __toESM(require("react"));

// src/common/components/MultiSelectIconGridOption/MultiSelectIconGridOption.tsx
var import_classnames5 = __toESM(require("classnames"));
var import_core46 = require("@earned/core");
var import_jsx_runtime60 = require("react/jsx-runtime");
var MultiSelectIconGridOption = ({
  label,
  value,
  icon,
  isSelected,
  onSelect
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime60.jsxs)(
    "div",
    {
      onClick: () => onSelect(value),
      className: (0, import_classnames5.default)(
        "flex cursor-pointer flex-col items-center gap-2 rounded-lg border-[1px] px-3 pb-8 pt-6 transition-all duration-200",
        "h-[190px] w-[170px] text-center text-green-4 hover:border-green-200",
        isSelected ? "border-green-200 bg-offwhite" : "border-gray-200 bg-white"
      ),
      children: [
        icon,
        /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(import_core46.Typography, { variant: "body", weight: "medium", color: "inherit", children: label })
      ]
    },
    value
  );
};
var MultiSelectIconGridOption_default = MultiSelectIconGridOption;

// src/common/components/MultiSelectIconGrid/MultiSelectIconGrid.tsx
var import_jsx_runtime61 = require("react/jsx-runtime");
var MultiSelectIconGrid = React24.memo(
  ({ options, value, onChange }) => {
    const handleItemClick = React24.useCallback(
      (itemValue) => {
        if (!onChange)
          return;
        const isSelected = value.includes(itemValue);
        const newSelectedItems = isSelected ? value.filter((item) => item !== itemValue) : [...value, itemValue];
        onChange(newSelectedItems);
      },
      [value, onChange]
    );
    return /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
      "div",
      {
        className: "grid grid-cols-[repeat(auto-fill,minmax(170px,1fr))] justify-items-center gap-x-5 gap-y-6 pb-8 pt-4",
        role: "group",
        "data-testid": "multi-select-icon-grid",
        children: options.map((option) => /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
          MultiSelectIconGridOption_default,
          {
            label: option.label,
            value: option.value,
            icon: option.icon,
            isSelected: value.includes(option.value),
            onSelect: handleItemClick
          },
          option.value
        ))
      }
    );
  }
);
MultiSelectIconGrid.displayName = "MultiSelectIconGrid";
var MultiSelectIconGrid_default = MultiSelectIconGrid;

// src/modules/money-guide-pro/components/Goals/Goals.tsx
var import_core47 = require("@earned/core");

// src/modules/money-guide-pro/assets/images/Travel.svg
var React25 = __toESM(require("react"));
var import_jsx_runtime62 = require("react/jsx-runtime");
var SvgTravel = (props) => /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("svg", { width: 76, height: 71, viewBox: "0 0 76 71", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("path", { id: "Travel", d: "M0.5 49.6349V21.5763L7.98229 29.0586H30.4292L13.594 1H22.9469L51.0055 29.0586H68.7759C77.1935 29.0586 75.3229 42.1526 75.3229 42.1526H51.0055L22.9469 70.2112H13.594L30.4292 42.1526H7.98229L0.5 49.6349Z", stroke: "#095921", strokeWidth: 0.83, strokeLinecap: "round" }) });
var Travel_default = SvgTravel;

// src/modules/money-guide-pro/assets/images/Car.svg
var React26 = __toESM(require("react"));
var import_jsx_runtime63 = require("react/jsx-runtime");
var SvgCar = (props) => /* @__PURE__ */ (0, import_jsx_runtime63.jsx)("svg", { width: 84, height: 84, viewBox: "0 0 84 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime63.jsx)("g", { id: "Car", children: /* @__PURE__ */ (0, import_jsx_runtime63.jsxs)("g", { id: "Car_2", children: [
  /* @__PURE__ */ (0, import_jsx_runtime63.jsx)("path", { id: "Car_3", d: "M15.2102 57.428C11.009 57.428 8.6797 53.2373 8.6797 48.0678V41.3655C8.6797 36.196 8.63847 35.4527 12.8397 35.4527H16.3755C18.9189 35.4527 21.294 30.0765 22.7048 27.4725L25.7953 21.7684C27.2061 19.1644 28.9571 16.0632 31.5005 16.0632H50.5178C53.0612 16.0632 55.1687 19.5291 56.5795 22.1331L59.67 27.8372C61.0808 30.4412 63.4559 35.8173 65.9993 35.8173H69.5351C73.7363 35.8173 77.1421 36.196 77.1421 41.3655V48.0678C77.1421 53.2373 76.6409 57.428 72.4397 57.428M39.9361 57.428H47.543", stroke: "#095921", strokeWidth: 0.830525, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ (0, import_jsx_runtime63.jsx)("path", { id: "Ellipse 94", d: "M35.6947 58.9537C35.6947 63.3901 32.0538 66.995 27.5519 66.995C23.0501 66.995 19.4091 63.3901 19.4091 58.9537C19.4091 54.5172 23.0501 50.9123 27.5519 50.9123C32.0538 50.9123 35.6947 54.5172 35.6947 58.9537Z", stroke: "#095921", strokeWidth: 0.83 }),
  /* @__PURE__ */ (0, import_jsx_runtime63.jsx)("path", { id: "Ellipse 95", d: "M68.0229 58.9537C68.0229 63.3901 64.3819 66.995 59.8801 66.995C55.3782 66.995 51.7373 63.3901 51.7373 58.9537C51.7373 54.5172 55.3782 50.9123 59.8801 50.9123C64.3819 50.9123 68.0229 54.5172 68.0229 58.9537Z", stroke: "#095921", strokeWidth: 0.83 })
] }) }) });
var Car_default = SvgCar;

// src/modules/money-guide-pro/assets/images/LeaveBequest.svg
var React27 = __toESM(require("react"));
var import_jsx_runtime64 = require("react/jsx-runtime");
var SvgLeaveBequest = (props) => /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("svg", { width: 84, height: 84, viewBox: "0 0 84 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("g", { id: "Leave Bequest", children: /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)("g", { id: "Leave Bequest_2", children: [
  /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("path", { id: "Icon", d: "M60.7188 74.0747C64.9069 74.0747 68.3021 70.7983 68.3021 66.7568V31.6827C68.3021 30.7123 67.9026 29.7817 67.1915 29.0955L46.6626 9.28506C45.9516 8.59888 44.9871 8.21338 43.9815 8.21338H22.8021C18.6139 8.21338 15.2188 11.4897 15.2188 15.5313V66.7568C15.2188 70.7984 18.6139 74.0747 22.8021 74.0747H30.1926", stroke: "#095921", strokeWidth: 0.830525, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)("g", { id: "Group 368680", children: [
    /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("path", { id: "Ellipse 104", d: "M58.303 56.4888C58.303 63.3406 52.5428 68.92 45.4059 68.92C38.2689 68.92 32.5087 63.3406 32.5087 56.4888C32.5087 49.637 38.2689 44.0576 45.4059 44.0576C52.5428 44.0576 58.303 49.637 58.303 56.4888Z", stroke: "#095921", strokeWidth: 0.83 }),
    /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("path", { id: "Vector 13", d: "M39.7012 67.4998V76.6756L45.4064 74.6365L51.1116 76.6756V67.4998", stroke: "#095921", strokeWidth: 0.83, strokeLinecap: "square" })
  ] })
] }) }) });
var LeaveBequest_default = SvgLeaveBequest;

// src/modules/money-guide-pro/assets/images/Celebration.svg
var React28 = __toESM(require("react"));
var import_jsx_runtime65 = require("react/jsx-runtime");
var SvgCelebration = (props) => /* @__PURE__ */ (0, import_jsx_runtime65.jsx)("svg", { width: 84, height: 84, viewBox: "0 0 84 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime65.jsx)("g", { id: "Media / Icon", children: /* @__PURE__ */ (0, import_jsx_runtime65.jsx)("path", { id: "Icon", d: "M15.4583 7.875V23.0417M7.875 15.4583H23.0417M19.25 60.9583V76.125M11.6667 68.5417H26.8333M45.7917 7.875L54.4583 33.875L76.125 42L54.4583 50.125L45.7917 76.125L37.125 50.125L15.4583 42L37.125 33.875L45.7917 7.875Z", stroke: "#095921", strokeWidth: 0.830525, strokeLinecap: "round", strokeLinejoin: "round" }) }) });
var Celebration_default = SvgCelebration;

// src/modules/money-guide-pro/assets/images/PrivateSchool.svg
var React29 = __toESM(require("react"));
var import_jsx_runtime66 = require("react/jsx-runtime");
var SvgPrivateSchool = (props) => /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("svg", { width: 84, height: 84, viewBox: "0 0 84 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("g", { id: "Media / Icon", children: /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("path", { id: "Icon", d: "M26.8333 49.5833V60.9583M42 49.5833V60.9583M57.1667 49.5833V60.9583M7.875 76.125H76.125M7.875 34.4167H76.125M7.875 23.0417L42 7.875L76.125 23.0417M11.6667 34.4167H72.3333V76.125H11.6667V34.4167Z", stroke: "#095921", strokeWidth: 0.830525, strokeLinecap: "round", strokeLinejoin: "round" }) }) });
var PrivateSchool_default = SvgPrivateSchool;

// src/modules/money-guide-pro/assets/images/College.svg
var React30 = __toESM(require("react"));
var import_jsx_runtime67 = require("react/jsx-runtime");
var SvgCollege = (props) => /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("svg", { width: 84, height: 84, viewBox: "0 0 84 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("g", { id: "Media / Icon", children: /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("path", { id: "Icon", d: "M42 49.4782L76.125 30.5199L42 11.5615L7.875 30.5199L42 49.4782ZM42 49.4782L65.3533 36.5041C67.4108 41.6923 68.5417 47.3489 68.5417 53.2697C68.5417 55.9288 68.3136 58.5347 67.8758 61.0688C57.9792 62.0311 49.0109 66.1639 42 72.4388C34.9891 66.1639 26.0208 62.0311 16.1242 61.0688C15.6865 58.5346 15.4583 55.9286 15.4583 53.2694C15.4583 47.3488 16.5892 41.6922 18.6467 36.504L42 49.4782ZM26.8333 72.228V43.7907L42 35.3648", stroke: "#095921", strokeWidth: 0.830525, strokeLinecap: "round", strokeLinejoin: "round" }) }) });
var College_default = SvgCollege;

// src/modules/money-guide-pro/assets/images/ProvideCare.svg
var React31 = __toESM(require("react"));
var import_jsx_runtime68 = require("react/jsx-runtime");
var SvgProvideCare = (props) => /* @__PURE__ */ (0, import_jsx_runtime68.jsx)("svg", { width: 84, height: 84, viewBox: "0 0 84 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime68.jsxs)("g", { id: "Provide Care", children: [
  /* @__PURE__ */ (0, import_jsx_runtime68.jsx)("path", { id: "Provide Care_2", d: "M12.8725 17.87C6.20917 24.5334 6.20917 35.3367 12.8725 42.0001L42.0002 71.1278L71.1275 42.0001C77.7908 35.3367 77.7908 24.5334 71.1275 17.87C64.4642 11.2067 53.6608 11.2067 46.9975 17.8701L42.0002 22.8677L37.0025 17.87C30.3392 11.2067 19.5358 11.2067 12.8725 17.87Z", stroke: "#095921", strokeWidth: 0.830525, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ (0, import_jsx_runtime68.jsx)("path", { id: "Icon", d: "M41.842 31.1978V54.0185M30.4316 42.6081H53.2524", stroke: "#095921", strokeWidth: 0.830525, strokeLinecap: "round", strokeLinejoin: "round" })
] }) });
var ProvideCare_default = SvgProvideCare;

// src/modules/money-guide-pro/assets/images/MajorPurchase.svg
var React32 = __toESM(require("react"));
var import_jsx_runtime69 = require("react/jsx-runtime");
var SvgMajorPurchase = (props) => /* @__PURE__ */ (0, import_jsx_runtime69.jsx)("svg", { width: 84, height: 84, viewBox: "0 0 84 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime69.jsx)("g", { id: "Media / Icon", children: /* @__PURE__ */ (0, import_jsx_runtime69.jsx)("path", { id: "Icon", d: "M47.6875 10.4423L47.3762 10.7171C47.3819 10.7235 47.3878 10.7298 47.3939 10.7359L47.6875 10.4423ZM73.5577 47.6875L73.2829 47.3762C73.2765 47.3819 73.2702 47.3878 73.2641 47.3939L73.5577 47.6875ZM74.2292 36.984L74.5405 36.7092C74.5348 36.7027 74.5289 36.6964 74.5228 36.6903L74.2292 36.984ZM36.984 74.2292L36.6903 74.5228C36.6964 74.5289 36.7027 74.5348 36.7092 74.5405L36.984 74.2292ZM47.016 74.2292L47.2908 74.5405C47.2973 74.5348 47.3036 74.5289 47.3097 74.5228L47.016 74.2292ZM10.4423 47.6875L10.7359 47.3939L10.7268 47.3847L10.7171 47.3762L10.4423 47.6875ZM23.0417 22.6264C22.8123 22.6264 22.6264 22.8123 22.6264 23.0417C22.6264 23.271 22.8123 23.4569 23.0417 23.4569V22.6264ZM23.0796 23.4569C23.3089 23.4569 23.4948 23.271 23.4948 23.0417C23.4948 22.8123 23.3089 22.6264 23.0796 22.6264V23.4569ZM8.29026 23.0417C8.29026 14.8947 14.8947 8.29026 23.0417 8.29026V7.45974C14.436 7.45974 7.45974 14.436 7.45974 23.0417H8.29026ZM8.29026 42V23.0417H7.45974V42H8.29026ZM23.0417 8.29026H42V7.45974H23.0417V8.29026ZM42 8.29026C44.1409 8.29026 46.0621 9.22827 47.3762 10.7171L47.9988 10.1675C46.5338 8.50764 44.389 7.45974 42 7.45974V8.29026ZM75.7097 42C75.7097 44.1409 74.7717 46.0621 73.2829 47.3762L73.8325 47.9988C75.4924 46.5338 76.5403 44.389 76.5403 42H75.7097ZM73.9178 37.2588C75.0333 38.5226 75.7097 40.1818 75.7097 42H76.5403C76.5403 39.9717 75.7848 38.1189 74.5405 36.7092L73.9178 37.2588ZM42 75.7097C40.1818 75.7097 38.5226 75.0333 37.2588 73.9178L36.7092 74.5405C38.1189 75.7848 39.9717 76.5403 42 76.5403V75.7097ZM46.7412 73.9178C45.4774 75.0333 43.8182 75.7097 42 75.7097V76.5403C44.0283 76.5403 45.8811 75.7848 47.2908 74.5405L46.7412 73.9178ZM10.7171 47.3762C9.22827 46.0621 8.29026 44.1409 8.29026 42H7.45974C7.45974 44.389 8.50764 46.5338 10.1675 47.9988L10.7171 47.3762ZM47.3939 10.7359L73.9355 37.2776L74.5228 36.6903L47.9811 10.1487L47.3939 10.7359ZM37.2776 73.9355L10.7359 47.3939L10.1487 47.9811L36.6903 74.5228L37.2776 73.9355ZM73.2641 47.3939L46.7224 73.9355L47.3097 74.5228L73.8513 47.9811L73.2641 47.3939ZM23.0417 23.4569H23.0796V22.6264H23.0417V23.4569Z", fill: "#095921" }) }) });
var MajorPurchase_default = SvgMajorPurchase;

// src/modules/money-guide-pro/assets/images/Wedding.svg
var React33 = __toESM(require("react"));
var import_jsx_runtime70 = require("react/jsx-runtime");
var SvgWedding = (props) => /* @__PURE__ */ (0, import_jsx_runtime70.jsxs)("svg", { width: 84, height: 84, viewBox: "0 0 84 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ (0, import_jsx_runtime70.jsx)("path", { d: "M76.0698 61.3446C74.0809 61.3446 72.092 61.8589 70.3646 62.8874C66.9098 64.9445 62.409 64.9445 58.9542 62.8874C55.4994 60.8303 50.9986 60.8303 47.5438 62.8874C44.089 64.9445 39.5882 64.9445 36.1334 62.8874C32.6786 60.8303 28.1778 60.8303 24.723 62.8874C21.2682 64.9445 16.7674 64.9445 13.3126 62.8874C11.5852 61.8589 9.59632 61.3446 7.60742 61.3446M41.8386 30.4277V35.7109M41.8386 35.7109H26.6247C22.4236 35.7109 19.0178 38.7527 19.0178 42.505V49.2992H64.6594V42.505C64.6594 38.7527 61.2537 35.7109 57.0525 35.7109H41.8386ZM76.0698 79.8728V56.0933C76.0698 52.341 72.6641 49.2992 68.4629 49.2992H15.2144C11.0132 49.2992 7.60742 52.341 7.60742 56.0933V79.8728H76.0698Z", stroke: "#095921", strokeWidth: 0.830525, strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ (0, import_jsx_runtime70.jsx)("path", { d: "M16.4519 6.40356C15.1827 7.67277 15.1827 9.73055 16.4519 10.9998L22 16.5479L27.5481 10.9998C28.8173 9.73055 28.8173 7.67277 27.5481 6.40356C26.2789 5.13436 24.2211 5.13436 22.9519 6.40356L22 7.3555L21.0481 6.40356C19.7789 5.13436 17.7211 5.13436 16.4519 6.40356Z", stroke: "#095921", strokeWidth: 0.83, strokeLinecap: "round", strokeLinejoin: "round" })
] });
var Wedding_default = SvgWedding;

// src/modules/money-guide-pro/assets/images/StartABusiness.svg
var React34 = __toESM(require("react"));
var import_jsx_runtime71 = require("react/jsx-runtime");
var SvgStartABusiness = (props) => /* @__PURE__ */ (0, import_jsx_runtime71.jsx)("svg", { width: 86, height: 87, viewBox: "0 0 86 87", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime71.jsx)("path", { d: "M34.0352 63.0549H51.9644M42.9998 8.146V12.0681M67.4171 18.4847L64.704 21.258M77.5312 43.4444H73.6944M12.3056 43.4444H8.46875M21.2955 21.258L18.5825 18.4847M29.4346 57.3113C21.9428 49.653 21.9428 37.2364 29.4346 29.5781C36.9265 21.9198 49.0731 21.9198 56.5649 29.5781C64.0568 37.2364 64.0568 49.653 56.5649 57.3113L54.4658 59.457C52.0376 61.9393 50.6734 65.3059 50.6734 68.8163V70.8991C50.6734 75.2313 47.2378 78.7432 42.9998 78.7432C38.7618 78.7432 35.3262 75.2313 35.3262 70.8991V68.8163C35.3262 65.3059 33.962 61.9393 31.5337 59.457L29.4346 57.3113Z", stroke: "#095921", strokeWidth: 0.830525, strokeLinecap: "round", strokeLinejoin: "round" }) });
var StartABusiness_default = SvgStartABusiness;

// src/modules/money-guide-pro/assets/images/NewHome.svg
var React35 = __toESM(require("react"));
var import_jsx_runtime72 = require("react/jsx-runtime");
var SvgNewHome = (props) => /* @__PURE__ */ (0, import_jsx_runtime72.jsx)("svg", { width: 86, height: 84, viewBox: "0 0 86 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime72.jsx)("path", { d: "M8.46875 42L16.1424 34.4167M16.1424 34.4167L43 7.875L69.8576 34.4167M16.1424 34.4167V72.3333C16.1424 74.4274 17.8602 76.125 19.9792 76.125H31.4896M69.8576 34.4167L77.5312 42M69.8576 34.4167V72.3333C69.8576 74.4274 68.1398 76.125 66.0208 76.125H54.5104M31.4896 76.125C33.6086 76.125 35.3264 74.4274 35.3264 72.3333V57.1667C35.3264 55.0726 37.0442 53.375 39.1632 53.375H46.8368C48.9558 53.375 50.6736 55.0726 50.6736 57.1667V72.3333C50.6736 74.4274 52.3914 76.125 54.5104 76.125M31.4896 76.125H54.5104", stroke: "#095921", strokeWidth: 0.830525, strokeLinecap: "round", strokeLinejoin: "round" }) });
var NewHome_default = SvgNewHome;

// src/modules/money-guide-pro/assets/images/GiftOrDonation.svg
var React36 = __toESM(require("react"));
var import_jsx_runtime73 = require("react/jsx-runtime");
var SvgGiftOrDonation = (props) => /* @__PURE__ */ (0, import_jsx_runtime73.jsx)("svg", { width: 86, height: 84, viewBox: "0 0 86 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime73.jsx)("path", { d: "M43 26.8333V76.125M43 26.8333C43 26.8333 43 21.1732 43 19.25C43 15.0618 46.4356 11.6667 50.6736 11.6667C54.9116 11.6667 58.3472 15.0618 58.3472 19.25C58.3472 23.4382 54.9116 26.8333 50.6736 26.8333C48.3817 26.8333 43 26.8333 43 26.8333ZM43 26.8333C43 26.8333 43 19.4885 43 17.3542C43 12.119 38.7055 7.875 33.408 7.875C28.1105 7.875 23.816 12.119 23.816 17.3542C23.816 22.5894 28.1105 26.8333 33.408 26.8333C36.5457 26.8333 43 26.8333 43 26.8333ZM16.1424 42H69.8576M16.1424 42C11.9043 42 8.46875 38.6048 8.46875 34.4167C8.46875 30.2285 11.9043 26.8333 16.1424 26.8333H69.8576C74.0956 26.8333 77.5312 30.2285 77.5312 34.4167C77.5312 38.6048 74.0956 42 69.8576 42M16.1424 42L16.1424 68.5417C16.1424 72.7298 19.578 76.125 23.816 76.125H62.184C66.422 76.125 69.8576 72.7298 69.8576 68.5417V42", stroke: "#095921", strokeWidth: 0.830525, strokeLinecap: "round", strokeLinejoin: "round" }) });
var GiftOrDonation_default = SvgGiftOrDonation;

// src/modules/money-guide-pro/assets/images/InsurancePolicy.svg
var React37 = __toESM(require("react"));
var import_jsx_runtime74 = require("react/jsx-runtime");
var SvgInsurancePolicy = (props) => /* @__PURE__ */ (0, import_jsx_runtime74.jsx)("svg", { width: 84, height: 84, viewBox: "0 0 84 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)("path", { d: "M75.7097 42C75.7097 60.6174 60.6174 75.7097 42 75.7097V76.5403C61.0761 76.5403 76.5403 61.0761 76.5403 42H75.7097ZM42 75.7097C23.3826 75.7097 8.29026 60.6174 8.29026 42H7.45974C7.45974 61.0761 22.9239 76.5403 42 76.5403V75.7097ZM8.29026 42C8.29026 23.3826 23.3826 8.29026 42 8.29026V7.45974C22.9239 7.45974 7.45974 22.9239 7.45974 42H8.29026ZM42 8.29026C60.6174 8.29026 75.7097 23.3826 75.7097 42H76.5403C76.5403 22.9239 61.0761 7.45974 42 7.45974V8.29026ZM56.7514 42C56.7514 50.147 50.147 56.7514 42 56.7514V57.5819C50.6057 57.5819 57.5819 50.6057 57.5819 42H56.7514ZM42 56.7514C33.853 56.7514 27.2486 50.147 27.2486 42H26.4181C26.4181 50.6057 33.3943 57.5819 42 57.5819V56.7514ZM27.2486 42C27.2486 33.853 33.853 27.2486 42 27.2486V26.4181C33.3943 26.4181 26.4181 33.3943 26.4181 42H27.2486ZM42 27.2486C50.147 27.2486 56.7514 33.853 56.7514 42H57.5819C57.5819 33.3943 50.6057 26.4181 42 26.4181V27.2486ZM65.8364 17.5763L52.4308 30.9819L53.0181 31.5692L66.4237 18.1636L65.8364 17.5763ZM52.4308 53.0181L65.8364 66.4237L66.4237 65.8364L53.0181 52.4308L52.4308 53.0181ZM31.5692 30.9819L18.1636 17.5763L17.5763 18.1636L30.9819 31.5692L31.5692 30.9819ZM30.9819 52.4308L17.5763 65.8364L18.1636 66.4237L31.5692 53.0181L30.9819 52.4308Z", fill: "#095921" }) });
var InsurancePolicy_default = SvgInsurancePolicy;

// src/modules/money-guide-pro/helpers.ts
var import_lodash5 = require("lodash");
function getIcon(type) {
  switch (type) {
    case "TRAVEL" /* TRAVEL */:
      return Travel_default;
    case "CAR" /* CAR */:
      return Car_default;
    case "LEAVE_BEQUEST" /* LEAVE_BEQUEST */:
      return LeaveBequest_default;
    case "CELEBRATION" /* CELEBRATION */:
      return Celebration_default;
    case "PRIVATE_SCHOOL" /* PRIVATE_SCHOOL */:
      return PrivateSchool_default;
    case "COLLEGE" /* COLLEGE */:
      return College_default;
    case "PROVIDE_CARE" /* PROVIDE_CARE */:
      return ProvideCare_default;
    case "MAJOR_PURCHASE" /* MAJOR_PURCHASE */:
      return MajorPurchase_default;
    case "WEDDING" /* WEDDING */:
      return Wedding_default;
    case "START_BUSINESS" /* START_BUSINESS */:
      return StartABusiness_default;
    case "NEW_HOME" /* NEW_HOME */:
      return NewHome_default;
    case "GIFT_OR_DONATION" /* GIFT_OR_DONATION */:
      return GiftOrDonation_default;
    case "HOME_IMPROVEMENT" /* HOME_IMPROVEMENT */:
      return NewHome_default;
    case "INSURANCE_POLICY_PREMIUM" /* INSURANCE_POLICY_PREMIUM */:
      return InsurancePolicy_default;
    default:
      return Travel_default;
  }
}
function extractCustomGoal(cache) {
  var _a;
  if (!cache)
    return null;
  const newCache = (0, import_lodash5.cloneDeep)(cache);
  const goals = ((_a = newCache.household) == null ? void 0 : _a.goals) || [];
  const customGoalIndex = goals.findIndex(
    (goal) => !Object.values(MgpGoalType).includes(goal.TYPE)
  );
  if (customGoalIndex !== -1) {
    const [customGoal] = goals.splice(customGoalIndex, 1);
    newCache[HELPER_FIELDS.CUSTOM_GOAL] = customGoal.CUSTOM_TYPE;
  }
  return newCache;
}
function restoreCustomGoal(fields) {
  const newFields = (0, import_lodash5.cloneDeep)(fields);
  const customGoal = newFields[HELPER_FIELDS.CUSTOM_GOAL];
  if (customGoal) {
    if (!newFields.household.goals) {
      newFields.household.goals = [];
    }
    newFields.household.goals.push({
      TYPE: "CUSTOM",
      CUSTOM_TYPE: customGoal
    });
    delete newFields[HELPER_FIELDS.CUSTOM_GOAL];
  }
  return newFields;
}

// src/modules/money-guide-pro/components/Goals/Goals.tsx
var React38 = __toESM(require("react"));
var import_react_hook_form24 = require("react-hook-form");
var import_jsx_runtime75 = require("react/jsx-runtime");
var GOALS_OPTIONS_WITH_ICONS = GOALS_OPTIONS.map((goal) => {
  const Icon3 = getIcon(goal.value);
  return {
    ...goal,
    icon: /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(Icon3, { width: 84, height: 84 })
  };
});
var Goals = () => {
  var _a;
  const {
    setValue,
    formState: { errors },
    watch,
    register,
    trigger
  } = (0, import_react_hook_form24.useFormContext)();
  const selectedGoals = watch("household.goals");
  const selectedGoalTypes = React38.useMemo(
    () => selectedGoals.map((goal) => goal.TYPE),
    [selectedGoals]
  );
  const handleSelectGoal = React38.useCallback(
    (newSelectedGoals) => {
      const goals = newSelectedGoals.map((goal) => ({
        TYPE: goal,
        CUSTOM_TYPE: void 0
      }));
      setValue("household.goals", goals);
      trigger(HELPER_FIELDS.CUSTOM_GOAL);
    },
    [setValue, trigger]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime75.jsx)("div", { "data-testid": "goals", role: "region", "aria-labelledby": "goals-title", children: /* @__PURE__ */ (0, import_jsx_runtime75.jsxs)("div", { className: "flex flex-col gap-8", children: [
    /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
      MultiSelectIconGrid_default,
      {
        options: GOALS_OPTIONS_WITH_ICONS,
        onChange: handleSelectGoal,
        value: selectedGoalTypes
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
      import_core47.TextInput,
      {
        label: "Other",
        error: (_a = errors[HELPER_FIELDS.CUSTOM_GOAL]) == null ? void 0 : _a.message,
        ...register(HELPER_FIELDS.CUSTOM_GOAL)
      }
    )
  ] }) });
};
var Goals_default = React38.memo(Goals);

// src/modules/money-guide-pro/components/AdditionalIncomeList/AdditionalIncomeList.tsx
var React39 = __toESM(require("react"));
var import_react_hook_form25 = require("react-hook-form");
var import_jsx_runtime76 = require("react/jsx-runtime");
var AdditionalIncomeList = ({
  navigateTo,
  additionalIncomeFields,
  removeAdditionalIncome,
  onEditClick
}) => {
  const handleAddClick = () => {
    navigateTo("ADDITIONAL_INCOME_FORM");
  };
  const [removeItemIndex, setRemoveItemIndex] = React39.useState(
    null
  );
  const onCloseRemoveDialog = () => setRemoveItemIndex(null);
  const onRemove = () => {
    removeAdditionalIncome(removeItemIndex);
    onCloseRemoveDialog();
  };
  const { watch } = (0, import_react_hook_form25.useFormContext)();
  const coClient = watch("coClient");
  const hasCoClient = !!(coClient == null ? void 0 : coClient.FIRST_NAME);
  const totalMonthlyIncome = React39.useMemo(
    () => additionalIncomeFields.reduce(
      (total, field) => total + Number(
        field["MONTHLY_INCOME" /* MONTHLY_INCOME */].replace(
          /[^\d.]/g,
          ""
        )
      ),
      0
    ),
    [additionalIncomeFields]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)("div", { "data-testid": "additional-income", children: [
    /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)("div", { className: "flex flex-col gap-8", children: [
      /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(AddButton_default, { label: "Add Additional Income", onClick: handleAddClick }),
      /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)("div", { children: [
        additionalIncomeFields.map((field, index) => /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)(
          UserSummary_default,
          {
            title: getReviewListValue(
              ADDITIONAL_INCOME_SOURCE_OPTIONS,
              field["INCOME_SOURCE" /* INCOME_SOURCE */]
            ),
            subtitle: formatters.currency(
              field["MONTHLY_INCOME" /* MONTHLY_INCOME */]
            ),
            onEditClick: () => onEditClick(index),
            onRemoveClick: () => setRemoveItemIndex(index),
            children: [
              hasCoClient && /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
                ReviewList_default,
                {
                  label: "Client Name",
                  value: formatters.string(
                    field["OWNER_NAME" /* OWNER_NAME */]
                  )
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
                ReviewList_default,
                {
                  label: "Income Source",
                  value: formatters.string(
                    getReviewListValue(
                      ADDITIONAL_INCOME_SOURCE_OPTIONS,
                      field["INCOME_SOURCE" /* INCOME_SOURCE */]
                    )
                  )
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
                ReviewList_default,
                {
                  label: "Monthly Income",
                  value: formatters.currency(
                    field["MONTHLY_INCOME" /* MONTHLY_INCOME */]
                  )
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
                ReviewList_default,
                {
                  label: "Income source description",
                  value: formatters.string(
                    field["DESCRIPTION" /* DESCRIPTION */]
                  )
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
                ReviewList_default,
                {
                  label: "Start Year",
                  value: formatters.string(
                    field["START_YEAR" /* START_YEAR */]
                  )
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
                ReviewList_default,
                {
                  label: "End Year",
                  value: formatters.string(
                    field["END_YEAR" /* END_YEAR */]
                  )
                }
              )
            ]
          },
          field.id
        )),
        additionalIncomeFields.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
          ListFooterTotals_default,
          {
            totalAmount: totalMonthlyIncome,
            label: "Total Monthly Income"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
      ListItemRemoveDialog_default,
      {
        isOpen: removeItemIndex !== null,
        onClose: onCloseRemoveDialog,
        onRemove
      }
    )
  ] });
};
var AdditionalIncomeList_default = AdditionalIncomeList;

// src/modules/money-guide-pro/components/AdditionalIncomeForm/AdditionalIncomeForm.tsx
var import_core48 = require("@earned/core");
var React40 = __toESM(require("react"));
var import_classnames6 = __toESM(require("classnames"));
var import_core49 = require("@earned/core");
var import_react_hook_form26 = require("react-hook-form");
var import_yup8 = require("@hookform/resolvers/yup");
var import_react_hook_form27 = require("react-hook-form");
var import_jsx_runtime77 = require("react/jsx-runtime");
var AdditionalIncomeForm = ({
  clients,
  editValues,
  editIndex,
  update,
  append
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const methods = (0, import_react_hook_form27.useForm)({
    values: editValues ? MGP_ADITIONAL_RET_INCOME_SCHEMA.cast(editValues) : MGP_ADITIONAL_RET_INCOME_SCHEMA.getDefault(),
    mode: "onTouched",
    resolver: (0, import_yup8.yupResolver)(MGP_ADITIONAL_RET_INCOME_SCHEMA)
  });
  const {
    register,
    formState: { errors },
    setValue,
    handleSubmit,
    watch
  } = methods;
  const { watch: watchForm } = (0, import_react_hook_form26.useFormContext)();
  const coClient = watchForm("coClient");
  const hasCoClient = !!(coClient == null ? void 0 : coClient.FIRST_NAME);
  const clientNameOptions = React40.useMemo(() => {
    const options = clients.map((client) => ({
      label: `${client.firstName} ${client.lastName}`,
      value: `${client.firstName} ${client.lastName}`,
      id: client.id
    }));
    if (hasCoClient) {
      options.push({
        label: "Both Clients",
        value: "Both Clients",
        id: "Both Clients"
      });
    }
    return options;
  }, [clients, hasCoClient]);
  const selectedClientId = watch("OWNER_NAME" /* OWNER_NAME */);
  const selectedClient = React40.useMemo(
    () => clientNameOptions.find((option) => option.value === selectedClientId) || NO_SELECTION_OPTION,
    [clientNameOptions, selectedClientId]
  );
  const selectedIncomeSource = watch("INCOME_SOURCE" /* INCOME_SOURCE */);
  const selectedIncomeSourceOption = React40.useMemo(
    () => ADDITIONAL_INCOME_SOURCE_OPTIONS.find(
      (option) => option.value === selectedIncomeSource
    ) || NO_SELECTION_OPTION,
    [selectedIncomeSource]
  );
  const { registerBeforeNavigate, unregisterBeforeNavigate } = useNavigationContext();
  React40.useEffect(() => {
    const beforeNavigate = async () => {
      return new Promise(
        (accept) => handleSubmit(
          async (values) => {
            if (editIndex !== void 0) {
              update(editIndex, values);
            } else {
              append(values);
            }
            accept(true);
          },
          () => accept(false)
        )()
      );
    };
    registerBeforeNavigate(beforeNavigate);
    return () => unregisterBeforeNavigate();
  }, [
    registerBeforeNavigate,
    unregisterBeforeNavigate,
    update,
    handleSubmit,
    editIndex,
    editValues,
    append,
    selectedClientId
  ]);
  React40.useEffect(() => {
    if (!selectedClientId && !hasCoClient) {
      setValue(
        "OWNER_NAME" /* OWNER_NAME */,
        clientNameOptions[0].value
      );
    }
  }, [selectedClientId, clientNameOptions, setValue, hasCoClient]);
  return /* @__PURE__ */ (0, import_jsx_runtime77.jsx)("div", { "data-testid": "additional-income-form", children: /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
      "div",
      {
        className: (0, import_classnames6.default)(!hasCoClient && "invisible m-0 h-0 overflow-hidden"),
        children: /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
          import_core49.SelectBox,
          {
            label: "Client Name",
            error: (_a = errors == null ? void 0 : errors["OWNER_NAME" /* OWNER_NAME */]) == null ? void 0 : _a.message,
            options: [NO_SELECTION_OPTION, ...clientNameOptions],
            selected: selectedClient,
            onChange: (selected) => {
              setValue(
                "OWNER_NAME" /* OWNER_NAME */,
                selected.value
              );
            }
          }
        )
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)("div", { className: "flex flex-col sm:flex-row sm:gap-4", children: [
      /* @__PURE__ */ (0, import_jsx_runtime77.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
        import_core49.SelectBox,
        {
          label: "Income Source",
          error: (_b = errors == null ? void 0 : errors["INCOME_SOURCE" /* INCOME_SOURCE */]) == null ? void 0 : _b.message,
          options: ADDITIONAL_INCOME_SOURCE_OPTIONS,
          selected: selectedIncomeSourceOption,
          onChange: (selected) => {
            setValue(
              "INCOME_SOURCE" /* INCOME_SOURCE */,
              selected.value ?? "",
              { shouldValidate: true }
            );
          }
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime77.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
        import_core48.TextInput,
        {
          label: "Monthly Income",
          type: "currency",
          error: (_c = errors == null ? void 0 : errors["MONTHLY_INCOME" /* MONTHLY_INCOME */]) == null ? void 0 : _c.message,
          ...register("MONTHLY_INCOME" /* MONTHLY_INCOME */)
        }
      ) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
      import_core48.TextInput,
      {
        label: "Describe income source",
        error: (_d = errors == null ? void 0 : errors["DESCRIPTION" /* DESCRIPTION */]) == null ? void 0 : _d.message,
        ...register("DESCRIPTION" /* DESCRIPTION */)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)("div", { className: "flex flex-col sm:flex-row sm:gap-4", children: [
      /* @__PURE__ */ (0, import_jsx_runtime77.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
        import_core48.TextInput,
        {
          label: "Start Year",
          type: "number",
          error: (_e = errors == null ? void 0 : errors["START_YEAR" /* START_YEAR */]) == null ? void 0 : _e.message,
          ...register("START_YEAR" /* START_YEAR */)
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime77.jsx)("div", { className: "sm:w-[50%]", children: /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
        import_core48.TextInput,
        {
          label: "End Year",
          type: "number",
          error: (_f = errors == null ? void 0 : errors["END_YEAR" /* END_YEAR */]) == null ? void 0 : _f.message,
          ...register("END_YEAR" /* END_YEAR */),
          helperText: "optional",
          helperTextPosition: "top"
        }
      ) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
      import_core48.Checkbox,
      {
        label: "Check if amount will increase due to inflation",
        ...register("ADJUST_FOR_INFLATION" /* ADJUST_FOR_INFLATION */),
        error: (_g = errors == null ? void 0 : errors["ADJUST_FOR_INFLATION" /* ADJUST_FOR_INFLATION */]) == null ? void 0 : _g.message
      }
    )
  ] }) });
};
var AdditionalIncomeForm_default = AdditionalIncomeForm;

// src/modules/money-guide-pro/components/Review/Review.tsx
var import_core50 = require("@earned/core");
var React42 = __toESM(require("react"));
var import_react_hook_form30 = require("react-hook-form");
var import_lodash6 = require("lodash");

// src/modules/money-guide-pro/components/EmploymentReviewItem/EmploymentReviewItem.tsx
var import_react_hook_form28 = require("react-hook-form");
var import_jsx_runtime78 = require("react/jsx-runtime");
var EmploymentReviewItem = ({
  employment,
  hasCoClient
}) => {
  const { getValues } = (0, import_react_hook_form28.useFormContext)();
  const { client } = getValues();
  return /* @__PURE__ */ (0, import_jsx_runtime78.jsxs)("div", { "data-testid": "employment-review-item", children: [
    !hasCoClient && /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
      ReviewList_default,
      {
        label: "Client Name",
        value: formatters.string(`${client.FIRST_NAME} ${client.LAST_NAME}`)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(ReviewList_default, { label: "Title", value: formatters.string(employment.TITLE) }),
    /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
      ReviewList_default,
      {
        label: "Employer Name",
        value: formatters.string(employment.EMPLOYER_NAME)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
      ReviewList_default,
      {
        label: "Employment Income",
        value: formatters.currency(employment.ANNUAL_INCOME)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
      ReviewList_default,
      {
        label: "Employment Type",
        value: formatters.string(
          employment.TYPE === EMPLOYMENT_TYPE.OTHER ? getReviewListValue(EMPLOYMENT_TYPE_OPTIONS, employment.OTHER_TYPE) : getReviewListValue(EMPLOYMENT_TYPE_OPTIONS, employment.TYPE)
        )
      }
    )
  ] });
};
var EmploymentReviewItem_default = EmploymentReviewItem;

// src/modules/money-guide-pro/components/CareerChangeReviewItem/CareerChangeReviewItem.tsx
var React41 = __toESM(require("react"));
var import_react_hook_form29 = require("react-hook-form");
var import_jsx_runtime79 = require("react/jsx-runtime");
var CareerChangeReviewItem = ({
  careerChange,
  isCoClient = false
}) => {
  const { getValues } = (0, import_react_hook_form29.useFormContext)();
  const { client, coClient } = getValues();
  const careerChangeData = React41.useMemo(() => {
    const source = isCoClient ? coClient : client;
    const option = CAREER_CHANGE_OPTIONS.find(
      (option2) => option2.value === careerChange
    );
    const label = option.value !== "OTHER" ? option.label : "Other";
    const value = option.value !== "OTHER" ? source[option.inputKey] : source["CAREER_CHANGE_OTHER" /* CAREER_CHANGE_OTHER */];
    return { label, value };
  }, [careerChange, isCoClient, client, coClient]);
  return /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("div", { "data-testid": "career-change-review-item", children: /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
    ReviewList_default,
    {
      label: careerChangeData.label,
      value: careerChangeData.value
    }
  ) });
};
var CareerChangeReviewItem_default = CareerChangeReviewItem;

// src/modules/money-guide-pro/components/Review/Review.tsx
var import_jsx_runtime80 = require("react/jsx-runtime");
var Review = ({ clients, onEditClick }) => {
  const { getValues } = (0, import_react_hook_form30.useFormContext)();
  const { client, coClient, household, CUSTOM_GOAL } = getValues();
  const hasCoClient = coClient.FIRST_NAME !== void 0;
  const employments = React42.useMemo(
    () => (0, import_lodash6.groupBy)(household.employments, (employment) => employment.CLIENT_ID),
    [household.employments]
  );
  const clientId = React42.useMemo(
    () => {
      var _a;
      return ((_a = clients.find(
        (c) => c.firstName === client.FIRST_NAME && c.lastName === client.LAST_NAME
      )) == null ? void 0 : _a.id) ?? "";
    },
    [client, clients]
  );
  const coClientId = React42.useMemo(
    () => {
      var _a;
      return ((_a = clients.find(
        (c) => c.firstName === coClient.FIRST_NAME && c.lastName === coClient.LAST_NAME
      )) == null ? void 0 : _a.id) ?? "";
    },
    [coClient, clients]
  );
  const clientEmployments = employments[clientId];
  const coClientEmployments = employments[coClientId];
  return /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)("div", { "data-testid": "review", children: [
    /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewSubheader_default, { label: "Information" }),
    hasCoClient ? /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_jsx_runtime80.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: `${client.FIRST_NAME} ${client.LAST_NAME} Annual Income`,
          value: formatters.currency(client.ANNUAL_INCOME)
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: `${coClient.FIRST_NAME} ${coClient.LAST_NAME} Annual Income`,
          value: formatters.currency(coClient.ANNUAL_INCOME)
        }
      )
    ] }) : /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(import_jsx_runtime80.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
      ReviewList_default,
      {
        label: "Annual Income",
        value: formatters.currency(client.ANNUAL_INCOME)
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewEditLink_default, { onClick: () => onEditClick("ANNUAL_INCOME") }),
    /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(ReviewBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewSubheader_default, { label: "Important Relationships" }),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)("div", { className: "flex flex-col gap-6", children: household.importantRelationships.map((relationship, index) => /* @__PURE__ */ (0, import_jsx_runtime80.jsx)("div", { className: "flex flex-col", children: relationship !== void 0 && (relationship == null ? void 0 : relationship.TYPE) === IMPORTANT_RELATIONSHIP_TYPE.PERSON ? /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_jsx_runtime80.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Name",
            value: formatters.string(
              `${relationship.FIRST_NAME} ${relationship.LAST_NAME}`
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Relationship",
            value: formatters.string(
              getReviewListValue(
                IMPORTANT_RELATIONSHIPS_PERSON_RELATIONSHIP_OPTIONS,
                relationship.RELATIONSHIP
              )
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Date of Birth",
            value: formatters.string(
              transformers.form.date(relationship.DOB)
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Dependent Status",
            value: formatters.string(
              getReviewListValue(
                IMPORTANT_RELATIONSHIP_BASE_DEPENDENT_STATUS_OPTIONS,
                relationship.DEPENDENT_STATUS
              )
            )
          }
        )
      ] }) : /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_jsx_runtime80.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Organization Name",
            value: formatters.string(relationship == null ? void 0 : relationship.NAME)
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Organization Type",
            value: formatters.string(
              getReviewListValue(
                IMPORTANT_RELATIONSHIP_ORGANIZATION_TYPE_OPTIONS,
                relationship == null ? void 0 : relationship.ORGANIZATION_TYPE
              )
            )
          }
        )
      ] }) }, index)) }),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewEditLink_default,
        {
          onClick: () => onEditClick("IMPORTANT_RELATIONSHIPS")
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(ReviewBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewSubheader_default, { label: "Employment" }),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)("div", { className: "flex flex-col gap-6", children: [
        clientEmployments && /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_jsx_runtime80.Fragment, { children: [
          hasCoClient && /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(import_core50.Typography, { variant: "body-lg", weight: "medium", className: "pb-1", children: `${client.FIRST_NAME} ${client.LAST_NAME}` }),
          clientEmployments.map((employment, index) => /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
            EmploymentReviewItem_default,
            {
              employment,
              hasCoClient
            },
            index
          ))
        ] }),
        coClientEmployments && /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_jsx_runtime80.Fragment, { children: [
          hasCoClient ? /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(import_core50.Typography, { variant: "body-lg", weight: "medium", className: "pb-1", children: `${coClient.FIRST_NAME} ${coClient.LAST_NAME}` }) : null,
          coClientEmployments.map((employment, index) => /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
            EmploymentReviewItem_default,
            {
              employment,
              hasCoClient
            },
            index
          ))
        ] })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewEditLink_default, { onClick: () => onEditClick("EMPLOYMENT") })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(ReviewBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewSubheader_default, { label: "Career Change" }),
      client.CAREER_CHANGE.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_jsx_runtime80.Fragment, { children: [
        hasCoClient && /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(import_core50.Typography, { variant: "body-lg", weight: "medium", className: "pb-1", children: `${client.FIRST_NAME} ${client.LAST_NAME}` }),
        client.CAREER_CHANGE.map((careerChange, index) => /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(CareerChangeReviewItem_default, { careerChange }, index))
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewEditLink_default, { onClick: () => onEditClick("CAREER_CHANGE") }),
      coClient.CAREER_CHANGE.length > 0 && /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_jsx_runtime80.Fragment, { children: [
        hasCoClient && /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(import_core50.Typography, { variant: "body-lg", weight: "medium", className: "pb-1", children: `${coClient.FIRST_NAME} ${coClient.LAST_NAME}` }),
        coClient.CAREER_CHANGE.map((careerChange, index) => /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          CareerChangeReviewItem_default,
          {
            careerChange,
            isCoClient: true
          },
          index
        )),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewEditLink_default,
          {
            onClick: () => onEditClick("CAREER_CHANGE_CO_CLIENT")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(ReviewBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewSubheader_default, { label: "Additional Income" }),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)("div", { className: "flex flex-col gap-6", children: household.retirementIncomes.map((income, index) => /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)("div", { className: "flex flex-col", children: [
        income.OWNER_NAME && /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Client Name",
            value: formatters.string(income.OWNER_NAME)
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Income Source",
            value: formatters.string(
              getReviewListValue(
                ADDITIONAL_INCOME_SOURCE_OPTIONS,
                income.INCOME_SOURCE
              )
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Income Source Description",
            value: formatters.string(income.DESCRIPTION)
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Monthly Income",
            value: formatters.currency(income.MONTHLY_INCOME)
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Start Year",
            value: formatters.string(income.START_YEAR)
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "End Year",
            value: formatters.string(income.END_YEAR)
          }
        )
      ] }, index)) }),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewEditLink_default, { onClick: () => onEditClick("ADDITIONAL_INCOME") })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(ReviewBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewSubheader_default, { label: "Goals" }),
      household.goals.map((goal, index) => /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: "Goal",
          value: formatters.string(
            getReviewListValue(GOALS_OPTIONS, goal.TYPE)
          )
        },
        index
      )),
      CUSTOM_GOAL && /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: "Goal",
          value: `Other (${formatters.string(CUSTOM_GOAL)})`
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewEditLink_default, { onClick: () => onEditClick("GOALS") })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(ReviewBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewSubheader_default, { label: "Current and Retirement Expenses" }),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: "Current Monthly Living Expense Amount",
          value: formatters.currency(household.CURRENT_MONTHLY_LIVING_EXPENSES)
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: "Monthly Living Expense at Retirement",
          value: formatters.currency(
            household.RETIREMENT_MONTHLY_LIVING_EXPENSES
          )
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewEditLink_default, { onClick: () => onEditClick("RETIREMENT_EXPENSES") })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(ReviewBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewSubheader_default, { label: "Retirement Age" }),
      hasCoClient && /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(import_core50.Typography, { variant: "body-lg", weight: "medium", className: "pb-1", children: `${client.FIRST_NAME} ${client.LAST_NAME}` }),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: "Target Retirement Age",
          value: formatters.string(client.TARGET_RETIREMENT_AGE)
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: "How willing are you to retire later?",
          value: formatters.string(
            getReviewListValue(
              WILLING_TO_RETIRE_LATER_OPTIONS,
              client.WILLING_TO_RETIRE_LATER
            )
          )
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: "Are you considering part-time work before full retirement?",
          value: formatters.string(
            getReviewListValue(
              CONSIDER_PART_TIME_RETIREMENT_OPTIONS,
              client.CONSIDER_PART_TIME_RETIREMENT
            )
          )
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewEditLink_default, { onClick: () => onEditClick("RETIREMENT_AGE") }),
      hasCoClient && /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_jsx_runtime80.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(import_core50.Typography, { variant: "body-lg", weight: "medium", className: "pb-1", children: `${coClient.FIRST_NAME} ${coClient.LAST_NAME}` }),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Target Retirement Age",
            value: formatters.string(coClient.TARGET_RETIREMENT_AGE)
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "How willing are you to retire later?",
            value: formatters.string(
              getReviewListValue(
                WILLING_TO_RETIRE_LATER_OPTIONS,
                coClient.WILLING_TO_RETIRE_LATER
              )
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Are you considering part-time work before full retirement?",
            value: formatters.string(
              getReviewListValue(
                CONSIDER_PART_TIME_RETIREMENT_OPTIONS,
                coClient.CONSIDER_PART_TIME_RETIREMENT
              )
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewEditLink_default,
          {
            onClick: () => onEditClick("RETIREMENT_AGE_CO_CLIENT")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(ReviewBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewSubheader_default, { label: "Extra Savings" }),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: "Extra Yearly Savings",
          value: formatters.currency(
            household.WILLING_TO_SAVE_EXTRA_ANNUAL_AMOUNT
          )
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: "How willing are you to save more?",
          value: formatters.string(
            getReviewListValue(
              WILLING_TO_RETIRE_LATER_OPTIONS,
              household.WILLING_TO_SAVE_EXTRA
            )
          )
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewEditLink_default, { onClick: () => onEditClick("EXTRA_SAVINGS") })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(ReviewBlock_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(ReviewSubheader_default, { label: "Protection & Legacy Planning" }),
      hasCoClient && /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(import_core50.Typography, { variant: "body-lg", weight: "medium", className: "pb-1", children: `${client.FIRST_NAME} ${client.LAST_NAME}` }),
      client.CURRENT_INSURANCE_POLICIES.length > 0 && client.CURRENT_INSURANCE_POLICIES.map((policy, index) => /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: "Individual Insurance Policies",
          value: formatters.string(
            getReviewListValue(INSURANCE_POLICIES_OPTIONS, policy)
          )
        },
        index
      )),
      client.CURRENT_ESTATE_PLANNING.length > 0 && client.CURRENT_ESTATE_PLANNING.map((policy, index) => /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewList_default,
        {
          label: "Estate Planning",
          value: formatters.string(
            getReviewListValue(ESTATE_PLANNING_OPTIONS, policy)
          )
        },
        index
      )),
      /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
        ReviewEditLink_default,
        {
          onClick: () => onEditClick("PROTECTION_AND_LEGACY_PLANNING")
        }
      ),
      hasCoClient && /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)(import_jsx_runtime80.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(import_core50.Typography, { variant: "body-lg", weight: "medium", className: "pb-1", children: `${coClient.FIRST_NAME} ${coClient.LAST_NAME}` }),
        coClient.CURRENT_INSURANCE_POLICIES.length > 0 && coClient.CURRENT_INSURANCE_POLICIES.map((policy, index) => /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Individual Insurance Policies",
            value: formatters.string(
              getReviewListValue(INSURANCE_POLICIES_OPTIONS, policy)
            )
          },
          index
        )),
        coClient.CURRENT_ESTATE_PLANNING.length > 0 && coClient.CURRENT_ESTATE_PLANNING.map((policy, index) => /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewList_default,
          {
            label: "Estate Planning",
            value: formatters.string(
              getReviewListValue(ESTATE_PLANNING_OPTIONS, policy)
            )
          },
          index
        )),
        /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
          ReviewEditLink_default,
          {
            onClick: () => onEditClick("PROTECTION_AND_LEGACY_PLANNING_CO_CLIENT")
          }
        )
      ] })
    ] })
  ] });
};
var Review_default = Review;

// src/modules/money-guide-pro/components/RetirementAge/RetirementAge.tsx
var import_core51 = require("@earned/core");
var React43 = __toESM(require("react"));
var import_react_hook_form31 = require("react-hook-form");
var import_jsx_runtime81 = require("react/jsx-runtime");
var RetirementAge = ({
  isCoClientPage = false
}) => {
  var _a, _b, _c, _d, _e, _f;
  const {
    register,
    formState: { errors }
  } = (0, import_react_hook_form31.useFormContext)();
  const formKey = isCoClientPage ? "coClient" : "client";
  const contextKey = React43.useMemo(
    () => `retirement-age-${formKey}`,
    [formKey]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime81.jsxs)("div", { "data-testid": "retirement-age", children: [
    /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(
      import_core51.TextInput,
      {
        label: "Target Retirement Age",
        type: "number",
        ...register(`${formKey}.${"TARGET_RETIREMENT_AGE" /* TARGET_RETIREMENT_AGE */}`),
        error: (_b = (_a = errors == null ? void 0 : errors[formKey]) == null ? void 0 : _a["TARGET_RETIREMENT_AGE" /* TARGET_RETIREMENT_AGE */]) == null ? void 0 : _b.message,
        autoFocus: true
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(QuestionBlock_default, { label: "How willing are you to retire later?", children: /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(
      import_core51.RadioGroup,
      {
        ...register(`${formKey}.${"WILLING_TO_RETIRE_LATER" /* WILLING_TO_RETIRE_LATER */}`),
        error: (_d = (_c = errors == null ? void 0 : errors[formKey]) == null ? void 0 : _c["WILLING_TO_RETIRE_LATER" /* WILLING_TO_RETIRE_LATER */]) == null ? void 0 : _d.message,
        children: WILLING_TO_RETIRE_LATER_OPTIONS.map((option) => /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(
          import_core51.Radio,
          {
            label: option.label,
            value: option.value
          },
          option.value
        ))
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(QuestionBlock_default, { label: "Are you considering part-time work before full retirement?", children: /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(
      import_core51.RadioGroup,
      {
        ...register(
          `${formKey}.${"CONSIDER_PART_TIME_RETIREMENT" /* CONSIDER_PART_TIME_RETIREMENT */}`
        ),
        error: (_f = (_e = errors == null ? void 0 : errors[formKey]) == null ? void 0 : _e["CONSIDER_PART_TIME_RETIREMENT" /* CONSIDER_PART_TIME_RETIREMENT */]) == null ? void 0 : _f.message,
        children: CONSIDER_PART_TIME_RETIREMENT_OPTIONS.map((option) => /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(
          import_core51.Radio,
          {
            label: option.label,
            value: option.value
          },
          option.value
        ))
      }
    ) })
  ] }, contextKey);
};
var RetirementAge_default = RetirementAge;

// src/modules/money-guide-pro/components/MGPWizard/MGPWizard.tsx
var import_lodash7 = __toESM(require("lodash"));

// src/modules/money-guide-pro/components/ExtraSavings/ExtraSavings.tsx
var import_core52 = require("@earned/core");
var import_react_hook_form32 = require("react-hook-form");
var import_jsx_runtime82 = require("react/jsx-runtime");
var ExtraSavings = () => {
  var _a, _b, _c, _d;
  const {
    register,
    formState: { errors }
  } = (0, import_react_hook_form32.useFormContext)();
  return /* @__PURE__ */ (0, import_jsx_runtime82.jsxs)("div", { "data-testid": "extra-savings", children: [
    /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(
      import_core52.TextInput,
      {
        label: "Extra Annual Savings",
        type: "currency",
        ...register(
          `household.${"WILLING_TO_SAVE_EXTRA_ANNUAL_AMOUNT" /* WILLING_TO_SAVE_EXTRA_ANNUAL_AMOUNT */}`
        ),
        error: (_b = (_a = errors == null ? void 0 : errors["household"]) == null ? void 0 : _a["WILLING_TO_SAVE_EXTRA_ANNUAL_AMOUNT" /* WILLING_TO_SAVE_EXTRA_ANNUAL_AMOUNT */]) == null ? void 0 : _b.message
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(QuestionBlock_default, { label: "How willing are you to save more?", children: /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(
      import_core52.RadioGroup,
      {
        ...register(`household.${"WILLING_TO_SAVE_EXTRA" /* WILLING_TO_SAVE_EXTRA */}`),
        error: (_d = (_c = errors == null ? void 0 : errors["household"]) == null ? void 0 : _c["WILLING_TO_SAVE_EXTRA" /* WILLING_TO_SAVE_EXTRA */]) == null ? void 0 : _d.message,
        children: WILLING_TO_RETIRE_LATER_OPTIONS.map((option) => /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(
          import_core52.Radio,
          {
            label: option.label,
            value: option.value
          },
          option.value
        ))
      }
    ) })
  ] });
};
var ExtraSavings_default = ExtraSavings;

// src/modules/money-guide-pro/components/ProtectionAndLegacyPlanning/ProtectionAndLegacyPlanning.tsx
var import_core53 = require("@earned/core");
var React44 = __toESM(require("react"));
var import_react_hook_form33 = require("react-hook-form");
var import_jsx_runtime83 = require("react/jsx-runtime");
var ProtectionAndLegacyPlanning = ({ isCoClientPage = false }) => {
  var _a, _b, _c, _d;
  const {
    register,
    formState: { errors }
  } = (0, import_react_hook_form33.useFormContext)();
  const formKey = isCoClientPage ? "coClient" : "client";
  const contextKey = React44.useMemo(() => `career-change-${formKey}`, [formKey]);
  return /* @__PURE__ */ (0, import_jsx_runtime83.jsx)("div", { "data-testid": "protection-and-legacy-planning", children: /* @__PURE__ */ (0, import_jsx_runtime83.jsxs)("div", { className: "flex flex-col gap-6", children: [
    /* @__PURE__ */ (0, import_jsx_runtime83.jsxs)("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(import_core53.Typography, { variant: "body-lg", weight: "medium", children: "Individual Insurance Policies" }),
      /* @__PURE__ */ (0, import_jsx_runtime83.jsx)("div", { className: "pl-4", children: /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(
        import_core53.CheckboxGroup,
        {
          ...register(
            `${formKey}.${"CURRENT_INSURANCE_POLICIES" /* CURRENT_INSURANCE_POLICIES */}`
          ),
          error: (_b = (_a = errors[formKey]) == null ? void 0 : _a[`${"CURRENT_INSURANCE_POLICIES" /* CURRENT_INSURANCE_POLICIES */}`]) == null ? void 0 : _b.message,
          children: INSURANCE_POLICIES_OPTIONS.map((option) => /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(
            import_core53.Checkbox,
            {
              label: option.label,
              value: option.value
            },
            `${contextKey}-${option.value}`
          ))
        },
        contextKey
      ) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime83.jsxs)("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(import_core53.Typography, { variant: "body-lg", weight: "medium", children: "Estate Planning" }),
      /* @__PURE__ */ (0, import_jsx_runtime83.jsx)("div", { className: "pl-4", children: /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(
        import_core53.CheckboxGroup,
        {
          ...register(
            `${formKey}.${"CURRENT_ESTATE_PLANNING" /* CURRENT_ESTATE_PLANNING */}`
          ),
          error: (_d = (_c = errors[formKey]) == null ? void 0 : _c[`${"CURRENT_ESTATE_PLANNING" /* CURRENT_ESTATE_PLANNING */}`]) == null ? void 0 : _d.message,
          children: ESTATE_PLANNING_OPTIONS.map((option) => /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(
            import_core53.Checkbox,
            {
              label: option.label,
              value: option.value
            },
            `${contextKey}-${option.value}`
          ))
        },
        contextKey
      ) })
    ] })
  ] }) });
};
var ProtectionAndLegacyPlanning_default = ProtectionAndLegacyPlanning;

// src/modules/money-guide-pro/components/MGPWizard/MGPWizard.tsx
var import_jsx_runtime84 = require("react/jsx-runtime");
var MGPWizard = ({
  isOpen,
  close,
  modalRootSelector = "body",
  initialNavHistory,
  cache,
  isLoading,
  isSubmitting = false,
  onSubmit,
  onDone,
  isSuccess,
  onPageChange,
  onFieldChange
}) => {
  const stateMachineConfig = React45.useMemo(
    () => ({
      ...MGP_STATE_MACHINE_CONFIG,
      initialNavHistory
    }),
    [initialNavHistory]
  );
  const [isReviewing, setIsReviewing] = React45.useState(false);
  const [reviewHistory, setReviewHistory] = React45.useState([]);
  const {
    curStepName,
    isFirstStep,
    isFinalStep,
    navigateTo,
    goNext,
    goBack,
    getFormProgress,
    navHistory,
    registerBeforeNavigate,
    unregisterBeforeNavigate,
    updateNavHistory
  } = useStateMachineWizard(stateMachineConfig);
  const methods = (0, import_react_hook_form34.useForm)({
    values: cache ? MGP_FORM_SCHEMA.cast(extractCustomGoal(cache)) : MGP_FORM_SCHEMA.getDefault(),
    mode: "onTouched",
    resolver: (0, import_yup9.yupResolver)(MGP_FORM_SCHEMA)
  });
  const { getValues, handleSubmit: submit, trigger, control, watch } = methods;
  const fieldValues = getValues();
  const progress = getFormProgress(fieldValues);
  React45.useEffect(() => {
    const subscription = watch((...[values, field]) => {
      var _a;
      if (!onFieldChange)
        return;
      const value = import_lodash7.default.get(values, field.name);
      const schema = import_lodash7.default.get(
        MGP_PAYLOAD_SCHEMA.fields,
        ((_a = field.name) == null ? void 0 : _a.split(".").join(".fields.")) ?? ""
      );
      trigger(field.name).then((valid) => {
        if (schema && valid) {
          onFieldChange({
            key: field.name,
            field: schema.cast(value)
          });
        }
      });
    });
    return () => subscription.unsubscribe();
  }, [watch, onFieldChange, trigger]);
  const nextLabel = React45.useMemo(
    () => isFinalStep ? "Submit" : "Next",
    [isFinalStep]
  );
  const handleSubmit = (fields) => {
    onSubmit(MGP_PAYLOAD_SCHEMA.cast(restoreCustomGoal(fields)));
  };
  const handleNext = React45.useCallback(() => {
    trigger(
      MGP_PAGE_VALIDATION_MAP[curStepName]
    ).then((valid) => {
      if (valid)
        goNext(getValues());
    });
  }, [trigger, curStepName, goNext, getValues]);
  const handleReturnToReview = React45.useCallback(async () => {
    const isValid = await trigger(
      MGP_PAGE_VALIDATION_MAP[curStepName]
    );
    if (isValid) {
      setIsReviewing(false);
      updateNavHistory(reviewHistory);
      setReviewHistory([]);
    }
  }, [trigger, curStepName, reviewHistory, updateNavHistory]);
  React45.useEffect(() => {
    if (isReviewing && curStepName === "REVIEW") {
      setIsReviewing(false);
      setReviewHistory([]);
    }
  }, [isReviewing, curStepName]);
  const handleEditFromReview = React45.useCallback(
    (page) => {
      setIsReviewing(true);
      setReviewHistory([...navHistory]);
      navigateTo(page);
    },
    [navHistory, navigateTo]
  );
  const {
    importantRelationshipsFields,
    removeImportantRelationship,
    selectedImportantRelationship,
    updateImportantRelationship,
    appendImportantRelationship,
    setSelectedImportantRelationship
  } = useImportantRelationshipsList({ control });
  const onEditImportantRelationship = React45.useCallback(
    (index) => {
      setSelectedImportantRelationship(index);
      if (importantRelationshipsFields[index]["TYPE" /* TYPE */] === IMPORTANT_RELATIONSHIP_TYPE.PERSON) {
        navigateTo("IMPORTANT_RELATIONSHIPS_PERSON_FORM");
      } else {
        navigateTo("IMPORTANT_RELATIONSHIPS_ORGANIZATION_FORM");
      }
    },
    [setSelectedImportantRelationship, navigateTo, importantRelationshipsFields]
  );
  const importantRelationshipValues = React45.useMemo(
    () => selectedImportantRelationship !== void 0 ? importantRelationshipsFields[selectedImportantRelationship] : void 0,
    [selectedImportantRelationship, importantRelationshipsFields]
  );
  const importantRelationshipType = React45.useMemo(
    () => importantRelationshipValues && importantRelationshipValues["TYPE" /* TYPE */],
    [importantRelationshipValues]
  );
  const {
    employmentsFields,
    appendEmployments,
    removeEmployments,
    updateEmployments,
    selectedEmployment,
    setSelectedEmployment
  } = useEmploymentsList({ control });
  const selectedEmploymentValues = React45.useMemo(() => {
    return selectedEmployment !== void 0 ? employmentsFields[selectedEmployment] : void 0;
  }, [employmentsFields, selectedEmployment]);
  const onEditEmployment = React45.useCallback(
    (index) => {
      setSelectedEmployment(index);
      navigateTo("EMPLOYMENT_FORM");
    },
    [setSelectedEmployment, navigateTo]
  );
  const {
    additionalIncomeFields,
    appendAdditionalIncome,
    removeAdditionalIncome,
    updateAdditionalIncome,
    selectedAdditionalIncome,
    setSelectedAdditionalIncome
  } = useAdditionalIncomeList({ control });
  const onEditAdditionalIncome = React45.useCallback(
    (index) => {
      setSelectedAdditionalIncome(index);
      navigateTo("ADDITIONAL_INCOME_FORM");
    },
    [setSelectedAdditionalIncome, navigateTo]
  );
  const selectedAdditionalIncomeValues = React45.useMemo(() => {
    return selectedAdditionalIncome !== void 0 ? additionalIncomeFields[selectedAdditionalIncome] : void 0;
  }, [additionalIncomeFields, selectedAdditionalIncome]);
  React45.useEffect(() => {
    if (onPageChange)
      onPageChange(curStepName, navHistory);
  }, [curStepName, onPageChange, navHistory]);
  const clients = useClients(fieldValues);
  const renderPages = React45.useCallback(() => {
    switch (curStepName) {
      case "INTRO":
        return null;
      case "ADDITIONAL_INCOME":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
          AdditionalIncomeList_default,
          {
            navigateTo,
            additionalIncomeFields,
            removeAdditionalIncome,
            onEditClick: onEditAdditionalIncome
          }
        );
      case "ADDITIONAL_INCOME_FORM":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
          AdditionalIncomeForm_default,
          {
            clients,
            update: updateAdditionalIncome,
            append: appendAdditionalIncome,
            editValues: selectedAdditionalIncomeValues,
            editIndex: selectedAdditionalIncome
          }
        );
      case "GOALS":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(Goals_default, {});
      case "ANNUAL_INCOME":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(AnnualIncome_default, {});
      case "EMPLOYMENT":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
          Employment_default,
          {
            navigateTo,
            employmentsFields,
            removeEmployment: removeEmployments,
            onEditClick: onEditEmployment,
            clients
          }
        );
      case "EMPLOYMENT_FORM":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
          EmploymentForm_default,
          {
            clients,
            update: updateEmployments,
            append: appendEmployments,
            editValues: selectedEmploymentValues,
            editIndex: selectedEmployment
          }
        );
      case "RETIREMENT_EXPENSES":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(RetirementExpenses_default, {});
      case "CAREER_CHANGE":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(CareerChange_default, {});
      case "CAREER_CHANGE_CO_CLIENT":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(CareerChange_default, { isCoClientPage: true });
      case "IMPORTANT_RELATIONSHIPS":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
          ImportantRelationshipsList_default,
          {
            navigateTo,
            removeImportantRelationship,
            importantRelationshipsFields,
            onEditClick: onEditImportantRelationship
          }
        );
      case "IMPORTANT_RELATIONSHIPS_SELECT":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(ImportantRelationshipsSelect_default, {});
      case "IMPORTANT_RELATIONSHIPS_PERSON_FORM":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
          ImportantRelationshipsPersonForm_default,
          {
            clients,
            update: updateImportantRelationship,
            append: appendImportantRelationship,
            editIndex: selectedImportantRelationship,
            editValues: importantRelationshipType === IMPORTANT_RELATIONSHIP_TYPE.PERSON ? importantRelationshipValues : void 0
          }
        );
      case "IMPORTANT_RELATIONSHIPS_ORGANIZATION_FORM":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
          ImportantRelationshipsOrganizationForm_default,
          {
            update: updateImportantRelationship,
            append: appendImportantRelationship,
            editIndex: selectedImportantRelationship,
            editValues: importantRelationshipType === IMPORTANT_RELATIONSHIP_TYPE.ORGANIZATION ? importantRelationshipValues : void 0
          }
        );
      case "REVIEW":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(Review_default, { clients, onEditClick: handleEditFromReview });
      case "RETIREMENT_AGE":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(RetirementAge_default, {});
      case "RETIREMENT_AGE_CO_CLIENT":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(RetirementAge_default, { isCoClientPage: true });
      case "EXTRA_SAVINGS":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(ExtraSavings_default, {});
      case "PROTECTION_AND_LEGACY_PLANNING":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(ProtectionAndLegacyPlanning_default, {});
      case "PROTECTION_AND_LEGACY_PLANNING_CO_CLIENT":
        return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(ProtectionAndLegacyPlanning_default, { isCoClientPage: true });
    }
  }, [
    curStepName,
    navigateTo,
    additionalIncomeFields,
    removeAdditionalIncome,
    onEditAdditionalIncome,
    clients,
    updateAdditionalIncome,
    appendAdditionalIncome,
    selectedAdditionalIncomeValues,
    selectedAdditionalIncome,
    employmentsFields,
    removeEmployments,
    onEditEmployment,
    updateEmployments,
    appendEmployments,
    selectedEmploymentValues,
    selectedEmployment,
    removeImportantRelationship,
    importantRelationshipsFields,
    onEditImportantRelationship,
    updateImportantRelationship,
    appendImportantRelationship,
    selectedImportantRelationship,
    importantRelationshipType,
    importantRelationshipValues,
    handleEditFromReview
  ]);
  const showReturnToReview = React45.useMemo(
    () => isReviewing && !LIST_FORM_PAGES.includes(curStepName),
    [isReviewing, curStepName]
  );
  const pageTitle = React45.useMemo(
    () => {
      var _a;
      return (_a = stateMachineConfig.steps[curStepName]) == null ? void 0 : _a.stepTitle;
    },
    [curStepName, stateMachineConfig]
  );
  const pageSubtitle = React45.useMemo(() => {
    var _a;
    const subtitle = (_a = stateMachineConfig.steps[curStepName]) == null ? void 0 : _a.stepSubtitle;
    if (typeof subtitle === "function") {
      return subtitle(fieldValues);
    }
    return subtitle ?? "";
  }, [curStepName, stateMachineConfig, fieldValues]);
  const titleTag = useTitleTag(fieldValues, curStepName);
  return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)("div", { "data-testid": "mgp-wizard", children: /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
    NavigationContext.Provider,
    {
      value: { registerBeforeNavigate, unregisterBeforeNavigate },
      children: /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
        Modal_default,
        {
          title: "Onboarding Questionnaire",
          pageTitle,
          subtitle: pageSubtitle,
          titleTag,
          open: isOpen,
          close,
          progressPercentage: isLoading ? 0 : progress,
          showProgressBar: true,
          rootSelector: modalRootSelector,
          showConfirmation: isSuccess,
          renderConfirmation: () => /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(SuccessPanel_default, { onDone }),
          children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime84.jsx)("div", { className: "flex flex-row justify-center", children: /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(LoadingIndicator_default, {}) }) : /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(import_react_hook_form34.FormProvider, { ...methods, children: /* @__PURE__ */ (0, import_jsx_runtime84.jsxs)("form", { onSubmit: submit(handleSubmit), children: [
            renderPages(),
            /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
              Footer_default,
              {
                onNextClick: handleNext,
                onPreviousClick: goBack,
                nextDisabled: isSubmitting,
                showPrevious: !isFirstStep,
                submitMode: isFinalStep,
                nextLabel,
                submitting: isFinalStep && isSubmitting,
                showReturnToReview,
                onReturnToReviewClick: handleReturnToReview
              }
            )
          ] }) })
        }
      )
    }
  ) });
};
var MGPWizard_default = MGPWizard;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ADDITIONAL_INCOME_SOURCE_OPTIONS,
  AboutUsReferral,
  CAREER_CHANGE_OPTIONS,
  CONSIDER_PART_TIME_RETIREMENT_OPTIONS,
  DisabilityInsuranceWizard,
  EMPLOYMENT_TYPE,
  EMPLOYMENT_TYPE_OPTIONS,
  ESTATE_PLANNING_OPTIONS,
  GOALS_OPTIONS,
  IMPORTANT_RELATIONSHIPS_PERSON_RELATIONSHIP_OPTIONS,
  IMPORTANT_RELATIONSHIP_BASE_DEPENDENT_STATUS_OPTIONS,
  IMPORTANT_RELATIONSHIP_ORGANIZATION_TYPE_OPTIONS,
  INSURANCE_POLICIES_OPTIONS,
  INTERESTS_OPTIONS,
  JMMG_ACCESS_CODE,
  MGPWizard,
  ProfileWizard,
  Radio,
  RadioGroup,
  RiskToleranceWizard,
  SIGNUP_FORM_SCHEMA,
  SIGNUP_TERMS_HEADER,
  SignupFieldKeys,
  SignupWizard,
  TermLifeInsuranceWizard,
  UMP_ACCESS_CODE,
  WILLING_TO_RETIRE_LATER_OPTIONS,
  getPortfolioTypeFromRiskScore,
  getReviewListValue
});
